'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase', ['ngDialog', 'toastr', 'ui.bootstrap', 'ngComboDatePicker', 'darthwade.dwLoading', 'ngMessages', 'praos-multiselect']);

    angular.module('praos.briefcase').config(['$logProvider', function ($logProvider) {
        $logProvider.debugEnabled(false); 
    }]);
})();
"use strict";

(function () {
  "use strict";


  angular.module("praos.briefcase").controller("praosBriefcaseCtrl", ["$scope", "$element", "$attrs", "$q", "$parse", "briefcaseService", "$timeout", "briefcaseConstants", "professionalService", "loader", "toastr", "ngDialog", function ($scope, $element, $attrs, $q, $parse, briefcaseService, $timeout, briefcaseConstants, professionalService, loader, toastr, ngDialog) {
    var self = this;
    $scope.currentNavItem = "page1";
    $scope.activeTab = 0;
    $scope.data = {};
    $scope.tabs = [];
    self.user = {};
    var currentStep = 0;
    $scope.consentedAt = false;
    $scope.consentList = [];
    var inProcessTab = 0;

    self.init = function () {
      self.userRole = $attrs.userRole;
      currentStep = _.get(briefcaseService, "briefcaseSession.briefcase.currentStep", 0);
      $scope.viewType = $attrs.viewType;

      self.roleAccess = angular.copy(briefcaseConstants.roleAccess);

      var userRole = briefcaseService.briefcaseSession.userType;

      var isAdminOrHospitalUser = false;

      if ($attrs.userRole == "admin") {
        if (userRole == "ADMIN") {
          self.roleAccess.admin = true;
        } else if (userRole == "SUPER_ADMIN") {
          self.roleAccess.superAdmin = true;
        }
        isAdminOrHospitalUser = true;
      } else if ($attrs.userRole == "hospital") {
        if (userRole == "HOSPITAL_ADMIN") {
          self.roleAccess.hospitalAdmin = true;
        } else if (userRole == "HOSPITAL_MANAGER") {
          self.roleAccess.hospitalManager = true;
        } else if (userRole == "HOSPITAL_SUPERVISOR") {
          self.roleAccess.hospitalUser = true;
        }
        isAdminOrHospitalUser = true;
      } else if ($attrs.userRole == "nurse") {
        self.roleAccess.nurse = true;
      } else if ($attrs.userRole == "mobile") {
        self.roleAccess.mobile = true;
      } else if ($attrs.userRole == "guest") {
        self.roleAccess.guest = true;
      }

      briefcaseService.roleAccess = angular.copy(self.roleAccess);
      $scope.data.page1 = false;
      $scope.data.page2 = currentStep < 1;
      $scope.data.page3 = currentStep < 2;
      $scope.data.page4 = currentStep < 2;
      $scope.data.page5 = currentStep < 3;
      $scope.data.page6 = currentStep < 3;

      self.user = briefcaseService.briefcase.user;
      briefcaseService.userRole = self.userRole;
      briefcaseService.viewType = $scope.viewType;

      console.log("Is admin or hospital user: ", isAdminOrHospitalUser);
      briefcaseConstants.isAdminOrHospitalUser = isAdminOrHospitalUser;

      self.tabs = [{
        title: "My Profile",
        content: "Tabs will become paginated if there isn't enough room for them.",
        disabled: $scope.data.page1,
        visibility: true,
        url: "<div profile-briefcase></div>"
      }, {
        title: "Licenses & Certifications",
        content: "You can swipe left and right on a mobile device to change tabs.",
        disabled: !$scope.data.page2 ? false : isAdminOrHospitalUser ? false : $scope.data.page2,
        visibility: true,
        url: "<div license-briefcase></div>"
      }, {
        title: "Education & Work Experience",
        content: "If you set the selected tab binding to -1, it will leave no tab selected.",
        disabled: !$scope.data.page4 ? false : isAdminOrHospitalUser ? false : $scope.data.page4,
        visibility: true,
        url: "<div education-briefcase></div>"
      }, {
        title: "Tasks",
        content: "View and manage your assigned tasks and responsibilities.",
        disabled: !$scope.data.page5 ? false : isAdminOrHospitalUser ? false : $scope.data.page5,
        visibility: true,
        url: "<div task-briefcase></div>"
      }, {
        title: "Documents",
        content: "If you remove a tab, it will try to select a new one.",
        disabled: !$scope.data.page6 ? false : isAdminOrHospitalUser ? false : $scope.data.page6,
        visibility: true,
        url: "<div document-briefcase></div>"
      }, {
        title: "Other Details",
        content: "If you remove a tab, it will try to select a new one.",
        visibility: $attrs.userRole === "superAdmin" || $attrs.userRole === "admin",
        url: "<div other-briefcase></div>"
      }];
      $scope.tabs = self.tabs;

      if (briefcaseService.redirectionFlag) {
        $scope.$emit("$TabWorking", {
          flag: briefcaseService.redirectionFlag
        });
      }

      if (briefcaseService.briefcaseSession && briefcaseService.briefcaseSession.briefcase && briefcaseService.briefcaseSession.briefcase.consentedAt) {
        $scope.consentedAt = briefcaseService.briefcaseSession.briefcase.consentedAt;
      }
    };
    var consentDialogPopup;
    self.viewConsents = function () {
      $scope.consentsElementDisable = true;
      loader.show();
      professionalService.getConsent(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id).then(function (_ref) {
        var consentedAt = _ref.consentedAt,
            form = _ref.form;

        loader.hide();
        $scope.jobConsentsTimeStamp = consentedAt || "N/A";
        $scope.consentList = form;
        self.openPopup1("common_consent_template_main");
      }, function (error) {
        loader.hide();
        error = error.data;
        toastr.error(error.message);
      });
    };

    self.openPopup1 = function (id) {
      consentDialogPopup = ngDialog.open({
        template: id,
        className: "ngdialog-theme-default documentation-dialog",
        closeByNavigation: true,
        scope: $scope,
        closeByDocument: false,
        closeByEscape: false,
        consentList: $scope.consentList
      });
    };

    self.closeConsentPopUp = function () {
      ngDialog.close(consentDialogPopup);
    };

    $scope.onSubmitConsents = function (form, isConsented) {
      if (form.$invalid) {
        return toastr.error("Please fill the required details!");
      }

      var briefcase = angular.copy({
        consentedAt: isConsented ? true : undefined
      });
      var options = { item: { briefcase: briefcase } };
      loader.show();
      ngDialog.closeAll();
      professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options).then(function () {
        $scope.consentedAt = true;
        briefcaseService.consented = true;
      }).catch(function (e) {
        return toastr.error(e.message);
      }).finally(function () {
        loader.hide();
        self.setActiveTab(inProcessTab);
      });
    };

    self.updateTabIndex = function (index) {
      $scope.activeTab = index;
      $scope.selectedIndex = index;
      $scope.$emit("briefcaseTabChangeEventForNurse", {
        flag: $scope.activeTab
      });
    };

    self.setActiveTab = function (index) {
      if (briefcaseService.userRole === "nurse") {
        if (briefcaseService.consented || index > 2) {
          self.updateTabIndex(index);
        } else {
          professionalService.getConsent(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id).then(function (_ref2) {
            var consentedAt = _ref2.consentedAt;

            if (!consentedAt) {
              inProcessTab = index;
              self.viewConsents();
              $scope.activeTab = 0;
              $scope.selectedIndex = 0;
              $scope.$emit("briefcaseTabChangeEventForNurse", {
                flag: $scope.activeTab
              });
            } else {
              briefcaseService.consented = true;
              self.updateTabIndex(index);
            }
          });
        }
      } else {
        self.updateTabIndex(index);
      }
    };

    $timeout(function () {
      $scope.$emit("$viewContentLoaded");
    }, 0);

    $scope.$on("$TabWorking", function (event, _ref3) {
      var flag = _ref3.flag;

      if ($scope.tabs[flag].disabled == true) {
        $scope.tabs[flag].disabled = false;
        if (flag == 3) {
          $scope.tabs[3].disabled = false;
          $scope.tabs[4].disabled = false;
        }
      }
      $timeout(function () {
        $scope.activeTab = flag;
        $scope.selectedIndex = flag;
        $scope.$emit("briefcaseTabChangeEventForNurse", {
          flag: $scope.activeTab
        });
      }, 500);
    });
  }]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('additionalCertificationService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.AdditionalCertificationService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
    'use strict';

    var module = angular.module('praos.briefcase');

    module.service('briefcaseService', ['$q', 'briefcaseConstants', function ($q, briefcaseConstants) {
        var service = this;

        service.briefcase = {};
        service.briefcaseSession = {};
        service.professionalClient = {};
        service.UsersClient = {};

        function initObj() {
            service.briefcaseObj = {};
            service.briefcase.user = {};
            service.briefcase.license = {};
            service.briefcase.document = {};
            service.briefcase.education = {};
            service.briefcase.keys = {};
            service.briefcase.status = {};
            service.roleAccess = {};
            service.userRole = "";
            service.viewType = "edit";
            service.consented = false;
        }
        this.initObj = initObj;
    }]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('certificationService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.CertificationService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('certifyingBodyService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.CertifyingBodyService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('cityService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.CityService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('constantsService', ['briefcaseConstants', function (briefcaseConstants) {
        return new SystemClient.ConstantsService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').factory('documentSync', ['$http', '$log', 'briefcaseConstants', DocumentSync]);
    function DocumentSync($http, $log, briefcaseConstants) {
        var serviceObj = {};
        serviceObj.put = Put;

        function Put(id, data) {
            console.log("Briefcase id : ", id);
            console.log("Sync input data: ", data);
            return $http({ url: briefcaseConstants.BASE_URL2 + '/v2/nurse/sync/' + id,
                method: 'PUT',
                data: data,
                headers: {
                    "Content-Type": 'application/json',
                    'authorization': briefcaseConstants.ACCESS_TOKEN
                }
            });
        }

        return serviceObj;
    }
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('educationLevelService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.EducationLevelService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('experienceLevelService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.ExperienceLevelService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').factory('fileDownload', FileDownload);
    function FileDownload($http, FileSaver, Blob, $log) {
        var serviceObj = {};
        serviceObj.get = Get;

        function Get(fileUrl, filename) {
            $http({
                method: 'GET',
                url: fileUrl,
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers['content-type'];

                try {
                    var blob = new Blob([data], { type: contentType });
                    FileSaver.saveAs(blob, filename);
                } catch (ex) {
                    $log.error(ex);
                }
            }).error(function (data) {
                $log.error(data);
            });
        }

        return serviceObj;
    }
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('recordService', ['briefcaseConstants', function (briefcaseConstants) {
        return new RecordsClient.RecordService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('jobService', ['briefcaseConstants', function (briefcaseConstants) {
        return new JobsClient.JobService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('licenseBodyService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.LicenseBodyService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('licenseTypeService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.LicenseTypeService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('licenseUrlService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.LicenseUrlService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    var Loader = function () {
        function Loader() {
            _classCallCheck(this, Loader);

            this.spinner = document.createElement('div');
            this.spinner.classList.add('spinner');
            this.text = document.createElement('div');
            this.text.classList.add('text');
            this.overlay = document.createElement('div');
            this.overlay.appendChild(this.spinner);
            this.overlay.appendChild(this.text);
            this.overlay.classList.add('preloader');
            document.body.appendChild(this.overlay);
        }

        _createClass(Loader, [{
            key: 'show',
            value: function show() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    text = _ref.text,
                    size = _ref.size;

                this.overlay.style.setProperty('--spinner-size', size || '48px');
                this.text.innerText = text || 'Loading...';
                document.body.style.setProperty('overflow-y', 'hidden');
                this.overlay.classList.add('active-loading');
            }
        }, {
            key: 'hide',
            value: function hide() {
                document.body.style.removeProperty('overflow-y');
                this.overlay.classList.remove('active-loading');
            }
        }]);

        return Loader;
    }();

    angular.module('praos.briefcase').factory('loader', [function () {
        return new Loader();
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('organizationService', ['briefcaseConstants', function (briefcaseConstants) {
        return new OrganizationsClient.OrganizationService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('professionalService', ['briefcaseConstants', function (briefcaseConstants) {
        return new ProfessionalClient.ProfessionalService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
		angular.module('praos.briefcase').factory('specialtyService', ['briefcaseConstants', function (briefcaseConstants) {
				return new BriefcaseClient.SpecialtyService(briefcaseConstants.BASE_URL2 + '/v2');
		}]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('userService', ['briefcaseConstants', function (briefcaseConstants) {
        return new UsersClient.UserService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').factory('workflowEngineService', ['briefcaseConstants', function (briefcaseConstants) {
        return new WorkflowEngineClient.WorkflowEngineService(briefcaseConstants.BASE_URL2 + '/v2');
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').directive('briefcaseDobDatepicker', ['$window', '$templateCache', '$log', function ($window, $templateCache, $log) {

        if (!$window.moment) {
            $log.warn('moment.js is required for this datepicker, http://momentjs.com/');
            return {
                link: function link() {}
            };
        }

        var fileName = 'datepicker.directive.html';
        var template = $templateCache.get(fileName);

        if (!template) {
            template = ['<form name="datepicker">', '<div class="btn-group btn-group-justified" role="group">', '<div ng-repeat="i in localeOrder track by $index" class="btn-group" role="group">', '<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">', '<span ng-bind="date[options[i].name] || options[i].name"> </span>', '<span class="caret"></span>', '</button>', '<ul class="dropdown-menu" role="menu">', '<li ng-repeat="(j, option) in options[i].options track by $index" ng-class="{\'selectedval\': option.selected === true, \'disabled\': option.disabled === true}">', '<a ng-click="select(options[i].name, option)" ng-bind="options[i].labels[j] || option.value"></a>', '</li>', '</ul>', '</div>', '</div>', '</form>'].join('');
            $templateCache.put(fileName, template);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            templateUrl: fileName,
            scope: {
                model: '=ngModel',
                minDate: '=minDate',
                maxDate: '=maxDate',
                locale: '=?locale'
            },
            link: function link(scope, elem, attrs, ngModelCtrl) {

                var day = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
                var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                scope.localeOrder = ['month', 'day', 'year'];

                var params = {
                    day: {
                        name: 'day',
                        initLabel: 'Day',
                        options: []
                    },
                    month: {
                        name: 'month',
                        initLabel: 'Month',
                        options: []
                    },
                    year: {
                        name: 'year',
                        initLabel: 'Year',
                        options: []
                    }
                };

                var minDate;
                var maxDate;

                if (scope.minDate && scope.minDate !== 'now') {

                    var tempMinDate;

                    if (typeof scope.minDate === 'number') {
                        if (scope.minDate > 0) {
                            tempMinDate = moment().add(scope.minDate, 'year');
                        } else if (scope.minDate < 0) {
                            tempMinDate = moment().subtract(Math.abs(scope.minDate), 'year');
                        } else {
                            tempMinDate = moment();
                        }
                    } else {
                        tempMinDate = moment(scope.minDate);
                    }

                    minDate = tempMinDate;
                } else {
                    minDate = moment();
                }

                if (scope.maxDate && scope.maxDate !== 'now') {

                    var tempMaxDate;

                    if (typeof scope.maxDate === 'number') {
                        if (scope.maxDate > 0) {
                            tempMaxDate = moment().add(scope.maxDate, 'year');
                        } else if (scope.maxDate < 0) {
                            tempMaxDate = moment().subtract(Math.abs(scope.maxDate), 'year');
                        } else {
                            tempMaxDate = moment();
                        }
                    } else {
                        tempMaxDate = moment(scope.maxDate);
                    }

                    maxDate = tempMaxDate;
                } else {
                    maxDate = moment();
                }

                scope.options = angular.copy(params);

                scope.date = {};

                scope.select = function (typeString, option) {

                    if (option.disabled === undefined || option.disabled !== true) {
                        scope.date[typeString] = option.value;
                        calcAvailableDates(scope.date);
                        setupModel();
                    }
                };

                function calcAvailableDates(dateObj) {

                    var maxYear = maxDate.get('year');
                    var minYear = minDate.get('year');
                    var maxMonth = maxDate.get('month');
                    var minMonth = minDate.get('month');
                    var maxDay = maxDate.get('date');
                    var minDay = minDate.get('date');

                    if (minDate !== maxDate) {

                        scope.options.year.options = [];
                        for (var i = minYear; i <= maxYear; i++) {

                            var yearObj = {
                                value: i,
                                available: true
                            };

                            if (dateObj && dateObj.year === i) {
                                yearObj.selected = true;
                            }

                            scope.options.year.options.push(yearObj);
                        }
                    } else {}


                    if (minDate !== maxDate) {

                        scope.options.month.options = [];

                        for (var i = 0; i < month.length; i++) {

                            var monthObj = {
                                value: month[i]
                            };

                            if (dateObj && dateObj.month === month[i]) {
                                monthObj.selected = true;
                            }

                            if (dateObj && dateObj.year) {
                                if (dateObj.year === minYear) {
                                    if (minMonth > i) {
                                        monthObj.disabled = true;
                                    }
                                } else if (dateObj.year === maxYear) {
                                    if (maxMonth < i) {
                                        monthObj.disabled = true;
                                    }
                                }
                            }

                            scope.options.month.options.push(monthObj);
                        }
                    } else {}


                    if (minDate !== maxDate) {
                        scope.options.day.options = [];
                        if (dateObj && dateObj.year && dateObj.month || dateObj && dateObj.month) {

                            var useYear;
                            if (dateObj.year) {
                                useYear = dateObj.year;
                            } else {
                                useYear = moment().get('year');
                            }

                            var totaldayMonth = moment({
                                year: useYear,
                                month: month.indexOf(dateObj.month)
                            }).endOf('month').get('date');

                            for (var i = 0; i < totaldayMonth; i++) {

                                var dayObj = {};
                                dayObj.value = i + 1;

                                if (dateObj && dateObj.day && dateObj.day === i + 1) {
                                    dayObj.selected = true;
                                }


                                if (dateObj.year && dateObj.month) {
                                    if (dateObj.year === minYear && month.indexOf(dateObj.month) === minMonth) {

                                        if (minDay > i) {
                                            dayObj.disabled = true;
                                        }
                                    } else if (dateObj.year === maxYear && month.indexOf(dateObj.month) === maxMonth) {

                                        if (maxDay < i) {
                                            dayObj.disabled = true;
                                        }
                                    }
                                }

                                scope.options.day.options.push(dayObj);
                            }
                        } else {

                            scope.options.day.options = [];
                            for (var i = 0; i < day.length; i++) {

                                var dayObj = {};
                                dayObj.value = i + 1;

                                if (dateObj && dateObj.day && dateObj.day === i + 1) {
                                    dayObj.selected = true;
                                }

                                scope.options.day.options.push(dayObj);
                            }
                        }
                    }
                }

                function setupModel() {

                    if (scope.date.year !== undefined && scope.date.month !== undefined && scope.date.day !== undefined) {

                        var createDate = {
                            year: scope.date.year,
                            month: month.indexOf(scope.date.month),
                            date: scope.date.day
                        };

                        createDate = moment.utc(createDate);
                        ngModelCtrl.$setViewValue(createDate);
                    }
                }

                var toView = function toView(value) {

                    if (value !== undefined) {
                        var tempDate = moment(value);
                        calcAvailableDates({
                            year: tempDate.get('year'),
                            month: month[tempDate.get('month')],
                            day: tempDate.get('date')
                        });
                    } else {
                        calcAvailableDates();
                    }

                    if (value !== undefined) {
                        var createDate = moment(value);
                        if (createDate.isValid()) {

                            var obj = {};
                            obj.day = createDate.date();
                            obj.month = month[createDate.month()];
                            obj.year = createDate.year();

                            scope.date = obj;
                        }
                    } else {
                        scope.date = {};
                    }

                    setupModel();

                    return value;
                };

                var toModel = function toModel(value) {

                    if (value && value.isValid()) {
                        if ((value.isAfter(minDate) || minDate.isSame(value)) && (maxDate.isAfter(value) || maxDate.isSame(value))) {
                            ngModelCtrl.$setValidity('not-allowed', true);
                            return value.format();
                        } else {
                            ngModelCtrl.$setValidity('not-allowed', false);
                            return undefined;
                        }
                    } else {
                        return undefined;
                    }
                };

                ngModelCtrl.$parsers.push(toModel);
                ngModelCtrl.$formatters.push(toView);
            }
        };
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').filter('capitalize', function () {
        return function (input) {
            return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        };
    });

    angular.module('praos.briefcase').filter('validationMessage', function () {
        return function (input, ignoreSubmit) {
            var form = '$name' in input.$$parentForm.$$parentForm ? input.$$parentForm.$$parentForm : input.$$parentForm;
            return input.$dirty || form.$submitted || ignoreSubmit ? input.$error : {};
        };
    });

    angular.module('praos.briefcase').filter('imgSrc', function () {
        return function (input) {
            if (!input || typeof input !== 'string') return 'img/profile.jpg';
            var url = new URL(input);
            url.searchParams.append('v', Date.now());
            return url.toString();
        };
    });
})();
'use strict';

(function () {
	'use strict';



	angular.module('praos.briefcase').directive('pctCompleteBriefcase', function () {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				value: '='
			},
			template: ' <div class="c100 p{{value}} small blue">' + '<span>{{value}}%</span>' + '<div class="slice">' + ' <div class="bar"></div>' + '<div class="fill"></div>' + '</div>' + '</div>'
		};
	});
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').directive('briefcaseSingleSelection', ['$filter', '$document', '$compile', '$parse', function ($filter, $document, $compile, $parse) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                groupBy: '@',
                otherStatus: '=',
                otherId: '='
            },
            template: function template(element, attrs) {
                var checkboxes = !!attrs.checkboxes;
                var groups = !!attrs.groupBy;

                var template = '<div  class="multiselect-parent btn-group dropdown-multiselect check-list check-list-new check-list-skill multiselect-div">';
                template += '<button style="border: solid 1.5px #d3d3d3;" type="button" class="dropdown-toggle multiselect-btn" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}&nbsp;<span class="caret"></span></button>';
                template += '<ul style="width:100%;overflow: auto;" class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll" >';
                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a data-ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll"><a data-ng-click="deselectAll();"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
                template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';

                if (groups) {
                    template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                    template += '<li ng-repeat-end role="presentation">';
                } else {
                    template += '<li tabindex="200" role="presentation" ng-repeat="option in options | filter: searchFilter">';
                }

                template += '<a role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp))">';

                if (checkboxes) {

                    template += '<label class="checkbox-inline">';
                    template += '<input  style="display:inline-block;"';
                    template += 'type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" name="">';
                    template += '<span ng-if="!$last" class="checklist-span" >{{getPropertyForObject(option, settings.displayProp)}}</span>';
                    template += '<span ng-if="$last" class="checklist-span" >Other</span>';
                    template += '<span ng-if="$last" class="checklist-span"><div> <input ng-model="otherStatus" class="YY" ng-if="isChecked(getPropertyForObject(option,settings.idProp))" id=\"' + attrs.otherId + '\" placeholder="Other"  type="text" style="visibility:visible;margin-left:90px; display: inline-block; font-size:14px;color:#555; width:78px;" /></div></span>';
                    template += '</label></a>';

                } else {
                    }

                template += '</li>';

                template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function link($scope, $element, $attrs) {
                var $dropdownTrigger = $element.children()[0];
                $scope.toggleDropdown = function () {
                    $scope.open = !$scope.open;
                };

                $scope.checkboxClick = function ($event, id) {
                    $scope.setSelectedItem(id);
                    $event.stopImmediatePropagation();
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: true,
                    scrollableHeight: '245px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 1,
                    showCheckAll: false,
                    showUncheckAll: false,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop
                };

                $scope.texts = {
                    checkAll: 'Check All',
                    uncheckAll: 'Uncheck All',
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: 'Search...',
                    buttonDefaultText: 'Select',
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }
                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function (e) {
                        if ($scope.open) {
                            var target = e.target.parentElement;
                            var parentFound = false;

                            while (angular.isDefined(target) && target !== null && !parentFound) {
                                if (target.className.split(' ').includes('multiselect-parent') && !parentFound) {
                                    if (target === $dropdownTrigger) {
                                        parentFound = true;
                                    }
                                }
                                target = target.parentElement;
                            }

                            if (!parentFound) {
                                $scope.$apply(function () {
                                    $scope.open = false;
                                });
                                var otherIndex = _.findIndex($scope.selectedModel, getFindObj('other')) !== -1;
                                if ($scope.selectedModel && $scope.selectedModel.id === 'other') {
                                    var findObj = getFindObj('other');
                                    var finalObj = null;
                                    if ($scope.settings.externalIdProp === '') {
                                        finalObj = _.find($scope.options, findObj);
                                    } else {
                                        finalObj = findObj;
                                    }
                                    var otherInputText = $('#' + $attrs.otherId).val();
                                    finalObj.label = otherInputText ? otherInputText : 'Other';
                                    angular.extend($scope.selectedModel, finalObj);
                                }
                                $scope.$apply();
                            }
                        }
                    });
                }
                $scope.otherStatus1Skill = function (event, index, val) {
                    event.preventDefault();
                    event.stopPropagation();
                };

                $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue);
                    }

                    return groupValue;
                };

                $scope.getButtonText = function () {
                    if ($scope.selectedModel) {
                        if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0)) {
                            if ($scope.settings.smartButtonMaxItems > 0) {
                                var itemsText = [];

                                angular.forEach($scope.options, function (optionItem) {
                                    if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                        var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                        var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                        itemsText.push(converterResponse ? converterResponse : displayText);
                                    }
                                });

                                if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                    itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                    itemsText.push('...');
                                }

                                return itemsText.join(', ');
                            } else {
                                var totalSelected;

                                if ($scope.singleSelection) {
                                    totalSelected = $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) ? 1 : 0;
                                } else {
                                    totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                                }

                                if (totalSelected === 0) {
                                    return $scope.texts.buttonDefaultText;
                                } else {
                                    return $scope.selectedModel.label;
                                }
                            }
                        } else {
                            return $scope.texts.buttonDefaultText;
                        }
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };

                $scope.selectAll = function () {
                    $scope.deselectAll(false);
                    $scope.externalEvents.onSelectAll();

                    angular.forEach($scope.options, function (value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true);
                    });
                };

                $scope.deselectAll = function (sendEvent) {
                    sendEvent = sendEvent || true;

                    if (sendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    }
                };

                $scope.setSelectedItem = function (id, dontRemove) {
                    var finalObj = null;

                    if (id) {
                        var findObj = getFindObj(id);
                    }

                    if ($scope.settings.externalIdProp === '') {
                        finalObj = _.find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                        angular.extend($scope.selectedModel, finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                        if ($scope.settings.closeOnSelect) $scope.open = false;

                        return;
                    }

                    dontRemove = dontRemove || false;

                    var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

                    if (!dontRemove && exists) {
                        if (findObj.id == 'other') {
                            $scope.otherStatus = "";
                        }
                        $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
                        $scope.externalEvents.onItemDeselect(findObj);
                    } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                        $scope.selectedModel.push(finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                    }
                    if ($scope.settings.closeOnSelect) $scope.open = false;
                };

                $scope.isChecked = function (id) {
                    if (id) {
                        if ($scope.singleSelection) {
                            return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                        }

                        return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                    }
                };

                $scope.externalEvents.onInitDone();
            }
        };
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').directive('compiler', ['$compile', function ($compile) {
        return function (scope, element, attrs) {
            scope.$watch(function (scope) {
                return scope.$eval(attrs.content);
            }, function (value) {
                element.html(value);
                $compile(element.contents())(scope);
            });
        };
    }]);
})();
'use strict';

(function () {
    var toogleClass = 'invalid-input';
    var template = '\n        <span class="error-icon"></span>\n        <ng-transclude></ng-transclude>\n    ';
    var dateFormatter = function dateFormatter(format) {
        return function (value) {
            return value ? moment(value).format(format) : undefined;
        };
    };
    var urlFormatter = function urlFormatter(value) {
        return value ? value.split('/').pop() : value;
    };
    angular.module('praos.briefcase').directive('validationWrapper', [function () {
        return {
            transclude: true,
            restrict: 'E',
            template: template,
            link: function link(scope, element, attrs) {
                var data = element.find('input').data() || element.find('select').data();
                if (attrs.type === 'date') {
                    data.$ngModelController.$formatters.push(dateFormatter('MM-DD-YYYY'));
                }

                if (attrs.type === 'file') {
                    data.$ngModelController.$formatters.push(urlFormatter);
                }
                var validator = function validator(invalid) {
                    invalid ? element.addClass(toogleClass) : element.removeClass(toogleClass);
                };
                scope.$watch(function () {
                    var formSubmitted = data.$ngModelController.$$parentForm.$$parentForm.$name ? data.$ngModelController.$$parentForm.$$parentForm.$submitted : data.$ngModelController.$$parentForm.$submitted;
                    return data.$ngModelController.$invalid && (data.$ngModelController.$dirty || attrs.ignoreSubmit || formSubmitted);
                }, validator);
            }
        };
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').directive('praosBriefcase', praosBriefcase);

    praosBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseService'];
    function praosBriefcase($window, briefcaseUtil, briefcaseService) {
        return {
            templateUrl: 'praos-briefcase.html',
            scope: {
                userRole: '=',
                viewType: '=',
                deviceType: '='
            },
            transclude: true,
            controller: 'praosBriefcaseCtrl as praosBriefcaseCtrl',
            compile: function compile() {
                return {
                    pre: function pre($scope, $elm, $attrs, briefcaseCtrl) {
                        briefcaseCtrl.userRole = $attrs.userRole;
                        briefcaseCtrl.viewType = $attrs.viewType;
                        briefcaseCtrl.deviceType = $attrs.deviceType;
                        briefcaseService.initObj();
                        briefcaseCtrl.init();

                        $scope.$on('$viewContentLoaded', function () {
                            var windowH = $(window).width();
                            var wrapperH = $('#nav-bar-content-briefcase md-tabs-wrapper').width();
                            if ($attrs.userRole == 'nurse') {
                                var startwidth = windowH - 340;
                                var scrollTopH = 230;
                                $('md-tabs-wrapper').addClass('nurseSticky');
                            } else if ($attrs.userRole == 'admin' || $attrs.userRole == 'superAdmin') {
                                var startwidth = windowH - 240;
                                var scrollTopH = 82;
                                $('md-tabs-wrapper').addClass('adminSticky');
                            } else if ($attrs.userRole == 'guest' || $attrs.deviceType == 'mobile') {
                                var startwidth = windowH;
                                var scrollTopH = 1;
                                $('md-tabs-wrapper').addClass('');
                            } else {
                                var startwidth = windowH - 290;
                                var scrollTopH = 40;
                                $('md-tabs-wrapper').addClass('hospitalSticky');
                            }
                            if (windowH > wrapperH) {
                                $('#nav-bar-content-briefcase md-tabs-wrapper').css('width', startwidth + 'px');
                            }

                            $(window).scroll(function () {
                                if ($(window).innerWidth() <= 991) {
                                    if ($(this).scrollTop() > 1) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').addClass("sticky");
                                    }
                                    if ($(this).scrollTop() < scrollTopH) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').removeClass("sticky");
                                    }
                                } else {
                                    if ($(this).scrollTop() > 400) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').addClass("sticky");
                                    }
                                    if ($(this).scrollTop() < scrollTopH) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').removeClass("sticky");
                                    }
                                    if ($(this).scrollTop() > 1) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').addClass("sticky");
                                    }
                                    if ($(this).scrollTop() < scrollTopH) {
                                        $('#nav-bar-content-briefcase md-tabs-wrapper').removeClass("sticky");
                                    }
                                }
                            });

                            $(window).resize(function () {
                                var windowH = $(window).width();
                                var wrapperH = $('#nav-bar-content-briefcase md-tabs-wrapper').width();
                                var differenceH = windowH - wrapperH;
                                var newH = wrapperH + differenceH;
                                var truecontentH = $('#truecontent').width();
                                if (windowH > truecontentH) {
                                    $('#nav-bar-content-briefcase md-tabs-wrapper').css('width', newH + 'px');
                                }
                                if ($attrs.userRole == 'nurse') {
                                    var fwidth = windowH - 340;
                                    $('md-tabs-wrapper').addClass('nurseSticky');
                                } else if ($attrs.userRole == 'admin' || $attrs.userRole == 'superAdmin') {
                                    var fwidth = windowH - 240;
                                    $('md-tabs-wrapper').addClass('adminSticky');
                                } else if ($attrs.userRole == 'guest' || $attrs.deviceType == 'mobile') {
                                    var fwidth = windowH;
                                    $('md-tabs-wrapper').addClass('');
                                } else {
                                    var fwidth = windowH - 290;
                                    $('md-tabs-wrapper').addClass('hospitalSticky');
                                }
                                if (document.getElementById("wrapper1")) {
                                    document.getElementById("wrapper1").innerHTML = fwidth;
                                }
                                $('#nav-bar-content-briefcase md-tabs-wrapper').css('width', fwidth + 'px');
                            });
                        });
                    },
                    post: function post($scope, $elm, $attrs, briefcaseCtrl) {
                        briefcaseCtrl.userRole = $attrs.userRole;
                    }
                };
            }
        };
    }
})();
'use strict';

(function () {
    var isValidExtension = function isValidExtension(files, accept) {
        if (accept) {
            var acceptableExtensions = accept.split(',');
            return Array.from(files).every(function (_ref) {
                var name = _ref.name;
                return acceptableExtensions.includes('.' + name.split('.').pop().toLowerCase());
            });
        }
        return true;
    };
    angular.module('praos.briefcase').directive('upload', ['toastr', function (toastr) {
        return {
            restrict: 'A',
            scope: {
                ngModel: '=',
                ngChange: '&',
                type: '@'
            },
            link: function link(scope, element) {
                if (scope.type && scope.type.toLowerCase() === 'file') {
                    element.bind('change', function () {
                        var files = element[0].files;
                        if (isValidExtension(files, element.attr('accept'))) {
                            scope.ngModel = files;
                            scope.$apply();
                            scope.ngChange();
                        } else {
                            toastr.error('Please upload a valid document');
                        }
                    });
                }
            }
        };
    }]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').directive('praosInputSelect', inputSelect);
    function controller() {
        var _this = this;

        this.onFocus = function () {
            return _this.visible = true;
        };
        this.onBlur = function () {
            return setTimeout(function () {
                return _this.visible = false;
            });
        };
        this.onSelect = function (item) {
            return _this.ngModelCtrl.$setViewValue(item);
        };
        this.onKeyUp = function (item) {
            return _this.ngModelCtrl.$setViewValue(item.target.value);
        };
        this.onEnter = function (evt) {
            evt.preventDefault();
            _this.visible = !_this.visible;
        };
        this.onArrowDown = function (evt) {
            evt.preventDefault();
            var ind = _this.options.indexOf(_this.ngModelCtrl.$viewValue);
            var item = ind >= 0 ? _this.options[ind + 1] : _this.options[0];
            item && _this.onSelect(item);
        };

        this.onArrowTop = function (evt) {
            evt.preventDefault();
            var ind = _this.options.indexOf(_this.ngModelCtrl.$viewValue);
            var item = ind >= 0 ? _this.options[ind - 1] : _this.options[_this.options.length - 1];
            item && _this.onSelect(item);
        };
        this.onKeyDown = function (evt) {
            switch (evt.keyCode) {
                case 13:
                    _this.onEnter(evt);
                    break;
                case 40:
                    _this.onArrowDown(evt);
                    break;
                case 38:
                    _this.onArrowTop(evt);
            }
        };
    }

    function inputSelect() {
        return {
            templateUrl: 'praos-input-select.html',
            require: { ngModelCtrl: 'ngModel' },
            bindToController: true,
            controllerAs: '$ctrl',
            scope: {
                options: '<',
                ngModel: '<'
            },
            controller: controller
        };
    }
})();
'use strict';

(function (modules) {
var installedModules = {};

function __webpack_require__(moduleId) {

if (installedModules[moduleId])
return installedModules[moduleId].exports;

var module = installedModules[moduleId] = {
exports: {},
id: moduleId,
loaded: false
 };

modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

module.loaded = true;

return module.exports;
	}

__webpack_require__.m = modules;

__webpack_require__.c = installedModules;

__webpack_require__.p = "";

return __webpack_require__(0);
})(
[
function (module, exports, __webpack_require__) {

	'use strict';

	var _angularjsDropdownMultiselect = __webpack_require__(1);

	var _angularjsDropdownMultiselect2 = _interopRequireDefault(_angularjsDropdownMultiselect);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}

	angular.module('praos-multiselect', []).directive('dmDropdownStaticInclude', ["$compile", function ($compile) {
		'ngInject';

		return function directive(scope, element, attrs) {
			var template = attrs.dmDropdownStaticInclude;
			var contents = element.html(template).contents();
			$compile(contents)(scope);
		};
	}]).directive('praosMultiselect', _angularjsDropdownMultiselect2.default);

},
function (module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = dropdownMultiselectDirective;

	var _angularjsDropdownMultiselect = __webpack_require__(2);

	var _angularjsDropdownMultiselect2 = _interopRequireDefault(_angularjsDropdownMultiselect);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}

	function dropdownMultiselectDirective() {
		return {
			restrict: 'AE',
			scope: {
				selectedModel: '=',
				options: '=',
				extraSettings: '=',
				events: '=',
				searchFilter: '=?',
				translationTexts: '=',
				disabled: '='
			},
			controller: _angularjsDropdownMultiselect2.default,
			templateUrl: 'app/component/praos-multiselect.html'
		};
	}

},
function (module, exports) {

	'use strict';

	dropdownMultiselectController.$inject = ["$scope", "$element", "$filter", "$document", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = dropdownMultiselectController;

	function contains(collection, target) {
		var containsTarget = false;
		collection.some(function (object) {
			if (object === target) {
				containsTarget = true;
				return true;
			}
			return false;
		});
		return containsTarget;
	}

	function getIndexByProperty(collection, objectToFind, property) {
		var index = -1;
		collection.some(function (option, ind) {
			if (option[property] === objectToFind[property]) {
				index = ind;
				return true;
			}
			return false;
		});
		return index;
	}

	function dropdownMultiselectController($scope, $element, $filter, $document, $timeout) {
		'ngInject';

		$scope.showAlert = false;
		var $dropdownTrigger = $element.children()[0];
		var externalEvents = {
			onItemSelect: angular.noop,
			onItemDeselect: angular.noop,
			onSelectAll: angular.noop,
			onDeselectAll: angular.noop,
			onInitDone: angular.noop,
			onMaxSelectionReached: angular.noop,
			onSelectionChanged: angular.noop,
			onClose: angular.noop
		};

		var settings = {
			dynamicTitle: true,
			scrollable: true,
			scrollableHeight: '250px',
			closeOnBlur: true,
			displayProp: '',
			enableSearch: true,
			clearSearchOnClose: true,
			selectionLimit: 3,
			showCheckAll: false,
			showUncheckAll: false,
			showEnableSearchButton: false,
			closeOnSelect: false,
			buttonClasses: 'btn btn-default',
			closeOnDeselect: false,
			groupBy: undefined,
			checkBoxes: true,
			groupByTextProvider: null,
			smartButtonMaxItems: 3,
			smartButtonTextConverter: angular.noop,
			styleActive: false,
			selectedToTop: false,
			keyboardControls: false,
			template: '{{getPropertyForObject(option, settings.displayProp)}}',
			searchField: '$',
			showAllSelectedText: false,
			defaultSelectionText: "Selected"
		};

		var texts = {
			checkAll: 'Check All',
			uncheckAll: 'Uncheck All',
			selectionCount: 'checked',
			selectionOf: '/',
			searchPlaceholder: 'Search...',
			buttonDefaultText: 'Select',
			dynamicButtonTextSuffix: 'checked',
			disableSearch: 'Disable search',
			enableSearch: 'Enable search',
			selectGroup: 'Select all:',
			allSelectedText: 'All',
			maxLimitText: 'Max Selection Limit Reached'
		};

		var input = {
			searchFilter: $scope.searchFilter || ''
		};

		angular.extend(settings, $scope.extraSettings || []);
		angular.extend(externalEvents, $scope.events || []);
		angular.extend(texts, $scope.translationTexts);

		if (settings.closeOnBlur) {
			$document.on('click', function (e) {
				if ($scope.open) {
					var target = e.target.parentElement;
					var parentFound = false;

					while (angular.isDefined(target) && target !== null && !parentFound) {
						if (!!target.className.split && contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
							if (target === $dropdownTrigger) {
								parentFound = true;
							}
						}
						target = target.parentElement;
					}

					if (!parentFound) {
						$scope.$apply(function () {
							$scope.close();
						});
					}
				}
			});
		}

		angular.extend($scope, {
			toggleDropdown: toggleDropdown,
			checkboxClick: checkboxClick,
			ShowAlertBox: ShowAlertBox,
			externalEvents: externalEvents,
			settings: settings,
			texts: texts,
			input: input,
			close: close,
			selectCurrentGroup: selectCurrentGroup,
			getGroupLabel: getGroupLabel,
			getButtonText: getButtonText,
			getPropertyForObject: getPropertyForObject,
			selectAll: selectAll,
			deselectAll: deselectAll,
			setSelectedItem: setSelectedItem,
			isChecked: isChecked,
			keyDownLink: keyDownLink,
			keyDownSearchDefault: keyDownSearchDefault,
			keyDownSearch: keyDownSearch,
			getFilter: getFilter,
			toggleSearch: toggleSearch,
			keyDownToggleSearch: keyDownToggleSearch,
			orderFunction: orderFunction
		});

		$scope.externalEvents.onInitDone();

		function focusFirstOption() {
			setTimeout(function () {
				var elementToFocus = angular.element($element)[0].querySelector('.option');
				if (angular.isDefined(elementToFocus) && elementToFocus != null) {
					elementToFocus.focus();
				}
			}, 0);
		}

		function toggleDropdown() {
			if ($scope.open) {
				$scope.close();
			} else {
				$scope.open = true;
			}
			if ($scope.settings.keyboardControls) {
				if ($scope.open) {
					if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
						setTimeout(function () {
							angular.element($element)[0].querySelector('.searchField').focus();
						}, 0);
					} else {
						focusFirstOption();
					}
				}
			}
			if ($scope.settings.enableSearch) {
				if ($scope.open) {
					setTimeout(function () {
						angular.element($element)[0].querySelector('.searchField').focus();
					}, 0);
				}
			}
		}

		function checkboxClick($event, option) {
			if ($scope.selectedModel && $scope.selectedModel.length === 10) {

				$event.target.checked = false;
			}
			$scope.setSelectedItem(option, false, true);
			$event.stopImmediatePropagation();
		}

		function ShowAlertBox() {
			$scope.showAlert = true;
			$timeout(function () {
				$scope.showAlert = false;
			}, 1000);
		}

		function close() {
			$scope.open = false;
			$scope.input.searchFilter = $scope.settings.clearSearchOnClose ? '' : $scope.input.searchFilter;
			$scope.externalEvents.onClose();
		}

		function selectCurrentGroup(currentGroup) {
			$scope.selectedModel.splice(0, $scope.selectedModel.length);
			$scope.options.forEach(function (item) {
				if (item[$scope.settings.groupBy] === currentGroup) {
					$scope.setSelectedItem(item, false, false);
				}
			});
			$scope.externalEvents.onSelectionChanged();
		}

		function getGroupLabel(groupValue) {
			if ($scope.settings.groupByTextProvider !== null) {
				return $scope.settings.groupByTextProvider(groupValue);
			}

			return groupValue;
		}

		function textWidth(text) {
			var $btn = $element.find('button');
			var canvas = document.createElement('canvas');
			var ctx = canvas.getContext('2d');
			ctx.font = $btn.css('font-size') + $btn.css('font-family');
			ctx.originalFont = $btn.css('font-size') + $btn.css('font-family');
			ctx.fillStyle = '#000000';
			return ctx.measureText(text).width;
		}

		function getButtonText() {
			if ($scope.settings.dynamicTitle && $scope.selectedModel && $scope.selectedModel.length > 0) {
				if (angular.isFunction($scope.settings.smartButtonTextProvider)) {
					return $scope.settings.smartButtonTextProvider($scope.selectedModel);
				}

				if ($scope.settings.smartButtonMaxItems > 0) {
					var paddingWidth = 12 * 2;
					var borderWidth = 1 * 2;
					var dropdownIconWidth = 8;
					var widthLimit = $element[0].offsetWidth - paddingWidth - borderWidth - dropdownIconWidth;

					var itemsText = [];

					angular.forEach($scope.options, function (optionItem) {
						if ($scope.isChecked(optionItem)) {
							var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
							var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

							itemsText.push(converterResponse || displayText);
						}
					});

					if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
						itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
						itemsText.push('...');
					}

					var result = itemsText.join(', ');
					var index = result.length - 4;
					if ($element[0].offsetWidth === 0) {
						return result;
					}
					if (widthLimit <= textWidth('...')) {
						return '...';
					}
					while (textWidth(result) > widthLimit) {
						if (itemsText[itemsText.length - 1] !== '...') {
							itemsText.push('...');
							result = result + '...';
							index = result.length - 4;
						}
						result = result.slice(0, index) + result.slice(index + 1);
						index -= 1;
					}

					if ($scope.selectedModel.length > 3) {
						return $scope.selectedModel.length + " " + $scope.settings.defaultSelectionText;
					}
					return result;
				}
				var totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;

				if (totalSelected === 0) {
					return $scope.texts.buttonDefaultText;
				}

				if ($scope.settings.showAllSelectedText && totalSelected === $scope.options.length) {
					return $scope.texts.allSelectedText;
				}

				return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
			}
			return $scope.texts.buttonDefaultText;
		}

		function getPropertyForObject(object, property) {
			if (angular.isDefined(object)) {
				if (!property) {
					return object;
				}
				if (Object.prototype.hasOwnProperty.call(object, property)) {
					return object[property];
				}
			}
			return undefined;
		}

		function selectAll() {
			$scope.deselectAll(true);
			$scope.externalEvents.onSelectAll();

			var searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
			angular.forEach(searchResult, function (value) {
				$scope.setSelectedItem(value, true, false);
			});
			$scope.externalEvents.onSelectionChanged();
			$scope.selectedGroup = null;
		}

		function deselectAll() {
			var dontSendEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (!dontSendEvent) {
				$scope.externalEvents.onDeselectAll();
			}

			$scope.selectedModel.splice(0, $scope.selectedModel.length);
			if (!dontSendEvent) {
				$scope.externalEvents.onSelectionChanged();
			}
			$scope.selectedGroup = null;
		}

		function setSelectedItem(option) {
			var dontRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
			var fireSelectionChange = arguments[2];

			var exists = void 0;
			var indexOfOption = void 0;
			if (!$scope.selectedModel.includes(option)) {
				if (option === 'None' || option !== 'None' && $scope.selectedModel.indexOf('None') !== -1) {
					$scope.deselectAll();
				}
			}

			if (!$scope.selectedModel.includes(option)) {
				if ($scope.settings.selectionLimit !== 0 && $scope.selectedModel.length === $scope.settings.selectionLimit) {
					$scope.ShowAlertBox();
				}
			}

			if (angular.isDefined(settings.idProperty)) {
				exists = getIndexByProperty($scope.selectedModel, option, settings.idProperty) !== -1;
				indexOfOption = getIndexByProperty($scope.selectedModel, option, settings.idProperty);
			} else {
				exists = $scope.selectedModel.indexOf(option) !== -1;
				indexOfOption = $scope.selectedModel.indexOf(option);
			}

			if (!dontRemove && exists) {
				$scope.selectedModel.splice(indexOfOption, 1);
				$scope.externalEvents.onItemDeselect(option);
				if ($scope.settings.closeOnDeselect) {
					$scope.close();
				}
			} else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
				$scope.selectedModel.push(option);
				if (fireSelectionChange) {
					$scope.externalEvents.onItemSelect(option);
				}
				if ($scope.settings.closeOnSelect) {
					$scope.close();
				}
				if ($scope.settings.selectionLimit > 0 && $scope.selectedModel.length === $scope.settings.selectionLimit) {
					$scope.externalEvents.onMaxSelectionReached();
				}
			} else if ($scope.settings.selectionLimit === 1 && !exists && $scope.selectedModel.length === $scope.settings.selectionLimit) {
				$scope.selectedModel.splice(0, 1);
				$scope.selectedModel.push(option);
				if (fireSelectionChange) {
					$scope.externalEvents.onItemSelect(option);
				}
				if ($scope.settings.closeOnSelect) {
					$scope.close();
				}
			}
			if (fireSelectionChange) {
				$scope.externalEvents.onSelectionChanged();
			}
			$scope.selectedGroup = null;
		}

		function isChecked(option) {
			if (angular.isDefined(settings.idProperty)) {
				return getIndexByProperty($scope.selectedModel, option, settings.idProperty) !== -1;
			}
			return $scope.selectedModel.indexOf(option) !== -1;
		}

		function keyDownLink(event) {
			var sourceScope = angular.element(event.target).scope();
			var nextOption = void 0;
			var parent = event.target.parentNode;
			if (!$scope.settings.keyboardControls) {
				return;
			}
			if (event.keyCode === 13 || event.keyCode === 32) {
				event.preventDefault();
				if (sourceScope.option) {
					$scope.setSelectedItem(sourceScope.option, false, true);
				} else if (event.target.id === 'deselectAll') {
					$scope.deselectAll();
				} else if (event.target.id === 'selectAll') {
					$scope.selectAll();
				}
			} else if (event.keyCode === 38) {
				event.preventDefault();
				if (parent.previousElementSibling) {
					nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
				}
				while (!nextOption && !!parent) {
					parent = parent.previousElementSibling;
					if (parent) {
						nextOption = parent.querySelector('a') || parent.querySelector('input');
					}
				}
				if (nextOption) {
					nextOption.focus();
				}
			} else if (event.keyCode === 40) {
				event.preventDefault();
				if (parent.nextElementSibling) {
					nextOption = parent.nextElementSibling.querySelector('a') || parent.nextElementSibling.querySelector('input');
				}
				while (!nextOption && !!parent) {
					parent = parent.nextElementSibling;
					if (parent) {
						nextOption = parent.querySelector('a') || parent.querySelector('input');
					}
				}
				if (nextOption) {
					nextOption.focus();
				}
			} else if (event.keyCode === 27) {
				event.preventDefault();

				$scope.toggleDropdown();
			}
		}

		function keyDownSearchDefault(event) {
			var parent = event.target.parentNode.parentNode;
			var nextOption = void 0;
			if (!$scope.settings.keyboardControls) {
				return;
			}
			if (event.keyCode === 9 || event.keyCode === 40) {
				event.preventDefault();
				focusFirstOption();
			} else if (event.keyCode === 38) {
				event.preventDefault();
				if (parent.previousElementSibling) {
					nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
				}
				while (!nextOption && !!parent) {
					parent = parent.previousElementSibling;
					if (parent) {
						nextOption = parent.querySelector('a') || parent.querySelector('input');
					}
				}
				if (nextOption) {
					nextOption.focus();
				}
			} else if (event.keyCode === 27) {
				event.preventDefault();

				$scope.toggleDropdown();
			}
		}

		function keyDownSearch(event, searchFilter) {
			var searchResult = void 0;
			if (!$scope.settings.keyboardControls) {
				return;
			}
			if (event.keyCode === 13) {
				if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
					searchResult = $filter('filter')($scope.options, $scope.getFilter(searchFilter));
					if (searchResult.length === 1) {
						$scope.setSelectedItem(searchResult[0], false, true);
					}
				} else if ($scope.settings.enableSearch) {
					$scope.selectAll();
				}
			}
		}

		function getFilter(searchFilter) {
			var filter = {};
			filter[$scope.settings.searchField] = searchFilter;
			return filter;
		}

		function toggleSearch($event) {
			if ($event) {
				$event.stopPropagation();
			}
			$scope.settings.enableSearch = !$scope.settings.enableSearch;
			if (!$scope.settings.enableSearch) {
				$scope.input.searchFilter = '';
			}
		}

		function keyDownToggleSearch() {
			if (!$scope.settings.keyboardControls) {
				return;
			}
			if (event.keyCode === 13) {
				$scope.toggleSearch();
				if ($scope.settings.enableSearch) {
					setTimeout(function () {
						angular.element($element)[0].querySelector('.searchField').focus();
					}, 0);
				} else {
					focusFirstOption();
				}
			}
		}

		function orderFunction(object1, object2) {
			if (angular.isUndefined(object2)) {
				return -1;
			}
			if (angular.isUndefined(object1)) {
				return 1;
			}
			if (object1.type !== 'object' || object2.type !== 'object') {
				return object1.index < object2.index ? -1 : 1;
			}
			var v1 = object1.value;
			var v2 = object2.value;
			if ($scope.settings.groupBy) {
				if (v1[$scope.settings.groupBy] !== v2[$scope.settings.groupBy]) {
					if (v1[$scope.settings.groupBy] < v2[$scope.settings.groupBy]) {
						return 1;
					}
					return -1;
				}
			}
			if (!$scope.settings.selectedToTop) {
				return $scope.options.indexOf(v1) < $scope.options.indexOf(v2) ? -1 : 1;
			}
			if (!$scope.isChecked(v1) && !$scope.isChecked(v2) || $scope.isChecked(v1) && $scope.isChecked(v2)) {
				return $scope.options.indexOf(v1) < $scope.options.indexOf(v2) ? -1 : 1;
			}
			if ($scope.isChecked(v1)) {
				return -1;
			}
			return 1;
		}
	}

}
]);
angular.module("praos-multiselect").run(["$templateCache", function ($templateCache) {
	$templateCache.put('app/component/praos-multiselect.html', '<div class="multiselect-parent btn-group dropdown-multiselect" ng-class="{open: open}">' + '<div ng-click=toggleDropdown()>' + '<button ng-disabled=disabled type=button class=dropdown-toggle ng-class=settings.buttonClasses>{{getButtonText()}}&nbsp;<span class=caret></span></button>' + '</div>' + '<ul class="dropdown-menu dropdown-menu-form custom-check-mark" ng-if=open ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\', overflow: \'auto\' }">' + '<li ng-if="settings.showCheckAll && settings.selectionLimit === 0">' + '<a ng-keydown=keyDownLink($event) data-ng-click=selectAll() tabindex=-1 id=selectAll>' + '<span class="glyphicon glyphicon-ok"></span> {{texts.checkAll}}</a>' + '</li>' + '<li ng-if=settings.showUncheckAll>' + '<a ng-keydown=keyDownLink($event) data-ng-click=deselectAll(); tabindex=-1 id=deselectAll>' + '<span class="glyphicon glyphicon-remove"></span> {{texts.uncheckAll}}</a>' + '</li>' + '<li ng-if="settings.selectByGroups && ((settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll)" class=divider></li>' + '<li ng-repeat="currentGroup in settings.selectByGroups track by $index" ng-click=selectCurrentGroup(currentGroup)>' + '<a ng-class="{\'dropdown-selected-group\': selectedGroup === currentGroup}" tabindex=-1>{{::texts.selectGroup}} {{::getGroupLabel(currentGroup)}}</a>' + '</li>' + '<li ng-if="settings.selectByGroups && settings.showEnableSearchButton" class=divider></li>' + '<li ng-if="settings.showEnableSearchButton && settings.enableSearch">' + '<a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click=toggleSearch($event); tabindex=-1>{{texts.disableSearch}}</a>' + '</li>' + '<li ng-if="settings.showEnableSearchButton && !settings.enableSearch">' + '<a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click=toggleSearch($event); tabindex=-1>{{texts.enableSearch}}</a>' + '</li>' + '<li ng-if="(settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll || settings.showEnableSearchButton" class=divider>' + '</li>' + '<li ng-if=settings.enableSearch>' + '<div class=dropdown-header>' + '<input type=text class="form-control searchField" ng-keydown="keyDownSearchDefault($event); keyDownSearch($event, input.searchFilter);" ng-style="{width: \'100%\'}" ng-model=input.searchFilter placeholder={{texts.searchPlaceholder}}>' + '</div>' + '</li>' + '<li ng-if=settings.enableSearch class=divider></li>' + '<li ng-if=settings.groupBy ng-repeat-start="option in orderedItems = ( options | filter:getFilter(input.searchFilter) | orderBy:\'\':false:orderFunction)" ' + 'ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" ' + 'role=presentation class=dropdown-header>{{ getGroupLabel(getPropertyForObject(option, settings.groupBy)) }}</li>' + '<li ng-if=settings.groupBy ng-class="{\'active\': isChecked(option) && settings.styleActive}" ' + 'ng-repeat-end role=presentation><a ng-keydown="option.disabled || keyDownLink($event)" ' + 'role=menuitem class=option tabindex=-1 ng-click="option.disabled || setSelectedItem(option, false, true)" ng-disabled=option.disabled>' + '<div ng-if=settings.checkBoxes class=checkbox><label>' + '<input class=checkboxInput type=checkbox ng-click="checkboxClick($event, option)" ng-checked=isChecked(option)> ' + '<span dm-dropdown-static-include={{settings.template}}></span></label>' + '</div>' + '<span ng-if=!settings.checkBoxes data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(option)}"></span>' + '<span dm-dropdown-static-include={{settings.template}}></span></a></li>' + '<li ng-if=!settings.groupBy ng-class="{\'active\': isChecked(option) && settings.styleActive}" ' + 'role=presentation ng-repeat="option in options | filter:getFilter(input.searchFilter)">' + '<a ng-keydown="option.disabled || keyDownLink($event)" role=menuitem class=option tabindex=-1 ' + 'ng-click="option.disabled || setSelectedItem(option, false, true)" ' + 'ng-disabled=option.disabled><div ng-if=settings.checkBoxes class=checkbox>' + '<label><input class=checkboxInput type=checkbox ng-click="checkboxClick($event, option)" ng-checked=isChecked(option)>' + ' <span dm-dropdown-static-include={{settings.template}}></span></label></div>' + '<span ng-if=!settings.checkBoxes data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(option)}"></span>' + ' <span ng-if=!settings.checkBoxes dm-dropdown-static-include={{settings.template}}></span></a>' + '<span class="divider" ng-if="option == \'None\'" style="height: 1px;margin: 9px 0;overflow: hidden;background-color: #e5e5e5;"/></li>' + '</ul><div ng-show="showAlert" class="fade-out notify">{{texts.maxLimitText}}</div></div>');
}]);
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('dropDownConstant', {

        lANGUAGE_CHOICES: [{
            "id": 'c9',
            "value": "1",
            "label": "English"
        }, {
            "id": 'c10',
            "value": "2",
            "label": "Spanish"
        }, {
            "id": 'c11',
            "value": "3",
            "label": "Other",
            "otherLanguage": ""
        }],
        SELECT_DISTANCE: [{ label: '10', value: 10 }, { label: '15', value: 15 }, { label: '20', value: 20 }, { label: '25', value: 25 }, { label: '50', value: 50 }, { label: '75', value: 75 }, { label: '100', value: 100 }, { label: '200', value: 200 }, { label: '300', value: 300 }, { label: '400', value: 400 }],

        LICENSE_BODY: ['Alabama State Board of Nursing', 'Alaska State Board of Nursing', 'Arizona State Board of Nursing', 'Arkansas State Board of Nursing', 'California State Board of Registered Nursing', 'Colorado State Board of Nursing', 'Connecticut State Board of Examiners for Nursing', 'Delaware State Board of Nursing', 'District of Columbia State Board of Nursing', 'Florida State Board of Nursing', 'Georgia State Board of Nursing', 'Hawaii State Board of Nursing', 'Idaho State Board of Nursing', 'Illinois Department of Professional Regulation', 'Indiana State Board of Nursing', 'Iowa State Board of Nursing', 'Kansas State Board of Nursing', 'Kentucky State Board of Nursing', 'Louisiana State Board of Nursing', 'Maine State Board of Nursing', 'Maryland State Board of Nursing', 'Massachusetts State Board of Nursing', 'Michigan Board of Nursing', 'Minnesota State Board of Nursing', 'Mississippi State Board of Nursing', 'Missouri State Board of Nursing', 'Montana State Board of Nursing', 'Nebraska Health and Human Services System', 'Nevada State Board of Nursing', 'New Hampshire State Board of Nursing', 'New Jersey State Board of Nursing', 'New Mexico State Board of Nursing', 'New York State Board of Nursing', 'North Carolina State Board of Nursing', 'North Dakota State Board of Nursing', 'Ohio State Board of Nursing', 'Oklahoma State Board of Nursing', 'Oregon State Board of Nursing', 'Pennsylvania State Board of Nursing', 'Rhode Island State Board of Nursing', 'South Carolina State Board of Nursing', 'South Dakota State Board of Nursing', 'Tennessee State Board of Nursing', 'Texas Board of Nurse Examiners', 'Utah State Board of Nursing', 'Vermont State Board of Nursing', 'Virginia State Board of Nursing', 'Washington State Nursing Care Quality Assurance Commission', 'West Virginia Board of Examiners for Registered Professional Nurses', 'Wisconsin Department of Regulation and Licensing', 'Wyoming State Board of Nursing'],

        CERTIFYING_BODY: [{
            "id": 0,
            "label": "None",
            "value": 0
        }, {
            "id": 1,
            "label": "Addictions Nursing Certification Board",
            "value": "ANCB"
        }, {
            "id": 2,
            "label": "American Academy of Nurse Practitioners Certification Program",
            "value": "AANPCP"
        }, {
            "id": 3,
            "label": "American Association of Critical Care Nurses Certification Corporation",
            "value": "AACCNCC"
        }, {
            "id": 4,
            "label": "American Association of Heart Failure Nurses",
            "value": "AAHFN"
        }, {
            "id": 5,
            "label": "American Board of Managed Care Nursing ",
            "value": "ABMCN"
        }, {
            "id": 6,
            "label": "American Board of Neuroscience Nursing",
            "value": "ABNN"
        }, {
            "id": 7,
            "label": "American Board of Certification for Gastroenterology Nurses, Inc.",
            "value": "ABCGN"
        }, {
            "id": 8,
            "label": "American Board for Occupational Health Nurses",
            "value": "ABOHN"
        }, {
            "id": 9,
            "label": "American Board of Perianesthesia Nursing, Inc.",
            "value": "ABPN"
        }, {
            "id": 10,
            "label": "American Hospital Association",
            "value": "AHA"
        }, {
            "id": 11,
            "label": "American Holistic Nurses Credentialing Corporation",
            "value": "AHNCC"
        }, {
            "id": 12,
            "label": "American Legal Nurse Consultant Certification Board",
            "value": "ALNCC"
        }, {
            "id": 13,
            "label": "American Nurses Credentialing Center",
            "value": "ANCC"
        }, {
            "id": 14,
            "label": "American Organization of Nurse Executives",
            "value": "AONE"
        }, {
            "id": 15,
            "label": "Association of Clinical Research Professionals",
            "value": "ACRP"
        }, {
            "id": 16,
            "label": "Board of Certification for Emergency Nursing",
            "value": "BCEN"
        }, {
            "id": 17,
            "label": "Certification Board of Infection Control and Epidemiology, Inc.",
            "value": "CBICE"
        }, {
            "id": 18,
            "label": "Certification Board for Urologic Nurses and Associates",
            "value": "CBUNA"
        }, {
            "id": 19,
            "label": "Commission on Nurse Certification",
            "value": "CNC"
        }, {
            "id": 20,
            "label": "Competency & Credentialing Institute (Formerly CBPN - Certification Board Perioperative Nursing)",
            "value": "CCI"
        }, {
            "id": 21,
            "label": "Dermatology Nursing Certification Board",
            "value": "DNCB"
        }, {
            "id": 22,
            "label": "HIV/AIDS Nursing Certification Board ",
            "value": "HANCB"
        }, {
            "id": 23,
            "label": "Infusion Nurses Certification Corporation",
            "value": "INCC"
        }, {
            "id": 24,
            "label": "International Association of Forensic Nurses",
            "value": "IAFN"
        }, {
            "id": 25,
            "label": "Medical-Surgical Nursing Certification Board",
            "value": "MSNCB"
        }, {
            "id": 26,
            "label": "National Asthma Education Certification Board",
            "value": "NAECB"
        }, {
            "id": 27,
            "label": "National Association for Healthcare Quality",
            "value": "NAHQ"
        }, {
            "id": 28,
            "label": "National Board for Certification of Hospice and Palliative Nurses",
            "value": "NBCHPN"
        }, {
            "id": 29,
            "label": "National Board of Certification and Recertification for Nurse Anesthetists",
            "value": "NBCRNA"
        }, {
            "id": 30,
            "label": "National Board for Certification of School Nurses",
            "value": "NBCSN"
        }, {
            "id": 31,
            "label": "National Certification Board for Diabetes Educators",
            "value": "NCBDE"
        }, {
            "id": 32,
            "label": "The National Certification Corporation",
            "value": "TNCC"
        }, {
            "id": 33,
            "label": "National Certifying Board for Ophthalmic Registered Nurses",
            "value": "NCBORN"
        }, {
            "id": 34,
            "label": "National Certifying Board of Otorhinolaryngology and Head-Neck Nurse",
            "value": "NCBOHN"
        }, {
            "id": 35,
            "label": "National League for Nursing ",
            "value": "NLN"
        }, {
            "id": 36,
            "label": "Nephrology Nursing Certification Commission",
            "value": "NNCC"
        }, {
            "id": 37,
            "label": "Oncology Nursing Certification Corporation",
            "value": "ONCC"
        }, {
            "id": 38,
            "label": "Orthopaedic Nurses Certification Board",
            "value": "ONCB"
        }, {
            "id": 39,
            "label": "Pediatric Nursing Certification Board",
            "value": "PNCB"
        }, {
            "id": 40,
            "label": "Plastic Surgical Nursing Certification Board",
            "value": "PSNCB"
        }, {
            "id": 41,
            "label": "Radiologic Nursing Certification Board",
            "value": "RNCB"
        }, {
            "id": 42,
            "label": "Rehabilitation Nursing Certification Board",
            "value": "RENCB"
        }, {
            "id": 43,
            "label": "Society for Clinical Research Excellence",
            "value": "SCRE"
        }, {
            "id": 44,
            "label": "Wound Ostomy and Continence Nursing Certification Board",
            "value": "WOCNCB"
        }],

        CERTIFICATION_NAME: [{
            "certifying_id": 0,
            "label": "None",
            "value": "None"
        }, {
            "cerfication_id": "ANCB",
            "label": "CARN – Certified Addictions Registered Nurse",
            "value": "CARN"
        }, {
            "cerfication_id": "ANCB",
            "label": "CARN-AP –  Certified Addictions Registered Nurse-Advanced Practice",
            "value": "CARN-AP"
        }, {
            "cerfication_id": "AANPCP",
            "label": "ENP – Emergency Nurse Practitioner",
            "value": "ENP"
        }, {
            "cerfication_id": "AANPCP",
            "label": "NP — Adult Nurse Practitioner",
            "value": "NP"
        }, {
            "cerfication_id": "AANPCP",
            "label": "FNP — Family Nurse Practitioner",
            "value": "FNP"
        }, {
            "cerfication_id": "AANPCP",
            "label": "A-GNP — Adult-Gerontology Primary Care Nurse Practitioner",
            "value": "A-GNP"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CCRN — Acute/Critical Care Nursing (Adult, Pediatric & Neonatal)",
            "value": "CCRN"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CCRN-E — Tele-ICU Acute/Critical Care Nursing (Adult)",
            "value": "CCRN-E"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "PCCN — Progressive Care Nursing (Adult)",
            "value": "PCCN"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CNML — Nurse Manager and Leader",
            "value": "CNML"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CCRN-K — Acute/Critical Care Knowledge",
            "value": "CCRN-K"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CMC — Cardiac Medicine (Adult)",
            "value": "CMC"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CSC — Cardiac Surgery (Adult)",
            "value": "CSC"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "ACNPC-AG — Acute Care Nurse Practitioner (Adult-Gerontology)",
            "value": "ACNPC-AG"
        }, {
            "cerfication_id": "AACCNCC",

            "label": "ACCNS — Clinical Nurse Specialist; Wellness through Acute Care (Adult-Gerontology, Pediatric & Neonatal)",

            "value": "ACCNS"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "ACNPC — Acute Care Nurse Practitioner (Adult)",
            "value": "ACNPC"
        }, {
            "cerfication_id": "AACCNCC",
            "label": "CCNS — Acute/Critical Care Clinical Nurse Specialist (Adult, Pediatric & Neonatal)",
            "value": "CCNS"
        }, {
            "cerfication_id": "AAHFN",
            "label": "CHFN — Certified Heart Failure Nurse",
            "value": "CHFN"
        }, {
            "cerfication_id": "AAHFN",
            "label": "CHFN-K — Non-Clinical Certified Heart Failure Nurse",
            "value": "CHFN-K"
        }, {
            "cerfication_id": "ABMCN",
            "label": "CMCN — Certification in Managed Care Nursing",
            "value": "CMCN"
        }, {
            "cerfication_id": "ABNN",
            "label": "CNRN — Certified Neuroscience Registered Nurse",
            "value": "CNRN"
        }, {
            "cerfication_id": "ABNN",
            "label": "SCRN — Stroke Certified Registered Nurse",
            "value": "SCRN"
        }, {
            "cerfication_id": "ABCGN",
            "label": "CGRN — Certified Gastroenterology Registered Nurse",
            "value": "CGRN"
        }, {
            "cerfication_id": "ABOHN",
            "label": "COHN – Certified Occupational Health Nurse",
            "value": "COHN"
        }, {
            "cerfication_id": "ABOHN",
            "label": "COHN-S – Certified Occupational Health Nurse-Specialist",
            "value": "COHN-S"
        }, {
            "cerfication_id": "ABPN",
            "label": "CAPA — Certified Ambulatory Perianesthesia Nurse",
            "value": "CAPA"
        }, {
            "cerfication_id": "ABPN",
            "label": "CPAN — Certified Post Anesthesia Nurse",
            "value": "CPAN"
        }, {
            "cerfication_id": "AHA",
            "label": "CPHRM – Certified Professional in Healthcare Risk Management",
            "value": "CPHRM"
        }, {
            "cerfication_id": "AHNCC",
            "label": "HN-BC — Holistic Nurse, Board Certified",
            "value": "HN-BC"
        }, {
            "cerfication_id": "AHNCC",
            "label": "HNB-BC – Holistic Baccalaureate Nurse, Board Certified",
            "value": "HNB-BC"
        }, {
            "cerfication_id": "AHNCC",
            "label": "AHN-BC – Advanced Holistic Nurse, Board Certified",
            "value": "AHN-BC"
        }, {
            "cerfication_id": "AHNCC",
            "label": "APHN-BC – Advanced Practice Holistic Nurse, Board Certified",
            "value": "APHN-BC"
        }, {
            "cerfication_id": "AHNCC",
            "label": "NC-BC – Nurse Coach, Board Certified",
            "value": "NC-BC"
        }, {
            "cerfication_id": "AHNCC",
            "label": "HWNC-BC – Health and Wellness Nurse Coach, Board Certified",
            "value": "HWNC-BC"
        }, {
            "cerfication_id": "ALNCC",
            "label": "LNCC — Legal Nurse Consultant Certified",
            "value": "LNCC"
        }, {
            "cerfication_id": "ANCC",
            "label": "ANP-BC – Adult Nurse Practitioner",
            "value": "ANP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "FNP-BC – Family Nurse Practitioner",
            "value": "FNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PPCNP-BC – Pediatric Primary Care Nurse Practitioner",
            "value": "PPCNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "ACNP-BC – Acute Care Nurse Practitioner",
            "value": "ACNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "GNP-BC – Gerontological Nurse Practitioner",
            "value": "GNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PMHNP-BC – Adult Psychiatric-Mental Health Nurse Practitioner",
            "value": "PMHNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PMHNP-BC – Psychiatric-Mental Health Nurse Practitioner (Across the Lifespan)",
            "value": "PMHNP-BC-L"
        }, {
            "cerfication_id": "ANCC",
            "label": "AGACNP-BC – Adult-Gerontology Acute Care Nurse Practitioner",
            "value": "AGACNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "AGPCNP-BC – Adult-Gerontology Primary Care Nurse Practitioner",
            "value": "AGPCNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "SNP-BC – School Nurse Practitioner",
            "value": "SNP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "ENP-BC – Emergency Nurse Practitioner",
            "value": "ENP-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PMHCNS-BC – Adult Psychiatric-Mental Health Clinical Nurse Specialist",
            "value": "PMHCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PMHCNS-BC – Child/Adolescent Psychiatric-Mental Health Clinical Nurse Specialist",
            "value": "PMHCNS-BC-C"
        }, {
            "cerfication_id": "ANCC",
            "label": "ACNS-BC – Adult Health Clinical Nurse Specialist",
            "value": "ACNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PCNS-BC Pediatric CNS",
            "value": "PCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "AGCNS-BC – Adult-Gerontology Clinical Nurse Specialist",
            "value": "AGCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "GCNS-BC – Gerontological Clinical Nurse Specialist",
            "value": "GCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "HHCNS-BC – Home Health Clinical Nurse Specialist",
            "value": "HHCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PCNS-BC – Pediatric Clinical Nurse Specialist",
            "value": "PCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "PHCNS-BC – Public/Community Health Clinical Nurse Specialist ",
            "value": "PHCNS-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "Ambulatory Care Nursing",
            "value": "ACN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Cardiac-Vascular Nursing",
            "value": "CVN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Faith Community Nursing",
            "value": "FCN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Gerontological Nursing",
            "value": "GN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Genetics Nursing - Advanced",
            "value": "GN-A"
        }, {
            "cerfication_id": "ANCC",
            "label": "Hemostasis Nursing",
            "value": "HN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Informatics Nursing",
            "value": "IN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Medical-Surgical Nursing",
            "value": "MSN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Nursing Case Management",
            "value": "NCM"
        }, {
            "cerfication_id": "ANCC",
            "label": "Nursing Professional Development",
            "value": "NPD"
        }, {
            "cerfication_id": "ANCC",
            "label": "Pain Management Nursing",
            "value": "PMN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Pediatric Nursing",
            "value": "PN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Psychiatric-Mental Health Nursing",
            "value": "PMHN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Public Health Nursing - Advanced",
            "value": "PHN-A"
        }, {
            "cerfication_id": "ANCC",
            "label": "Rheumatology Nursing",
            "value": "RN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Cardiac Rehabilitation Nursing",
            "value": "CRN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Certified Vascular Nurse",
            "value": "CVN"
        }, {
            "cerfication_id": "ANCC",
            "label": "College Health Nursing",
            "value": "CHN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Community Health Nursing",
            "value": "COHN"
        }, {
            "cerfication_id": "ANCC",
            "label": "General Nursing Practice",
            "value": "GNP"
        }, {
            "cerfication_id": "ANCC",
            "label": "High-Risk Perinatal Nursing",
            "value": "HRPN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Home Health Nursing",
            "value": "HHN"
        }, {
            "cerfication_id": "ANCC",
            "label": "Perinatal Nursing",
            "value": "PEN"
        }, {
            "cerfication_id": "ANCC",
            "label": "School Nursing",
            "value": "SN"
        },
        {
            "cerfication_id": "ANCC",
            "label": "AFN-BC – Advanced Forensic Nursing",
            "value": "AFN-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "AGN-BC – Advanced Genetics Nursing-Board Certified",
            "value": "AGN-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "NE-BC – Nurse Executive",
            "value": "NE-BC"
        }, {
            "cerfication_id": "ANCC",
            "label": "NEA-BC – Nurse Executive, Advanced",
            "value": "NEA-BC"
        }, {
            "cerfication_id": "AONE",
            "label": "CENP – Certified in Executive Nursing Practice",
            "value": "CENP"
        }, {
            "cerfication_id": "AONE",
            "label": "CNML – Certified Nurse Manager and Leader ",
            "value": "CNML"
        }, {
            "cerfication_id": "ACRP",
            "label": "CCRC — Certified Clinical Research Coordinator",
            "value": "CCRC"
        }, {
            "cerfication_id": "ACRP",
            "label": "CCRA — Certified Clinical Research Associate",
            "value": "CCRA"
        }, {
            "cerfication_id": "BCEN",
            "label": "CEN — Certified Emergency Nurse",
            "value": "CEN"
        }, {
            "cerfication_id": "BCEN",
            "label": "CFRN — Certified Flight Registered Nurse",
            "value": "CFRN"
        }, {
            "cerfication_id": "BCEN",
            "label": "CPEN – Certified Pediatric Emergency Nurse",
            "value": "CPEN"
        }, {
            "cerfication_id": "BCEN",
            "label": "CTRN – Certified Transport Registered Nurse",
            "value": "CTRN"
        }, {
            "cerfication_id": "BCEN",
            "label": "TCRN – Trauma Certified Registered Nurse ",
            "value": "TCRN"
        }, {
            "cerfication_id": "CBICE",
            "label": "CIC — Certified in Infection Control",
            "value": "CIC"
        }, {
            "cerfication_id": "CBUNA",
            "label": "CUNP – Certified Urologic Nurse Practitioner",
            "value": "CUNP"
        }, {
            "cerfication_id": "CBUNA",
            "label": "CURN – Certified Urologic Registered Nurse",
            "value": "CURN"
        }, {
            "cerfication_id": "CBUNA",
            "label": "CUA – Urologic Associate ",
            "value": "CUA"
        }, {
            "cerfication_id": "CNC",
            "label": "CNL – Clinical Nurse Leader",
            "value": "CUA"
        }, {
            "cerfication_id": "CCI",
            "label": "CNOR — Certified Nurse, Operating Room",
            "value": "CNOR"
        }, {
            "cerfication_id": "CCI",
            "label": "CRNFA – Certified Registered Nurse First Assistant",
            "value": "CRNFA"
        }, {
            "cerfication_id": "CCI",
            "label": "CNS-CP – Clinical Nurse Specialist Perioperative Certification",
            "value": "CNS-CP"
        }, {
            "cerfication_id": "DNCB",
            "label": "DNC – Dermatology Nurse Certified",
            "value": "DNC"
        }, {
            "cerfication_id": "DNCB",
            "label": "DCNP – Dermatology Certified Nurse Practitioner",
            "value": "DCNP"
        }, {
            "cerfication_id": "HANCB",
            "label": "ACRN – HIV/AIDS Certified Registered Nurse",
            "value": "ACRN"
        }, {
            "cerfication_id": "HANCB",
            "label": "AACRN – Advanced HIV/AIDS Certified Registered Nurse",
            "value": "AACRN"
        }, {
            "cerfication_id": "INCC",
            "label": "CRNI — Certified Registered Nurse Infusion",
            "value": "CRNI"
        }, {
            "cerfication_id": "IAFN",
            "label": "SANE-A — Sexual Assault Nurse Examiner-Adult/Adolescent",
            "value": "SANE-A"
        }, {
            "cerfication_id": "IAFN",
            "label": "SANE-P — Sexual Assault Nurse Examiner-Pediatric",
            "value": "SANE-P"
        }, {
            "cerfication_id": "IAFN",
            "label": "AFN-BC — Advanced Forensic Nursing",
            "value": "AFN-BC"
        }, {
            "cerfication_id": "MSNCB",
            "label": "CCCTM — Certified in Care Coordination and Transition Management",
            "value": "CCCTM"
        }, {
            "cerfication_id": "MSNCB",
            "label": "CMSRN — Certified Medical-Surgical Registered Nurse",
            "value": "CMSRN"
        }, {
            "cerfication_id": "NAECB",
            "label": "AE-C – Certified Asthma Educator",
            "value": "AE-C"
        }, {
            "cerfication_id": "NAHQ",
            "label": "CPHQ – Certified Professional in Healthcare Quality",
            "value": "CPHQ"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CHPN — Certified Hospice and Palliative Nurse",
            "value": "CHPN"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "ACHPN — Advanced Certified Hospice and Palliative Nurse",
            "value": "ACHPN"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CHPPN – Certified Hospice and Palliative Pediatric Nurse",
            "value": "CHPPN"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CHPLN – Certified Hospice and Palliative Licensed Nurse",
            "value": "CHPLN"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CHPNA – Certified Hospice and Palliative Nursing Assistant",
            "value": "CHPNA"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CHPCA – Certified Hospice and Palliative Care Administrator",
            "value": "CHPCA"
        }, {
            "cerfication_id": "NBCHPN",
            "label": "CPLC – Certified in Perinatal Loss Care",
            "value": "CPLC"
        }, {
            "cerfication_id": "NBCRNA",
            "label": "CRNA — Certified Registered Nurse Anesthetist",
            "value": "CRNA"
        }, {
            "cerfication_id": "NBCSN",
            "label": "NCSN — National Certified School Nurse",
            "value": "NCSN"
        }, {
            "cerfication_id": "NCBDE",
            "label": "CDE — Certified Diabetes Educator",
            "value": "CDE"
        }, {
            "cerfication_id": "TNCC",
            "label": "RNC-OB – Inpatient Obstetric Nursing",
            "value": "RNC-OB"
        }, {
            "cerfication_id": "TNCC",
            "label": "RNC-MNN – Maternal Newborn Nursing",
            "value": "RNC-MNN"
        }, {
            "cerfication_id": "TNCC",
            "label": "RNC-LRN – Low Risk Neonatal Nursing",
            "value": "RNC-LRN"
        }, {
            "cerfication_id": "TNCC",
            "label": "RNC-NIC – Neonatal Intensive Care Nursing",
            "value": "RNC-NIC"
        }, {
            "cerfication_id": "TNCC",
            "label": "NNP-BC – Neonatal Nurse Practitioner",
            "value": "NNP-BC"
        }, {
            "cerfication_id": "TNCC",
            "label": "WHNP-BC – Women’s Health Care Nurse Practitioner",
            "value": "WHNP-BC"
        }, {
            "cerfication_id": "TNCC",
            "label": "C-EFM – Electronic Fetal Monitoring",
            "value": "C-EFM"
        }, {
            "cerfication_id": "TNCC",
            "label": "C-NPT – Neonatal Pediatric Transport",
            "value": "C-NPT"
        }, {
            "cerfication_id": "NCBORN",
            "label": "CRNO — Certification for Registered Nurses of Ophthalmology",
            "value": "CRNO"
        }, {
            "cerfication_id": "NCBOHN",
            "label": "CORLN — Certified Otorhinolaryngology Nurse",
            "value": "CORLN"
        }, {
            "cerfication_id": "NLN",
            "label": "CNE — Certified Nurse Educator",
            "value": "CNE"
        }, {
            "cerfication_id": "NNCC",
            "label": "RNN — Certified Nephrology Nurse",
            "value": "CNN"
        }, {
            "cerfication_id": "NNCC",
            "label": "CDN —  Certified Dialysis Nurse",
            "value": "CDN"
        }, {
            "cerfication_id": "NNCC",
            "label": "CNN-NP – Certified Nephrology Nurse-Nurse Practitioner",
            "value": "CNN-NP"
        }, {
            "cerfication_id": "NNCC",
            "label": "CD-LPN – Certified Dialysis Licensed Practical Nurse",
            "value": "CD-LPN"
        }, {
            "cerfication_id": "NNCC",
            "label": "CD-LVN – Certified Dialysis Licensed Vocational Nurse",
            "value": "CD-LVN"
        }, {
            "cerfication_id": "NNCC",
            "label": "CCHT— Certified Clinical Hemodialysis Technician",
            "value": "CCHT"
        }, {
            "cerfication_id": "NNCC",
            "label": "CCHTA— Certified Clinical Hemodialysis Technician-Advanced",
            "value": "CCHTA"
        }, {
            "cerfication_id": "ONCC",
            "label": "AOCN — Advanced Oncology Certified Nurse",
            "value": "AOCN"
        }, {
            "cerfication_id": "ONCC",
            "label": "CPON — Certified Pediatric Oncology Nurse",
            "value": "CPON"
        }, {
            "cerfication_id": "ONCC",
            "label": "OCN — Oncology Certified Nurse",
            "value": "OCN"
        }, {
            "cerfication_id": "ONCC",
            "label": "AOCNP – Advanced Oncology Certified Nurse Practitioner",
            "value": "AOCNP"
        }, {
            "cerfication_id": "ONCC",
            "label": "AOCNS – Advanced Oncology Certified Clinical Nurse Specialist",
            "value": "AOCNS"
        }, {
            "cerfication_id": "ONCC",
            "label": "CPHON – Certified Pediatric Hematology Oncology Nurse",
            "value": "CPHON"
        }, {
            "cerfication_id": "ONCC",
            "label": "CBCN – Certified Breast Care Nurse",
            "value": "CBCN"
        }, {
            "cerfication_id": "ONCC",
            "label": "BMTCN – Bone Marrow Transplant Certified Nurse",
            "value": "BMTCN"
        }, {
            "cerfication_id": "ONCB",
            "label": "ONC — Orthopaedic Nurse Certified",
            "value": "ONC"
        }, {
            "cerfication_id": "ONCB",
            "label": "OCNS-C – Orthopaedic Clinical Nurse Specialist – Certified",
            "value": "OCNS-C"
        }, {
            "cerfication_id": "ONCB",
            "label": "ONP-C – Orthopaedic Nurse Practitioner-Certified",
            "value": "ONP-C"
        }, {
            "cerfication_id": "PNCB",
            "label": "CPN – Certified Pediatric Nurse",
            "value": "CPN"
        }, {
            "cerfication_id": "PNCB",
            "label": "CPEN – Certified Pediatric Emergency Nurse",
            "value": "CPEN"
        }, {
            "cerfication_id": "PNCB",
            "label": "CPNP-PC – Certified Pediatric Nurse Practitioner-Primary Care",
            "value": "CPNP-PC"
        }, {
            "cerfication_id": "PNCB",
            "label": "CPP-AC – Certified Pediatric Nurse Practitioner-Acute Care",
            "value": "CPP-AC"
        }, {
            "cerfication_id": "PNCB",
            "label": "PMHS – Pediatric Primary Care Mental Health Specialist",
            "value": "PMHS"
        }, {
            "cerfication_id": "PSNCB",
            "label": "CPSN — Certified Plastic Surgical Nurse",
            "value": "CPSN"
        }, {
            "cerfication_id": "PSNCB",
            "label": "CANS – Certified Aesthetic Nurse Specialist",
            "value": "CANS"
        }, {
            "cerfication_id": "RNCB",
            "label": "CRN — Certified Radiologic Nurse",
            "value": "CRN"
        }, {
            "cerfication_id": "RENCB",
            "label": "CRRN — Certified Rehabilitation Registered Nurse",
            "value": "CRRN"
        }, {
            "cerfication_id": "SCRE",
            "label": "CCRP — Certified Clinical Research Professional",
            "value": "CCRP"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CCCN — Certified Continence Care Nurse",
            "value": "CCCN "
        }, {
            "cerfication_id": "WOCNCB",
            "label": "COCN — Certified Ostomy Care Nurse",
            "value": "COCN"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWCN — Certified Wound Care Nurse",
            "value": "CWCN"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWOCN — Certified Wound Ostomy Continence Nurse",
            "value": "CWOCN"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWON – Certified Wound Ostomy Nurse",
            "value": "CWON"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CFCN – Certified Foot Care Nurse Advanced Practice",
            "value": "CFCN"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CCCN-AP — Certified Continence Care Nurse-Advanced Practice",
            "value": "CCCN-AP"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "COCN-AP — Certified Ostomy Care Nurse-Advanced Practice",
            "value": "COCN-AP"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWCN-AP — Certified Wound Care Nurse-Advanced Practice",
            "value": "CWCN-AP"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWOCN-AP — Certified Wound Ostomy Continence Nurse-Advanced Practice",
            "value": "CWOCN-AP"
        }, {
            "cerfication_id": "WOCNCB",
            "label": "CWON-AP – Certified Wound Ostomy Nurse-Advanced Practice",
            "value": "CWON-AP"
        }]
    });
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('briefcaseConstants', {
        SB_URL: "",
        VIEW_TYPE: "overview",
        BASE_URL: "",
        BASE_URL2: "",
        ACCESS_TOKEN: "",
        NAME_REGEX: /^[a-zA-Z- `~:;'",.“”‘’‛‟‚„′″´˝]*$/,
        DATE_REGEX: /^(((0[13578]|1[02])-(0[1-9]|[12]\d|3[01])-((19|[2-9]\d)\d{2}))|((0[13456789]|1[012])-(0[1-9]|[12]\d|30)-((19|[2-9]\d)\d{2}))|(02-(0[1-9]|1\d|2[0-8])-((19|[2-9]\d)\d{2}))|(02-29-((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,
        LICENSE_NUMBER_REGEX: /^[a-zA-Z0-9.-]{1,15}$/,
        PHONE_NUMBER_REGEX: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
        EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        VALID_FILE_FORMATS: ['doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png', 'page', 'pages', 'rtf', 'txt', 'gif'],
        URL_REGEX: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
        FileImage: [{
            'flag': false,
            'file': '',
            'size': false,
            'err': ''
        }],
        roleAccess: {
            'hospitalAdmin': false,
            'hospitalManager': false,
            'hospitalUser': false,
            'admin': false,
            'superAdmin': false,
            'nurse': false,
            'mobile': false,
            'guest': false
        },
        profileFields: {
            select: {
                'firstName': 1,
                'lastName': 1,
                'address': 1,
                'dateOfBirth': 1,
                'email': 1,
                'facebookId': 1,
                'phoneNumber': 1,
                'ssn': 1,
                'timezone': 1,
                'languages': 1,
                'emergencyContact': 1,
                'profession': 1,
                'jobs.workCities': 1,
                'jobs.workStates': 1,
                'jobs.workDistance': 1,
                'jobs.cancelledJobs': 1,
                'jobs.confirmedJobs': 1,
                'briefcase.currentStep': 1,
                'briefcase.consentedAt': 1,
                'profilePicUrl': 1,
                'profilePicThumbUrl': 1,
                'profilePicFileId': 1
            }
        },
        DOCUMENT_TAB_IFRAME_URL: "",
        ADMIN_DOCUMENT_TAB_IFRAME_URL: "",
        TASK_TAB_IFRAME_URL: "",
        ADMIN_TASK_TAB_IFRAME_URL: ""
    });
})();
'use strict';

(function () {
	'use strict';


	var module = angular.module('praos.briefcase');
	module.service('briefcaseUtil', ['$log', '$window', '$document', '$http', '$timeout', '$interval', '$injector', '$q', '$interpolate', 'briefcaseConstants', 'toastr', function ($log, $window, $document, $http, $timeout, $interval, $injector, $q, $interpolate, briefcaseConstants, toastr) {

		var addressToLatLng = function addressToLatLng(address) {
			var deferred = $q.defer();
			var latlng = {};
			new google.maps.Geocoder().geocode({
				'address': address
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					latlng.lat = results[0].geometry.location.lat();
					latlng.lng = results[0].geometry.location.lng();
					deferred.resolve(latlng);
				} else {
					latlng.error = 401;
					latlng.errorMsg = 'Your Address is wrong';
					toastr.error('Your address is not correct!');
					deferred.reject(latlng);
				}
			});
			return deferred.promise;
		};

		var getYears = function getYears(offset, range) {
			var currentYear = new Date().getFullYear();
			var startYear = currentYear - range;
			var years = [];
			for (startYear; startYear < currentYear; startYear = startYear + offset) {
				years.push(startYear + offset);
			}
			return years;
		};

		function findObjectByKey(array, key) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var obj = _step.value;

					var objKey = Object.keys(obj)[0];
					if (key === objKey) {
						return obj;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return null;
		}

		function isEmpty(obj) {
			var isEmpty = true;
			for (var bar in obj) {
				if (bar) {
					isEmpty = false;
				}
			}
			return isEmpty;
		};

		function checkSelectedDateIsGreater(ExpireDate) {
			var start = moment();
			var selectedDate = moment();
			if (ExpireDate) {
				var expireDate = moment(ExpireDate.replace(/-/g, '/'));
				if (expireDate > start) {
					selectedDate = ExpireDate;
				}
			}
			return selectedDate;
		};

		function formatDate(date) {
			if (moment(date).isValid()) {
				if (date && date.indexOf('T') > -1) {
					return moment.utc(date).format('MM-DD-YYYY');
				} else {
					return moment.utc(date, 'MM-DD-YYYY').format('MM-DD-YYYY');
				}
			}
			return undefined;
		}

		function isFileValid(file) {
			var result = {};
			if (file) {
				var validFormats = angular.copy(briefcaseConstants.VALID_FILE_FORMATS);
				if (validFormats.indexOf(file[0].name.substring(file[0].name.lastIndexOf('.') + 1).toLowerCase()) === -1) {
					result.size = true;
					result.flag = false;
					result.err = 'Please upload a valid document';
				} else if (file[0].size / 1024 > 1024 * 10) {
					result.size = true;
					result.flag = false;
					result.err = 'File size can not exceed 10 MB';
				} else {
					result.flag = true;
					result.file = file[0];
					result.size = false;
					result.err = '';
				}
			}
			return result;
		}

		function getDateDiff(date) {
			var newDate = date.split('T');
			date = newDate[0] + 'T23:59:00.000Z';
			var currentDate = new Date();
			currentDate.setHours(18);
			currentDate.setMinutes(29);
			var selectedDate = new Date(date);
			var timeDiff = selectedDate.getTime() - currentDate.getTime();
			var dateDiff = Math.round(timeDiff / (1000 * 3600 * 24));
			return dateDiff;
		}

		function b64toBlob(b64Data, contentType, sliceSize) {
			contentType = contentType || '';
			sliceSize = sliceSize || 512;

			var byteCharacters = atob(b64Data);
			var byteArrays = [];

			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = new Array(slice.length);
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, { type: contentType });
			return blob;
		}

		this.cleanObject = function cleanDeep(object) {
			return _.transform(object, function (result, value, key) {
				if (_.isArray(value) || _.isPlainObject(value)) {
					value = cleanDeep(value);
				}

				if (_.isPlainObject(value) && _.isEmpty(value) || _.isArray(value) && !value.length || value === '' || Number.isNaN(value) || value === null || value === undefined) {
					return;
				}

				if (_.isArray(result)) {
					return result.push(value);
				}

				result[key] = value;
			});
		};


		this.addressToLatLng = addressToLatLng;
		this.getYears = getYears;
		this.findObjectByKey = findObjectByKey;
		this.formatDate = formatDate;
		this.isEmpty = isEmpty;
		this.isFileValid = isFileValid;
		this.getDateDiff = getDateDiff;
		this.b64toBlob = b64toBlob;
		this.checkSelectedDateIsGreater = checkSelectedDateIsGreater;
	}]);
})();
'use strict';

(function () {
    angular.module('praos.briefcase').filter('urlParseName', function () {
        return function (value) {
            return value ? value.split('/').pop() : value;
        };
    });
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('documentConstants', {

        healthScreen: [{
            "name": 'Drug Test',
            "status": false,
            "date": "",
            "reason": ""
        }, {
            "name": 'TB Test',
            "status": false,
            "date": "",
            "reason": ""
        }],
        vaccinations: [{
            "value": "1",
            "name": "Varicella",
            "status": false,
            "file": false,
            "date": ''
        }, {
            "value": "2",
            "name": "Hepatitis B",
            "status": false,
            "file": false,
            "date": ''
        }, {
            "value": "3",
            "name": "Tdap",
            "status": false,
            "file": false,
            "date": ''
        }, {
            "value": "4",
            "name": "Pneumococcal",
            "status": false,
            "file": false,
            "date": ''
        }, {
            "value": "5",
            "name": "Flu Shot",
            "status": false,
            "file": false,
            "date": ''
        }, {
            "value": "6",
            "name": "MMR",
            "status": false,
            "file": false,
            "date": ''
        }],
        selectTestReason: [{
            label: 'Employment',
            value: 'Employment'
        }, {
            label: 'School',
            value: 'School'
        }, {
            label: 'Licensure',
            value: 'Licensure'
        }, {
            label: 'Other',
            value: 'Other'
        }],
        accountType: [{
            id: 1,
            value: 'Checking'
        }, {
            id: 2,
            value: 'Saving'
        }],

        ADDITIONAL_DOCUMENTATION: [{
            "addDocName": "",
            "file": ""
        }],
        STATES: {
            "AL": "Alabama",
            "AK": "Alaska",
            "AS": "American Samoa",
            "AZ": "Arizona",
            "AR": "Arkansas",
            "CA": "California",
            "CO": "Colorado",
            "CT": "Connecticut",
            "DE": "Delaware",
            "DC": "District Of Columbia",
            "FM": "Federated States Of Micronesia",
            "FL": "Florida",
            "GA": "Georgia",
            "GU": "Guam",
            "HI": "Hawaii",
            "ID": "Idaho",
            "IL": "Illinois",
            "IN": "Indiana",
            "IA": "Iowa",
            "KS": "Kansas",
            "KY": "Kentucky",
            "LA": "Louisiana",
            "ME": "Maine",
            "MH": "Marshall Islands",
            "MD": "Maryland",
            "MA": "Massachusetts",
            "MI": "Michigan",
            "MN": "Minnesota",
            "MS": "Mississippi",
            "MO": "Missouri",
            "MT": "Montana",
            "NE": "Nebraska",
            "NV": "Nevada",
            "NH": "New Hampshire",
            "NJ": "New Jersey",
            "NM": "New Mexico",
            "NY": "New York",
            "NC": "North Carolina",
            "ND": "North Dakota",
            "MP": "Northern Mariana Islands",
            "OH": "Ohio",
            "OK": "Oklahoma",
            "OR": "Oregon",
            "PW": "Palau",
            "PA": "Pennsylvania",
            "PR": "Puerto Rico",
            "RI": "Rhode Island",
            "SC": "South Carolina",
            "SD": "South Dakota",
            "TN": "Tennessee",
            "TX": "Texas",
            "UT": "Utah",
            "VT": "Vermont",
            "VI": "Virgin Islands",
            "VA": "Virginia",
            "WA": "Washington",
            "WV": "West Virginia",
            "WI": "Wisconsin",
            "WY": "Wyoming"
        }

    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').directive('documentBriefcase', documentBriefcase);

    documentBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];
    function documentBriefcase($window, briefcaseUtil, briefcaseConstants) {
        return {
            template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
            scope: {
                viewType: '@',
                callBack: '&documentBriefcase'
            },
            transclude: true,
            controller: 'documentCtrl as documentCtrl',
            link: function link($scope, $elm, $attrs, documentCtrl) {
                $scope.getTemplateUrl = function () {
                    return 'document/document-' + $attrs.viewType + '.html';
                };
                $elm.on('load', function () {
                    return $scope.callBack();
                });

                documentCtrl.init();

                $scope.updateTemplate = function (viewType) {
                    $attrs.viewType = viewType;
                    $scope.getTemplateUrl();
                    documentCtrl.init(); 
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').controller('documentCtrl', ['$scope', '$sce', 'briefcaseConstants', 'briefcaseService', 'loader', function ($scope, $sce, briefcaseConstants, briefcaseService, loader) {
        var vm = this;

        if (briefcaseConstants.isAdminOrHospitalUser) {
            $scope.externalClientIframeUrl = briefcaseConstants.ADMIN_DOCUMENT_TAB_IFRAME_URL.replace('{userId}', briefcaseService.briefcase.id) + '?auth=' + briefcaseConstants.ACCESS_TOKEN;
        } else {
            $scope.externalClientIframeUrl = briefcaseConstants.DOCUMENT_TAB_IFRAME_URL + '?auth=' + briefcaseConstants.ACCESS_TOKEN;
        }

        vm.init = function () {
            $scope.iframeLoadedCallBack = function () {
                loader.show();
            };

            $scope.trustSrc = function (src) {
                var trustedUrl = $sce.trustAsResourceUrl(src);
                return trustedUrl;
            };
        };
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('educationConstants', {

        EDUCATION_INSTITUTION: [{
            "instituteName": "",
            "yearFrom": '',
            "yearTo": '',
            "programName": '',
            "status": [],
            "courseWorkURL": '',
            "file": ''
        }],
        CONTINUING_EDUCATION: [{
            "title": "",
            "startDate": '',
            "endDate": '',
            "courseWorkURL": '',
            "file": '',
            "internal": 'true',
            "certFile": ''
        }],
        COMPETENCIES: [{
            "title": "",
            "startDate": "",
            "endDate": "",
            "moduleContentURL": "",
            "file": ""
        }],
        PROFESSIONAL_ORGANIZATION_MEMBERSHIP: [{
            "name": "",
            "startDate": "",
            "endDate": ""
        }],
        PROJECT_AND_PROFESSIONAL_ACTIVITY_WORK: [{
            "title": "",
            "startDate": "",
            "endDate": "",
            "projectDetailsURL": "",
            "file": ""
        }],
        EXPERIENCE_OF_YEAR: {
            'Less than 1 Year': 'Less than 1 Year',
            '1 to 2 Years': '1 to 2 Years',
            '2 to 3 Years': '2 to 3 Years',
            '3 to 5 Years': '3 to 5 Years',
            '5 to 10 Years': '5 to 10 Years',
            'Greater than 10 Years': 'Greater than 10 Years'
        },
        REFERENCES: [{
            "firstName": "",
            "lastName": '',
            "email": '',
            "phoneNumber": '',
            "organisation": '',
            "title": ''
        }],
        FACILITIES: [{
            "name": '',
            "city": '',
            "state": ''
        }],
        EDUCATION_DOCUMENTATION: [{
            "eduDocName": "",
            "file": ""
        }],
        EHR_SKILLS_DATA: [{
            "id": "Allscripts",
            "label": "Allscripts",
            "value": "Allscripts",
            "checked": false
        }, {
            "id": "AH",
            "label": "AthenaHealth",
            "value": "AH",
            "checked": false
        }, {
            "id": "GE",
            "label": "Centricity",
            "value": "GE",
            "checked": false
        }, {
            "id": "Cerner",
            "label": "Cerner Power Chart",
            "value": "Cerner",
            "checked": false
        }, {
            "id": "CG",
            "label": "CompuGroup",
            "value": "CG",
            "checked": false
        }, {
            "id": "CTSI",
            "label": "CTSI",
            "value": "CTSI",
            "checked": false
        }, {
            "id": "EW",
            "label": "eClinical works",
            "value": "EW",
            "checked": false
        }, {
            "id": "Epic",
            "label": "EpicCare Ambulatory Core EMR",
            "value": "Epic",
            "checked": false
        }, {
            "id": "McKesson",
            "label": "iKnowMed, Horizon, Paragon",
            "value": "McKesson",
            "checked": false
        }, {
            "id": "Meditech",
            "label": "Meditech",
            "value": "Meditech",
            "checked": false
        }, {
            "id": "NHS",
            "label": "NextGen Healthcare Systems",
            "value": "NHS",
            "checked": false
        }, {
            "id": "Optum",
            "label": "Optum",
            "value": "Optum",
            "checked": false
        }, {
            "id": "PF",
            "label": "Practice Fusion",
            "value": "PF",
            "checked": false
        }, {
            "id": "Vitera",
            "label": "Vitera",
            "value": "Vitera",
            "checked": false
        }, {
            "id": "other",
            "label": "Other",
            "value": "",
            "checked": false
        }],
        EDUCATION_INSTITUTION_STATUS: [{
            "id": "Graduated",
            "label": "Graduated",
            "value": "Graduated",
            "checked": false
        }, {
            "id": "Inprogress",
            "label": "In Progress",
            "value": "In Progress",
            "checked": false
        }, {
            "id": "Abandoned",
            "label": "Abandoned",
            "value": "Abandoned",
            "checked": false
        }, {
            "id": "other",
            "label": "Other",
            "value": "",
            "checked": false
        }],
        STATES: {
            "AL": "Alabama",
            "AK": "Alaska",
            "AS": "American Samoa",
            "AZ": "Arizona",
            "AR": "Arkansas",
            "CA": "California",
            "CO": "Colorado",
            "CT": "Connecticut",
            "DE": "Delaware",
            "DC": "District Of Columbia",
            "FM": "Federated States Of Micronesia",
            "FL": "Florida",
            "GA": "Georgia",
            "GU": "Guam",
            "HI": "Hawaii",
            "ID": "Idaho",
            "IL": "Illinois",
            "IN": "Indiana",
            "IA": "Iowa",
            "KS": "Kansas",
            "KY": "Kentucky",
            "LA": "Louisiana",
            "ME": "Maine",
            "MH": "Marshall Islands",
            "MD": "Maryland",
            "MA": "Massachusetts",
            "MI": "Michigan",
            "MN": "Minnesota",
            "MS": "Mississippi",
            "MO": "Missouri",
            "MT": "Montana",
            "NE": "Nebraska",
            "NV": "Nevada",
            "NH": "New Hampshire",
            "NJ": "New Jersey",
            "NM": "New Mexico",
            "NY": "New York",
            "NC": "North Carolina",
            "ND": "North Dakota",
            "MP": "Northern Mariana Islands",
            "OH": "Ohio",
            "OK": "Oklahoma",
            "OR": "Oregon",
            "PW": "Palau",
            "PA": "Pennsylvania",
            "PR": "Puerto Rico",
            "RI": "Rhode Island",
            "SC": "South Carolina",
            "SD": "South Dakota",
            "TN": "Tennessee",
            "TX": "Texas",
            "UT": "Utah",
            "VT": "Vermont",
            "VI": "Virgin Islands",
            "VA": "Virginia",
            "WA": "Washington",
            "WV": "West Virginia",
            "WI": "Wisconsin",
            "WY": "Wyoming"
        },
        EDUCATION: [{ name: "Associate Degree" }, { name: "Associate Degree in Nursing", onlyForProfession: "Nurse" }, { name: "Baccalaureate of Nursing", onlyForProfession: "Nurse" }, { name: "Bachelor Degree" }, { name: "Diploma in Nursing", onlyForProfession: "Nurse" }, { name: "Doctorate Degree" }, { name: "Doctorate of Nursing", onlyForProfession: "Nurse" }, { name: "Doctorate of Nursing Practice", onlyForProfession: "Nurse" }, { name: "High School Diploma" }, { name: "Master Degree" }, { name: "Master of Nursing", onlyForProfession: "Nurse" }, { name: "VN/PN program", onlyForProfession: "Nurse" }]
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').directive('educationBriefcase', educationBriefcase);

    educationBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];
    function educationBriefcase($window, briefcaseUtil, briefcaseConstants) {
        return {
            template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
            scope: {
                viewType: '@'
            },
            transclude: true,
            controller: 'educationCtrl as educationCtrl',
            link: function link($scope, $elm, $attrs, educationCtrl) {
                $scope.getTemplateUrl = function () {
                    return 'education/education-' + $attrs.viewType + '.html';
                };
                educationCtrl.init();

                $scope.updateTemplate = function (viewType) {
                    $attrs.viewType = viewType;
                    $scope.getTemplateUrl();
                    educationCtrl.init(); 
                };
            }
        };
    }
})();
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(function () {
    'use strict';


    angular.module('praos.briefcase').controller('educationCtrl', ['$scope', '$element', '$attrs', '$parse', '$compile', 'briefcaseService', 'dropDownConstant', 'ngDialog', 'briefcaseUtil', 'loader', '$document', 'toastr', 'educationConstants', 'briefcaseConstants', 'fileDownload', '$filter', '$timeout', '$localStorage', 'documentSync', 'professionalService', 'recordService', 'loader', function ($scope, $elm, $attrs, $parse, $compile, briefcaseService, dropDownConstant, ngDialog, briefcaseUtil, loader, $document, toastr, educationConstants, briefcaseConstants, fileDownload, $filter, $timeout, $localStorage, documentSync, professionalService, recordService) {

        var vm = this;
        var educationPopUp;
        initConstant();

        function initConstant() {
            $scope.isEditable = briefcaseConstants.isEditable;
            vm.isAdminOrHospitalUser = briefcaseConstants.isAdminOrHospitalUser;
            if (!vm.isAdminOrHospitalUser) {
                vm.enableRefValidation = true;
            } else {
                vm.enableRefValidation = false;
            }

            vm.deletedEducationDocuments = [];
            vm.deletedContinuingEducation = [];
            vm.deletedCompetencies = [];
            vm.deletedProOrgMemberships = [];
            vm.deletedActivityWork = [];
            vm.deletedEducation = [];
            vm.deletedReferences = [];
            vm.deletedFacilities = [];

            vm.dropDownConstant = angular.copy(dropDownConstant);
            vm.nameRegex = briefcaseConstants.NAME_REGEX;
            vm.emailRegex = briefcaseConstants.EMAIL_REGEX;
            vm.urlRegex = briefcaseConstants.URL_REGEX;
            vm.ehrSkillsData = angular.copy(educationConstants.EHR_SKILLS_DATA);
            vm.educationInstitutionStatus = angular.copy(educationConstants.EDUCATION_INSTITUTION_STATUS);
            vm.educationInstitution = angular.copy(educationConstants.EDUCATION_INSTITUTION);
            vm.educationDocumentation = angular.copy(educationConstants.EDUCATION_DOCUMENTATION);
            vm.continuingEducation = angular.copy(educationConstants.CONTINUING_EDUCATION);
            vm.competencies = angular.copy(educationConstants.COMPETENCIES);
            vm.proOrgMembership = angular.copy(educationConstants.PROFESSIONAL_ORGANIZATION_MEMBERSHIP);
            vm.projectProActivityWork = angular.copy(educationConstants.PROJECT_AND_PROFESSIONAL_ACTIVITY_WORK);
            vm.experienceOfYear = angular.copy(educationConstants.EXPERIENCE_OF_YEAR);
            vm.references = angular.copy(educationConstants.REFERENCES);
            vm.facilities = angular.copy(educationConstants.FACILITIES);
            vm.selectState = angular.copy(educationConstants.STATES);
            vm.yearsRange = briefcaseUtil.getYears(1, 78);
            vm.example14settings = {
                scrollableHeight: '200px',
                scrollable: true,
                enableSearch: false,
                showCheckAll: false,
                showUncheckAll: false,
                dynamicTitle: 'Skill checked',
                externalIdProp: ''
            };
            vm.example15settings = {
                dynamicTitle: 'Status checked',
                externalIdProp: ''
            };
            vm.defaultStatuses = ['Graduated', 'In progress', 'Abandoned'];
            vm.otherEhr = "";
            vm.ehrSkills = [];
            vm.files = {};
            vm.roleAccess = angular.copy(briefcaseService.roleAccess);
            vm.role = briefcaseService.userRole;
            vm.urlTooltip = 'Please enter URL with https:// or http:// as a prefix. e.g. https://www.example.com.';
        }

        vm.viewType = briefcaseService.viewType;

        vm.openBriefcase = function () {
            var SB_URL = briefcaseConstants.SB_URL + '/' + briefcaseService.briefcase.id + '?authToken=' + briefcaseConstants.ACCESS_TOKEN;
            console.log("Briefcase url", SB_URL);
            window.open(SB_URL);
            return false;
        };

        vm.init = function () {
            var _this = this;

            loader.show();
            var selectOptions = {
                select: {
                    'briefcase.competencies': 1,
                    'briefcase.education': 1,
                    'briefcase.continuingEducation': 1,
                    'briefcase.educationLevel': 1,
                    'briefcase.educationDocuments': 1,
                    'briefcase.ehrSkills': 1,
                    'briefcase.facilities': 1,
                    'briefcase.workExperiences': 1,
                    'briefcase.organizationMembership': 1,
                    'briefcase.references': 1,
                    'briefcase.workExperience': 1,
                    'briefcase.yearsOfExperience': 1,
                    'briefcase.activityWork': 1,
                    'briefcase.licensedAt': 1,
                    'jobs.cancelledJobs': 1,
                    'jobs.confirmedJobs': 1,
                    'jobs.competentReviews': 1,
                    'jobs.professionalReviews': 1,
                    'jobs.skilledReviews': 1,
                    'briefcase.currentStep': 1,
                    'briefcase.consentedAt': 1,
                    "profession": 1
                }
            };

            professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, selectOptions).then(function (_ref) {
                var _ref$briefcase = _ref.briefcase,
                    briefcase = _ref$briefcase === undefined ? {} : _ref$briefcase,
                    jobs = _ref.jobs,
                    profession = _ref.profession;

                var defaultBriefcase = {
                    competencies: [{}],
                    education: [{}],
                    continuingEducation: [{}],
                    educationDocuments: [{}],
                    ehrSkills: [],
                    facilities: [{}],
                    workExperiences: [{}],
                    organizationMembership: [{}],
                    references: [{}],
                    workExperience: {},
                    activityWork: [{}]
                };
                vm.jobs = jobs || {};
                vm.currentStep = briefcase.currentStep;
                vm.consentedAt = briefcase.consentedAt;

                if (briefcase) {
                    var fieldNames = ['activityWork', 'continuingEducation', 'competencies', 'facilities', 'organizationMembership'];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = fieldNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var name = _step.value;

                            if (briefcase[name]) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = briefcase[name][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var briefcaseItem = _step2.value;

                                        if (briefcaseItem.startDate) {
                                            briefcaseItem.startDate = new Date(new Date(briefcaseItem.startDate).getTime() + new Date(briefcaseItem.startDate).getTimezoneOffset() * 60000);
                                        }

                                        if (briefcaseItem.endDate) {
                                            briefcaseItem.endDate = new Date(new Date(briefcaseItem.endDate).getTime() + new Date(briefcaseItem.endDate).getTimezoneOffset() * 60000);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                var confirmedJobs = _.get(jobs, 'confirmedJobs', 0);
                vm.jobs.jobsPercentage = confirmedJobs ? Math.round(_.get(jobs, 'cancelledJobs', 0) / confirmedJobs * 100) : 0;
                vm.userEducation = angular.merge(defaultBriefcase, briefcase);
                vm.submitButtonSign;
                if (vm.currentStep < 3 && vm.roleAccess.nurse === true) {
                    vm.submitButtonSign = 'Finish Briefcase';
                } else {
                    vm.submitButtonSign = 'Save Briefcase';
                }
                var skills = _this.ehrSkillsData.filter(function (_ref2) {
                    var label = _ref2.label;
                    return vm.userEducation.ehrSkills.includes(label);
                });
                vm.ehrSkills = angular.copy(skills);

                var fitleredEducationList = educationConstants.EDUCATION.filter(function (education) {
                    return !education.onlyForProfession || education.onlyForProfession == profession;
                }).map(function (education) {
                    return education.name;
                });
                vm.educationList = angular.copy(fitleredEducationList);
                if (vm.roleAccess.nurse === true && vm.currentStep < 3) {
                    $timeout(function () {
                        educationPopUp = ngDialog.open({
                            template: 'educationPopUp',
                            className: 'ngdialog-theme-default documentation-dialog',
                            closeByNavigation: true,
                            scope: $scope,
                            closeByDocument: false,
                            closeByEscape: false
                        });
                    }, 500);
                }
                loader.hide();
                $scope.$apply();
            });
        };

        Date.prototype.toCustomISOString = function () {
            return moment(this).format('YYYY-MM-DDT00:00:00.000') + 'Z';
        };

        Object.defineProperty(vm, 'resumeFileName', {
            get: function get() {
                return _.get(vm, 'userEducation.workExperience.resumeFileId') || _.get(vm, 'userEducation.workExperience.resumeFileUrl') ? 'Resume' : '';
            }
        });

        vm.openEducationDatePicker = function (form, index, date) {
            var formName = form.$name;
            var maxDate = date === 'startDate' ? vm.userEducation[formName][index].endDate : null;
            var minDate = date === 'endDate' ? vm.userEducation[formName][index].startDate : null;
            $('.bt-' + date + formName).daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                maxDate: maxDate,
                minDate: minDate,
                startDate: vm.userEducation[formName][index][date],
                autoApply: true,
                "opens": "left",
                autoclose: true
            }, function (start) {
                $scope.$applyAsync(function () {
                    form[index].$setDirty();
                    vm.userEducation[formName][index][date] = start.toDate();
                });
            });
        };

        vm.addNewEducationDocument = function () {
            vm.userEducation.educationDocuments.push({});
        };

        vm.removeEducationDocument = function (index) {
            if (vm.userEducation.educationDocuments[index].id) {
                vm.deletedEducationDocuments.push(vm.userEducation.educationDocuments[index].id);
            }
            vm.userEducation.educationDocuments.splice(index, 1);
        };

        vm.addNewContinuingEducation = function (index) {
            vm.userEducation.continuingEducation.push({});
        };

        vm.removeContinuingEducation = function (index) {
            if (vm.userEducation.continuingEducation[index].id) {
                vm.deletedContinuingEducation.push(vm.userEducation.continuingEducation[index].id);
            }
            vm.userEducation.continuingEducation.splice(index, 1);
        };

        vm.addNewCompetencies = function () {
            vm.userEducation.competencies.push({});
        };

        vm.removeCompetencies = function (index) {
            if (vm.userEducation.competencies[index].id) {
                vm.deletedCompetencies.push(vm.userEducation.competencies[index].id);
            }
            vm.userEducation.competencies.splice(index, 1);
        };

        vm.addNewProOrgMembership = function () {
            vm.userEducation.organizationMembership.push({});
        };

        vm.removeProOrgMembership = function (index) {
            if (vm.userEducation.organizationMembership[index].id) {
                vm.deletedProOrgMemberships.push(vm.userEducation.organizationMembership[index].id);
            }
            vm.userEducation.organizationMembership.splice(index, 1);
        };

        vm.addNewProjectProActivityWork = function (index) {
            vm.userEducation.activityWork.push({});
        };

        vm.removeProjectProActivityWork = function (index) {
            if (vm.userEducation.activityWork[index].id) {
                vm.deletedActivityWork.push(vm.userEducation.activityWork[index].id);
            }
            vm.userEducation.activityWork.splice(index, 1);
        };

        vm.addNewEducation = function (index) {
            vm.userEducation.education.push({});
        };

        vm.removeEducation = function (index) {
            if (vm.userEducation.education[index].id) {
                vm.deletedEducation.push(vm.userEducation.education[index].id);
            }
            vm.userEducation.education.splice(index, 1);
        };

        vm.addNewReferences = function () {
            vm.userEducation.references.push({});
        };

        vm.removeReferences = function (index) {
            if (vm.userEducation.references[index].id) {
                vm.deletedReferences.push(vm.userEducation.references[index].id);
            }
            vm.userEducation.references.splice(index, 1);
        };

        vm.addNewFacilities = function () {
            vm.userEducation.facilities.push({});
        };

        vm.removeFacilities = function (index) {
            if (vm.userEducation.facilities[index].id) {
                vm.deletedFacilities.push(vm.userEducation.facilities[index].id);
            }
            vm.userEducation.facilities.splice(index, 1);
        };

        vm.validateYearTo = function (index, field) {
            if (vm.userEducation.education[index].yearFrom - vm.userEducation.education[index].yearTo > 0) {
                vm.userEducation.education[index][field] = undefined;
            }
        };

        $scope.invokeUpload = function (index) {
            var uploadElement = document.getElementById(index);
            uploadElement.click();
        };

        $scope.closePopup = function (dialogId) {
            ngDialog.close(dialogId);
        };

        vm.onUpload = function (form, item, idField, urlField, recordType, attachmentType) {
            var file = this.files[0];
            if (file) {
                if (file.size / 1e+6 > 10) {
                    return toastr.error('File is too large');
                }

                var isPermanent = recordType === 'Resume' || !!item.id && item.isPermanent !== false;

                if (form && !isPermanent) {
                    form.$setDirty();
                }

                var upload = {
                    recordId: item[idField] || item.id,
                    file: file,
                    fileName: attachmentType
                };

                if (isPermanent) {
                    upload.recordType = recordType;
                    upload.attachmentType = attachmentType;
                    upload.isPermanent = true;
                    upload.userId = briefcaseService.briefcase.id;
                    upload.permissions = 51; 
                } else {
                    item.isPermanent = false;
                }

                loader.show();
                recordService.upload(briefcaseConstants.ACCESS_TOKEN, upload).then(function (_ref3) {
                    var downloadUrl = _ref3.downloadUrl,
                        recordId = _ref3.recordId,
                        tempFileName = _ref3.tempFileName;

                    if (!item.id && recordType !== 'Resume') {
                        item.id = recordId;
                    }

                    item[idField] = recordId;
                    item[urlField] = downloadUrl;

                    if (!isPermanent) {
                        if (!item.attachments) {
                            item.attachments = {};
                        }

                        item.attachments[attachmentType] = {
                            fileName: attachmentType,
                            tempFileName: tempFileName
                        };
                    }

                    toastr.success('File successfully uploaded');
                }).catch(function (e) {
                    return toastr.error(e.message);
                }).finally(function () {
                    return loader.hide();
                });
            }
        };

        var referencWatch = $scope.$watch(function () {
            return vm && vm.userEducation && vm.userEducation.references;
        }, function (newVal, oldVal) {
            console.log('reference change', newVal, oldVal);
            if (newVal && oldVal) {
                var newArray = newVal.map(function (_ref4) {
                    var $$hashKey = _ref4.$$hashKey,
                        phoneNumber = _ref4.phoneNumber,
                        keepAttrs = _objectWithoutProperties(_ref4, ['$$hashKey', 'phoneNumber']);

                    return keepAttrs;
                });
                var oldArray = oldVal.map(function (_ref5) {
                    var $$hashKey = _ref5.$$hashKey,
                        phoneNumber = _ref5.phoneNumber,
                        keepAttrs = _objectWithoutProperties(_ref5, ['$$hashKey', 'phoneNumber']);

                    return keepAttrs;
                });

                if (!vm.enableRefValidation) {
                    vm.enableRefValidation = !angular.equals(newArray, oldArray);
                }
                if (vm.enableRefValidation) {
                    referencWatch();
                }
            }
        }, true);

        function updateBriefcaseItem(recordType, recordIdField, form, items, deletedItems, urlFields, dateFields) {
            var work = [];

            if (form.$dirty) {
                var _loop = function _loop(i) {
                    if (form[i].$dirty) {
                        var data = angular.copy(items[i]);
                        var recordId = void 0;
                        var attachments = data.attachments;
                        delete data.attachments;
                        delete data.isPermanent;

                        if (recordIdField && data[recordIdField]) {
                            recordId = data[recordIdField];
                            delete data[recordIdField];
                        } else {
                            recordId = data.id;
                        }

                        if (urlFields) {
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = urlFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var field = _step3.value;

                                    delete data[field];
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }

                        if (dateFields) {
                            var _iteratorNormalCompletion4 = true;
                            var _didIteratorError4 = false;
                            var _iteratorError4 = undefined;

                            try {
                                for (var _iterator4 = dateFields[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    var _field = _step4.value;

                                    if (data[_field]) {
                                        data[_field] = new Date(data[_field].getTime() - data[_field].getTimezoneOffset() * 60000);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                    }
                                } finally {
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                        }

                        delete data.id;

                        var hasValidData = Object.values(data || {}).filter(Boolean).length > 0;
                        if (hasValidData || attachments) {
                            work.push(recordService.upsert(briefcaseConstants.ACCESS_TOKEN, {
                                recordType: recordType,
                                recordId: recordId,
                                attachments: attachments,
                                userId: briefcaseService.briefcase.id,
                                permissions: 51, 
                                data: data
                            }).then(function () {
                                form[i].$setPristine();
                                form[i].$setUntouched();
                            }));
                        }
                    }
                };

                for (var i = 0; i < items.length; ++i) {
                    _loop(i);
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                var _loop2 = function _loop2() {
                    var recordId = _step5.value;

                    work.push(recordService.delete(briefcaseConstants.ACCESS_TOKEN, recordId, false, briefcaseService.briefcase.id, recordType).then(function () {
                        var index = deletedItems.indexOf(recordId);

                        if (index !== -1) {
                            deletedItems.splice(index, 1);
                        }
                    }));
                };

                for (var _iterator5 = deletedItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    _loop2();
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return work;
        }

        vm.onSubmit = function (form) {
            var resumeFile = _.get(vm, 'userEducation.workExperience.resumeFileId') || _.get(vm, 'userEducation.workExperience.resumeFileUrl');

            if (form.$invalid || !resumeFile) {
                if (form['$error'] && form['$error'].pattern) {
                    if (form['$error'].pattern[0]["$name"] === "workExperienceLinkedInUrl") {
                        angular.element('.linkedinurl')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].pattern[0]["$name"] === "activityWork") {
                        angular.element('.projectDetails')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].pattern[0]["$name"] === "education") {
                        angular.element('.educationCoursework')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].pattern[0]["$name"] === "continuingEducation") {
                        angular.element('.continuingEducationCoursework')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].pattern[0]["$name"] === "competencies") {
                        angular.element('.competenciesContent')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                }

                if (form['$error'] && form['$error'].required) {
                    if (form['$error'].required[0]["$name"] === "yearsOfExperience") {
                        angular.element('.yearsOfExperience')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].required[0]["$name"] === "references") {
                        angular.element('.references')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].required[0]["$name"] === "workExperienceResume") {
                        angular.element('.workExperienceResume')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                    if (form['$error'].required[0]["$name"] === "continuingEducation") {
                        angular.element('.continuingEducationTitle')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                }
                return toastr.error('Please fill the required details!');
            }

            var copy = _extends({}, briefcaseUtil.cleanObject(_extends({
                ehrSkills: vm.ehrSkills.map(function (_ref6) {
                    var label = _ref6.label;
                    return label;
                })
            }, angular.copy(vm.userEducation))), {
                workExperience: angular.copy(vm.userEducation.workExperience)
            });

            delete copy.licensedAt;
            delete copy.consentedAt;
            var options = { item: { briefcase: _extends({}, copy) } };

            if (!briefcaseConstants.isAdminOrHospitalUser) {
                options.item.briefcase.currentStep = vm.currentStep < 3 ? 3 : undefined;
            }

            loader.show();

            var work = [];

            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Education', 'courseworkFileId', form.education, this.userEducation.education, this.deletedEducation, ['courseWorkFileUrl'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Education Document', 'fileId', form.educationDocuments, this.userEducation.educationDocuments, this.deletedEducationDocuments, ['fileUrl'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Reference', '', form.references, this.userEducation.references, this.deletedReferences, [])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Work History', '', form.facilities, this.userEducation.facilities, this.deletedFacilities, [], ['startDate', 'endDate'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Continuing Education', 'certificateFileId', form.continuingEducation, this.userEducation.continuingEducation, this.deletedContinuingEducation, ['courseWorkFileUrl', 'certificateUrl'], ['startDate', 'endDate'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Competency', 'fileId', form.competencies, this.userEducation.competencies, this.deletedCompetencies, [], ['startDate', 'endDate'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Organization Membership', '', form.organizationMembership, this.userEducation.organizationMembership, this.deletedProOrgMemberships, [], ['startDate', 'endDate'])));
            work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Activity Work', 'fileId', form.activityWork, this.userEducation.activityWork, this.deletedActivityWork, ['fileUrl'], ['startDate', 'endDate'])));

            work.push(professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options));

            Promise.allSettled(work).then(function (result) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = result[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var item = _step6.value;

                        if (item.status === 'rejected') {
                            throw item.reason;
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }

                toastr.success('Data was saved successfully');
                form.$setPristine();
                form.$setUntouched();
                $scope.$emit('updateProfile');
                $scope.$emit('$TabWorking', { flag: 3 });
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        vm.syncDocument = function () {
            loader.show();
            var options = {
                'briefcase.education': 1,
                'briefcase.yearsOfExperience': 1,
                'briefcase.workExperience': 1,
                'briefcase.references': 1
            };
            professionalService.sync(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options).then(function () {
                return toastr.success('Education sync completed.');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        vm.download = function (recordId, url, attachmentType) {
            recordService.download({
                auth: briefcaseConstants.ACCESS_TOKEN,
                recordId: recordId,
                url: url,
                attachmentType: attachmentType,
                openWindow: true
            });

            return false;
        };
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('licenseConstants', {

        CERTIFICATION: [{
            'certificationName': "",
            'certifyingBody': "",
            'expiration': '',
            'file': '',
            'digitalBadgeURL': "",
            'courseWorkFile': "",
            'value': '1'
        }],
        CHECK_LICENSE: {
            'licenseType': "",
            'licenseBody': "",
            'practiceState': "",
            'licenseExpirationDate': "",
            'licenseNumber': ""
        },
        MULTIPLE_LICENSE: [{
            'licenseType': "",
            'licenseBody': "",
            'licenseExpirationDate': "",
            'licenseNumber': ""
        }],

        CERTIFICATION_IMAGE: [{
            'flag': false,
            'file': '',
            'size': false,
            'err': ''
        }],
        CERTIFICATION_NAME: [{
            'id': '0',
            'label': 'None',
            'value': 'None'
        }],
        ADDITIONAL_CERTIFICATION: [{
            "certId": 'c12',
            "value": "1",
            "label": "CPR",
            "isFavorite": true,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c13',
            "value": "2",
            "label": "BLS",
            "isFavorite": true,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        },
        {
            "certId": 'c15',
            "value": "4",
            "label": "ALS/ACLS",
            "isFavorite": true,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c22',
            "value": "11",
            "label": "PALS",
            "isFavorite": true,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c16',
            "value": "5",
            "label": "PICC",
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c17',
            "value": "6",
            "label": "TNCC",
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c18',
            "value": "7",
            "label": "ENPC",
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c19',
            "value": "8",
            "label": "STABLE",
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c20',
            "value": "9",
            "label": "NRP", 
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }, {
            "certId": 'c21',
            "value": "10",
            "label": "Others",
            "isFavorite": false,
            "checked": false,
            "fav_checked": false,
            "eCard": '',
            "certName": '',
            "backFile": false,
            "file": false,
            "expire_date": ''
        }]

    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').directive('licenseBriefcase', licenseBriefcase);

    licenseBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];
    function licenseBriefcase($window, briefcaseUtil, briefcaseConstants) {
        return {
            template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
            scope: {
                viewType: '@'
            },
            transclude: true,
            controller: 'licenseCtrl as licenseCtrl',
            link: function link($scope, $elm, $attrs, licenseCtrl) {

                $scope.getTemplateUrl = function () {
                    return 'license/license-' + $attrs.viewType + '.html';
                };

                licenseCtrl.init();

                $scope.updateTemplate = function (viewType) {
                    $attrs.viewType = viewType;
                    $scope.getTemplateUrl();
                    licenseCtrl.init(); 
                };
            }
        };
    }
})();
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
    'use strict';

    angular.module('praos.briefcase').controller('licenseCtrl', ['$scope', 'briefcaseService', 'ngDialog', 'toastr', 'briefcaseConstants', 'professionalService', 'licenseTypeService', 'licenseBodyService', 'specialtyService', 'certificationService', 'certifyingBodyService', 'additionalCertificationService', 'recordService', 'loader', function ($scope, briefcaseService, ngDialog, toastr, briefcaseConstants, professionalService, licenseTypeService, licenseBodyService, specialtyService, certificationService, certifyingBodyService, additionalCertificationService, recordService, loader) {
        var _this = this;

        $scope.unsavedLicenses = new Set();
        $scope.prLicenseHasChanges = false;
        $scope.role = briefcaseService.userRole;
        $scope.licensedAt = false;
        $scope.showSpecialties = false;
        $scope.showProfessionalCertificates = false;
        $scope.isAdminOrHospitalUser = briefcaseConstants.isAdminOrHospitalUser;
        $scope.deletedCertificates = [];
        $scope.deletedAddCertificates = [];
        $scope.addCertsWithoutFiles = [];
        $scope.addCertsWithoutFilesIndices = [];
        $scope.profession = '';
        $scope.affiliatedOrganization = '';
        $scope.roleAccess = angular.copy(briefcaseService.roleAccess);

        this.openBriefcase = function () {
            var SB_URL = briefcaseConstants.SB_URL + '/' + briefcaseService.briefcase.id + '?authToken=' + briefcaseConstants.ACCESS_TOKEN;
            console.log("Briefcase url", SB_URL);
            window.open(SB_URL);
            return false;
        };

        $scope.$on('licenseHasChanges', function (_, lic, has, newLic) {
            var ind = $scope.licenses.indexOf(lic);
            if (newLic.expirationDate) {
                newLic.expirationDate = convertFromUTC(newLic.expirationDate);
            }
            if (newLic.issueDate) {
                newLic.issueDate = convertFromUTC(newLic.issueDate);
            }
            has && Object.keys(newLic).length > 1 ? $scope.unsavedLicenses.add(ind) : $scope.unsavedLicenses.delete(ind);
        });

        $scope.$on('prLicenseHasChanges', function (_, has) {
            $scope.prLicenseHasChanges = has;
        });
        this.uniqMergeBy = function (arr1, arr2, field) {
            var mergedMap = [].concat(_toConsumableArray(arr1), _toConsumableArray(arr2)).reduce(function (acc, item) {
                acc.set(item[field], Object.assign(acc.get(item[field]) || {}, item));
                return acc;
            }, new Map());
            return Array.from(mergedMap.values());
        };
        $scope.isEditable = briefcaseConstants.isEditable;

        $scope.addNewLicense = function () {
            $scope.licenses = [].concat(_toConsumableArray($scope.licenses), [null]);
        };

        $scope.primaryLicenseSave = async function (response) {
            if (response.expirationDate) {
                response.expirationDate = convertFromUTC(response.expirationDate);
            }
            if (response.issueDate) {
                response.issueDate = convertFromUTC(response.issueDate);
            }
            if (!response.verifiedAt && response.verificationText && response.verificationText !== 'Verified manually') {
                if (!$scope.licensedAt) {
                    toastr.error('Your license couldn\u2019t be verified electronically, we will attempt to verify manually.\n                            Please continue to complete your profile.');
                } else {
                    toastr.error(response.verificationText);
                }
            } else if (response !== 'enableUserOnTimeOut') {
                toastr.success('License verified successfully!');
            }
            if (!$scope.licensedAt) {
                await _this.init();
                if (response !== 'enableUserOnTimeOut') {
                    $scope.licensetTabInfoPopUp = ngDialog.open({
                        template: 'licensetTabInfoPopUp',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: false,
                        closeByEscape: false
                    });
                }
            }
            $scope.licensedAt = true;
            $scope.$apply();
        };

        $scope.downloadFile = function (e, recordId, url, attachmentType) {
            e.preventDefault();
            recordService.download({
                auth: briefcaseConstants.ACCESS_TOKEN,
                recordId: recordId,
                attachmentType: attachmentType,
                url: recordId ? undefined : url,
                openWindow: true
            });

            return false;
        };

        $scope.closeModal = function () {
            ngDialog.closeAll();
        };

        $scope.specialityDropDownText = {
            searchPlaceholder: 'Search Specialty',
            maxLimitText: 'Limit Reached (10 Specialty Max)'
        };

        $scope.openLicenseHistory = function () {
            ngDialog.open({
                template: 'license/license-history.html',
                className: 'ngdialog-theme-default ngdialog-model-panel-phistory documentation-dialog',
                showClose: false,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope
            });
        };

        $scope.openCertificationHistory = function () {
            ngDialog.open({
                template: 'license/certification-history.html',
                className: 'ngdialog-theme-default ngdialog-model-panel-phistory documentation-dialog',
                showClose: false,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope
            });
        };

        $scope.openAdditionalCertificationHistory = function () {
            ngDialog.open({
                template: 'license/additional-certification-history.html',
                className: 'ngdialog-theme-default ngdialog-model-panel-phistory documentation-dialog',
                showClose: false,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope
            });
        };

        $scope.hasUnsaved = function () {
            return $scope.licenses.includes(null);
        };

        $scope.addNewCertificate = function () {
            $scope.certificates.push({ certifyingBody: 'None' });
        };

        $scope.isInvalid = function (form) {
            var invalidAddCerts = $scope.additionalCertificationsList.some(function (_ref) {
                var isActive = _ref.isActive,
                    expirationDate = _ref.expirationDate;
                return isActive && !expirationDate;
            });
            var specialtiesInvalid = !$scope.isAlliedHealth && !$scope.specialities.length;
            return form.$invalid || specialtiesInvalid || invalidAddCerts;
        };

        function clean(obj) {
            for (var propName in obj) {
                if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
                    delete obj[propName];
                }
            }
            return obj;
        }

        $scope.onSubmit = async function (form) {
            var addCertsNotFormatted = $scope.additionalCertificationsList.map(function (i) {
                var certification = _.pick(i, ['id', 'isActive', 'name', 'expirationDate', 'eCardNumber', 'label', 'frontFileId', 'backFileId', 'frontFileUrl', 'backFileUrl', 'attachments']);
                if (certification.expirationDate) {
                    certification.expirationDate = convertToUTC(certification.expirationDate);
                }
                return certification;
            });
            $scope.deletedAddCertificates = $scope.additionalCertificationsList.filter(function (_ref2) {
                var id = _ref2.id,
                    isActive = _ref2.isActive;
                return !!id && !isActive;
            }).map(function (cert) {
                return cert.id;
            });

            var addCerts = addCertsNotFormatted.map(function (obj) {
                return clean(obj);
            });

            $scope.addCertsWithoutFilesIndices = [];
            addCerts.map(function (cert, i) {
                if (!cert.expirationDate) {
                    $scope.addCertsWithoutFilesIndices.push(i);
                    return cert;
                }
            });

            if ($scope.isInvalid(form)) {
                if ($scope.addCertsWithoutFilesIndices.length) {
                    var targetIndex = Math.min.apply(Math, _toConsumableArray($scope.addCertsWithoutFilesIndices));
                    angular.element('additional-certificate')[targetIndex].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                }
                if (form['$error'] && form['$error'].required) {
                    var splits = form['$error'].required[0]["$name"].split("name");
                    if (splits[0] === "") {
                        angular.element('.certifyingName')[Number(splits[1] || 0)].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                    }
                }

                return toastr.error('Please fill the required details!');
            }

            if ($scope.prLicenseHasChanges) {
                angular.element('primary-license')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                return toastr.warning('Please save your primary license');
            }

            if ($scope.unsavedLicenses.size) {
                var _targetIndex = Math.min.apply(Math, _toConsumableArray(Array.from($scope.unsavedLicenses.values())));
                angular.element('license')[_targetIndex].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
                return toastr.warning('Please save your licenses changes');
            }

            var certs = $scope.certificates.filter(function (_ref3) {
                var certifyingBody = _ref3.certifyingBody;
                return certifyingBody !== 'None';
            }).map(function (item) {
                var cert = _.pick(item, ['id', 'certifyingBody', 'digitalBadgeUrl', 'expirationDate', 'name', 'fileId', 'courseworkFileId', 'attachments']);
                if (cert.expirationDate) {
                    cert.expirationDate = convertToUTC(cert.expirationDate);
                }
                return cert;
            });
            if ($scope.isAlliedHealth) {
                $scope.specialities = [];
            }
            var options = {
                item: {
                    briefcase: {
                        specialties: $scope.specialities.filter(function (sp) {
                            return sp !== 'None';
                        })
                    }
                },
                select: {
                    'briefcase.certifications': 1,
                    'briefcase.specialties': 1,
                    'briefcase.additionalCertifications': 1
                }
            };
            if (!briefcaseConstants.isAdminOrHospitalUser) {
                options.item.briefcase.currentStep = $scope.briefcase.currentStep < 2 ? 2 : undefined;
            }
            loader.show();

            var work = [];

            if (form.professionalCertificates) {
                work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Certification', 'fileId', form.professionalCertificates, certs, $scope.deletedCertificates, ['fileUrl', 'courseWorkFileUrl'])));
            }
            if (form.additionalCertificates) {
                work.push.apply(work, _toConsumableArray(updateBriefcaseItem('Additional Certification', 'frontFileId', form.additionalCertificates, addCerts, $scope.deletedAddCertificates, ['frontFileUrl', 'backFileUrl'])));
            }

            work.push(professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options));

            Promise.allSettled(work).then(function (result) {
                for (var i = 0; i < result.length; i++) {
                    if (result[i].status === 'rejected') {
                        throw result[i].reason;
                    }
                }

                toastr.success('Data was saved successfully');
                $scope.$emit('updateProfile');
                form.$setPristine();
                form.$setUntouched();

                $scope.addCertsWithoutFiles = [];
                $scope.addCertsWithoutFilesIndices = [];
                if (addCerts && addCerts.length) {
                    $scope.addCertsWithoutFiles = addCerts.filter(function (cert, i) {
                        if (cert.isActive && !(cert.frontFileUrl || cert.frontFileId) && !(cert.backFileUrl || cert.backFileId)) {
                            $scope.addCertsWithoutFilesIndices.push(i);
                            return cert;
                        }
                    });
                }

                if (!certs.length && !addCerts.length) {
                    $scope.certMissingPopUp = ngDialog.open({
                        template: 'certMissingPopUp',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: false,
                        closeByEscape: false
                    });
                } else if ($scope.addCertsWithoutFiles.length > 0) {
                    $scope.certFilesMissingPopUp = ngDialog.open({
                        template: 'certFilesMissingPopUp',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: false,
                        closeByEscape: false
                    });
                } else {
                    $scope.$emit('$TabWorking', { flag: 2 });
                }
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        function updateBriefcaseItem(recordType, recordIdField, form, items, deletedItems, urlFields) {
            var work = [];
            if (form && form.$dirty) {
                for (var i = 0; i < items.length; ++i) {
                    if (form[i] && form[i].$dirty) {
                        var data = angular.copy(items[i]);
                        var recordId = void 0;
                        var attachments = data.attachments;
                        delete data.attachments;

                        if (recordType == 'Additional Certification') {
                            if (!data.isActive) {
                                continue;
                            }
                            delete data.isActive;
                            delete data.frontFileUrl;
                            delete data.backFileUrl;
                        }

                        if (recordIdField && data[recordIdField]) {
                            recordId = data[recordIdField];
                            delete data[recordIdField];
                        } else {
                            recordId = data.id;
                        }

                        delete data.id;
                        if (urlFields) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = urlFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var field = _step.value;

                                    delete data[field];
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }

                        var hasValidData = Object.values(data || {}).filter(Boolean).length > 0;
                        if (hasValidData || attachments) {
                            work.push(recordService.upsert(briefcaseConstants.ACCESS_TOKEN, {
                                recordType: recordType,
                                recordId: recordId,
                                attachments: attachments,
                                userId: briefcaseService.briefcase.id,
                                permissions: 51, 
                                data: data
                            }));
                        }
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var recordId = _step2.value;

                    work.push(recordService.delete(briefcaseConstants.ACCESS_TOKEN, recordId, false, briefcaseService.briefcase.id, recordType).then(function () {
                        var index = deletedItems.indexOf(recordId);

                        if (index !== -1) {
                            deletedItems.splice(index, 1);
                        }
                    }));
                };

                for (var _iterator2 = deletedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return work;
        }

        $scope.$watch('profession', function (newVal) {
            $scope.isAlliedHealth = newVal === 'Allied Health';
            if ($scope.isAlliedHealth) {
                $scope.specialities = [];
            }
        });

        function convertToUTC(input) {
            if (!input) return null;

            var utcMoment = void 0;
            if (typeof input === 'number') {
                utcMoment = moment.utc(input);
            } else {
                utcMoment = moment.utc(new Date(input));
            }

            return typeof input === 'number' ? utcMoment.valueOf() : utcMoment.toISOString();
        }

        function convertFromUTC(input) {
            if (!input) return null;

            var localMoment = void 0;
            if (typeof input === 'number') {
                localMoment = moment.utc(input).local();
            } else {
                localMoment = moment.utc(new Date(input)).local();
            }

            return typeof input === 'number' ? localMoment.valueOf() : localMoment.format();
        }

        $scope.CertFileModalOk = function () {
            ngDialog.closeAll();
            var targetIndex = Math.min.apply(Math, _toConsumableArray($scope.addCertsWithoutFilesIndices));
            angular.element('additional-certificate')[targetIndex].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
        };

        $scope.CertModalOk = function () {
            ngDialog.closeAll();
            angular.element('additional-certificate')[0].scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
        };

        $scope.closeCertFileModal = function () {
            ngDialog.closeAll();
            $scope.$emit('$TabWorking', { flag: 2 });
        };

        $scope.removeLicense = function (target) {
            var ind = $scope.licenses.indexOf(target);
            $scope.unsavedLicenses.delete(ind);
            $scope.licenses.splice(ind, 1);
        };

        $scope.removeCertificate = function (index) {
            if ($scope.certificates[index].id) {
                $scope.deletedCertificates.push($scope.certificates[index].id);
            }
            $scope.certificates.splice(index, 1);
        };

        $scope.saveLicense = function (target) {
            var index = $scope.licenses.findIndex(function (l) {
                return !l || target.id === l.id;
            });
            $scope.unsavedLicenses.delete(index);
            if (target.expirationDate) {
                target.expirationDate = convertToUTC(target.expirationDate);
            }

            if (target.issueDate) {
                target.issueDate = convertToUTC(target.issueDate);
            }

            $scope.licenses[index] = target;
        };

        $scope.calculateDetailsRequired = function (license) {
            if (!license || !$scope.types) {
                return true;
            }
            var licenseType = $scope.types.find(function (type) {
                return type.abbr === license.licenseType;
            });
            return licenseType && licenseType.detailsRequired;
        };

        this.init = async function () {
            var _this2 = this;

            loader.show();
            var selectOptions = {
                select: {
                    'affiliations': 1,
                    'briefcase.licenses': 1,
                    'briefcase.licensedAt': 1,
                    'briefcase.licenseHistory': 1,
                    'briefcase.certificationHistory': 1,
                    'briefcase.certifications': 1,
                    'briefcase.currentStep': 1,
                    'briefcase.consentedAt': 1,
                    'briefcase.additionalCertifications': 1,
                    'briefcase.additionalCertificationsHistory': 1,
                    'briefcase.specialties': 1,
                    'jobs.cancelledJobs': 1,
                    'jobs.confirmedJobs': 1,
                    'jobs.competentReviews': 1,
                    'jobs.professionalReviews': 1,
                    'jobs.skilledReviews': 1,
                    'dateOfBirth': 1,
                    'ssn': 1,
                    'profession': 1
                }
            };

            var professional = await professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, selectOptions);
            $scope.profession = professional.profession;
            $scope.isAlliedHealth = $scope.profession === 'Allied Health';
            professional.briefcase && professional.briefcase.licenses && professional.briefcase.licenses.forEach(function (license) {
                if (license.expirationDate) {
                    license.expirationDate = convertFromUTC(license.expirationDate);
                }
                if (license.issueDate) {
                    license.issueDate = convertFromUTC(license.issueDate);
                }
            });
            professional.briefcase && professional.briefcase.certifications && professional.briefcase.certifications.forEach(function (certification) {
                if (certification.expirationDate) {
                    certification.expirationDate = convertFromUTC(certification.expirationDate);
                }
            });
            if (professional.affiliations && professional.affiliations.length === 1) {
                $scope.affiliatedOrganization = professional.affiliations[0].organization._id;
            }
            return Promise.all([licenseTypeService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession), licenseBodyService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession), specialtyService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession), certificationService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession), certifyingBodyService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession), additionalCertificationService.list(briefcaseConstants.ACCESS_TOKEN, professional.profession)]).then(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 6),
                    types = _ref5[0],
                    states = _ref5[1],
                    specialities = _ref5[2],
                    certificationNames = _ref5[3],
                    certificationBodies = _ref5[4],
                    additionalCertifications = _ref5[5];

                $scope.types = types;
                $scope.states = states;
                $scope.certificationNames = certificationNames;
                $scope.certificationBodies = certificationBodies;
                $scope.showProfessionalCertificates = certificationBodies ? certificationBodies.length >= 1 : false;

                if (professional.briefcase) {
                    $scope.briefcase = professional.briefcase;
                    $scope.licenseHistory = professional.briefcase.licenseHistory;
                    $scope.certificationHistory = professional.briefcase.certificationHistory;
                    $scope.additionalCertifications = additionalCertifications;
                    $scope.additionalCertificationHistory = professional.briefcase.additionalCertificationHistory;
                    $scope.specialities = professional.briefcase.specialties || ['None'];
                    $scope.specialtiesView = _.get(professional.briefcase, 'specialties', []).join(', ');
                    $scope.specialitiesList = ['None'].concat(_toConsumableArray(specialities.map(function (_ref6) {
                        var name = _ref6.name;
                        return name;
                    })));
                    $scope.showSpecialties = specialities.length >= 1;
                    $scope.jobs = professional.jobs;
                    var confirmedJobs = _.get(professional.jobs, 'confirmedJobs', 0);
                    $scope.jobsPercentage = confirmedJobs ? Math.round(_.get(professional.jobs, 'cancelledJobs', 0) / confirmedJobs * 100) : 0;
                    var briefcaseCerts = _.get(professional.briefcase, 'additionalCertifications', []).map(function (i) {
                        var diff = moment(i.expirationDate).diff(moment(), 'days');
                        return _extends({}, i, {
                            expirationTooltip: diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null,
                            expiredTooltip: diff < 0 ? 'Expired' : null
                        });
                    });
                    $scope.certificationsView = _.get(professional.briefcase, 'certifications', []);
                    $scope.certificationsView.forEach(function (cert) {
                        var diff = moment(cert.expirationDate).diff(moment(), 'days');
                        cert.expirationTooltip = diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null;
                        cert.expiredTooltip = diff < 0 ? 'Expired' : null;
                    });
                    $scope.additionalCertificationsList = _.orderBy(_this2.uniqMergeBy(briefcaseCerts, angular.copy($scope.additionalCertifications), 'name'), ['isAha', 'isOther'], ['asc', 'desc']);

                    $scope.primaryLicense = professional.briefcase.licenses && professional.briefcase.licenses[0];
                    if ($scope.primaryLicense) {
                        Object.assign($scope.primaryLicense, { ssn: professional.ssn, dateOfBirth: professional.dateOfBirth });
                    }
                    $scope.licenses = professional.briefcase.licenses ? professional.briefcase.licenses.slice(1) : [];
                    $scope.certificates = _.get(professional.briefcase, 'certifications', [{ certifyingBody: 'None' }]);
                    $scope.licensedAt = professional.briefcase.licensedAt;
                }

                loader.hide();
                $scope.$apply();
            });
        };

        this.syncDocument = function () {
            loader.show();
            var options = {
                'briefcase.licenses': 1,
                'briefcase.specialties': 1,
                'briefcase.certifications': 1,
                'briefcase.additionalCertifications': 1
            };
            professionalService.sync(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options).then(function () {
                return toastr.success('Licenses sync completed.');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };
    }]);
})();
'use strict';

(function () {
  'use strict';

  angular.module('praos.briefcase').directive('otherBriefcase', otherBriefcase);

  otherBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];
  function otherBriefcase($window, briefcaseUtil, briefcaseConstants) {
    return {
      template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
      scope: {
        viewType: '@'
      },
      transclude: true,
      controller: 'otherCtrl as otherCtrl',
      link: function link($scope, $elm, $attrs, otherCtrl) {
        $scope.getTemplateUrl = function () {
          return 'other/other-' + $attrs.viewType + '.html';
        };

        otherCtrl.init();
      }
    };
  }
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    'use strict';

    angular.module('praos.briefcase').controller('otherCtrl', ['$scope', 'briefcaseService', 'briefcaseUtil', 'loader', '$document', 'toastr', '$rootScope', '$timeout', 'briefcaseConstants', 'professionalService', 'organizationService', 'jobService', 'workflowEngineService', function ($scope, briefcaseService, briefcaseUtil, loader, $document, toastr, $rootScope, $timeout, briefcaseConstants, professionalService, organizationService, jobService, workflowEngineService) {

        var vm = this;

        vm.init = function () {
            loader.show();
            vm.nameRegex = briefcaseConstants.NAME_REGEX;
            vm.phoneNumberRegex = briefcaseConstants.PHONE_NUMBER_REGEX;
            vm.emailRegex = briefcaseConstants.EMAIL_REGEX;
            var selectOptions = {
                select: {
                    'jobs.newJobEmail': 1,
                    'jobs.newJobSms': 1,
                    'jobs.dnrOrganizations': 1,
                    'emailCommunicationEnabled': 1,
                    'affiliations': 1,
                    'affiliations.consentedAt': 1,
                    'createdAt': 1,
                    'briefcase.completedAt': 1,
                    'briefcase.consentedAt': 1,
                    'createdBy': 1,
                    'isMarketplace': 1,
                    'briefcase.licensedAt': 1,
                    'briefcase.licenses': 1,
                    'signupIpAddress': 1,
                    'signupChannel': 1,
                    'activatedAt': 1,
                    'facebookId': 1,
                    'linkedInId': 1
                }
            };

            professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, selectOptions).then(function (res) {
                vm.createdAt = res.createdAt;
                vm.activatedAt = res.activatedAt;
                vm.briefcase = res.briefcase;
                vm.affiliations = res.affiliations;
                vm.emailCommunicationEnabled = res.emailCommunicationEnabled;
                vm.signupIpAddress = res.signupIpAddress;
                vm.signupChannel = res.signupChannel;
                vm.isMarketplace = res.isMarketplace;
                vm.signedUp = 'Email';
                var creatorId = _.get(res, 'createdBy._id');
                if (creatorId && creatorId !== res._id) {
                    vm.signedUp = 'IRP';
                } else if (res.facebookId) {
                    vm.signedUp = 'Facebook';
                } else if (res.linkedInId) {
                    vm.signedUp = 'LinkedIn';
                }
                var verifiedBy = _.get(res, 'briefcase.licenses[0].verifiedBy');
                vm.licensedVerifiedDate = _.get(res, 'briefcase.licenses[0].verifiedAt');
                vm.verifiedBy = verifiedBy ? verifiedBy.firstName + ' ' + verifiedBy.lastName : vm.licensedVerifiedDate ? 'System' : '';
                vm.jobs = res.jobs;
                if (vm.jobs && vm.jobs.dnrOrganizations) {
                    vm.dnrOrganizations = vm.jobs.dnrOrganizations;
                } else {
                    vm.dnrOrganizations = [];
                }
                workflowEngineService.listThirdPartyIds(briefcaseConstants.ACCESS_TOKEN, res._id, 'PROFESSIONAL').then(function (idMappings) {
                    vm.idMappings = idMappings;
                    $scope.$apply();
                });
                $scope.$apply();
                loader.hide();
            }).catch(function (e) {
                return toastr.error(e.message);
            });
        };
        vm.refreshSelect = function () {
            $('.selectpicker').selectpicker('refresh');
        };

        vm.changeNotificationFlag = async function () {
            loader.show();
            var _vm$jobs = vm.jobs,
                newJobEmail = _vm$jobs.newJobEmail,
                newJobSms = _vm$jobs.newJobSms,
                emailCommunicationEnabled = vm.emailCommunicationEnabled;

            try {
                var options = { item: { emailCommunicationEnabled: emailCommunicationEnabled, jobs: { newJobEmail: +newJobEmail, newJobSms: newJobSms } } };
                await professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options);
                toastr.success("Settings changed successfully!");
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };

        vm.affiliationModal = async function (affiliation) {
            vm.organizations = null;
            loader.show();
            try {
                var _ref = await organizationService.list(briefcaseConstants.ACCESS_TOKEN, { select: { name: 1, intId: 1 }, status: 'APPROVED' }),
                    list = _ref.list;

                vm.organizations = list;
                if (affiliation) {
                    $scope.isNew = false;
                    var phoneNumber = _.get(affiliation, 'recruiter.phoneNumber');
                    var firstName = _.get(affiliation, 'recruiter.firstName');
                    var lastName = _.get(affiliation, 'recruiter.lastName');
                    var userName = firstName ? firstName + ' ' : '';
                    if (lastName) {
                        userName = userName + lastName;
                    }
                    var irp = !!_.get(affiliation, 'acceptedAt');
                    $scope.initialIRP = irp;
                    $scope.currentAffiliation = {
                        name: userName,
                        email: _.get(affiliation, 'recruiter.email'),
                        phoneNumber: phoneNumber ? [phoneNumber.slice(0, 3), '-', phoneNumber.slice(3, 6), '-', phoneNumber.slice(6)].join('') : '',
                        irp: irp,
                        organizationId: _.get(affiliation, 'organization._id')
                    };
                } else {
                    var _irp = true;
                    $scope.initialIRP = _irp;
                    $scope.isNew = true;
                    $scope.currentAffiliation = { irp: _irp };
                }
                $scope.$apply();
                $document.scrollTop(0, 0);
                $timeout(function () {
                    $('.selectpicker').selectpicker('refresh');
                });
                $("#affiliationDialog").modal({ backdrop: 'static', show: true });
                $timeout(function () {
                    $("body > .modal-backdrop.in").remove();
                    $(".modal-dialog").css("z-index", "99999");
                    $("body").removeClass("modal-open");
                }, 300);
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };

        vm.submitAffiliation = async function (form) {
            if (form.$invalid) {
                return toastr.error('Please fill required fields');
            }
            loader.show();

            try {
                var _$scope$currentAffili = $scope.currentAffiliation,
                    organizationId = _$scope$currentAffili.organizationId,
                    irp = _$scope$currentAffili.irp,
                    name = _$scope$currentAffili.name,
                    email = _$scope$currentAffili.email,
                    phoneNumber = _$scope$currentAffili.phoneNumber;

                var actualPhoneNumber = _.isEmpty(phoneNumber) ? '' : phoneNumber.split('-').join('');

                var _ref2 = _.isEmpty(name) ? [] : name.split(' '),
                    _ref3 = _slicedToArray(_ref2, 2),
                    firstName = _ref3[0],
                    lastName = _ref3[1];

                var recruiter = null;
                if (name) {
                    recruiter = {
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNumber: actualPhoneNumber
                    };
                }
                if ($scope.isNew || $scope.initialIRP !== irp) {
                    var affiliation = {
                        organizationId: organizationId,
                        isIrp: irp
                    };
                    if (recruiter) {
                        affiliation.recruiter = recruiter;
                    }
                    await professionalService.addAffiliation(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, affiliation);
                } else {
                    await professionalService.updateAffiliation(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, organizationId, { recruiter: recruiter });
                }
                var selectOptions = { select: { 'affiliations': 1 } };

                var _ref4 = await professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, selectOptions),
                    affiliations = _ref4.affiliations;

                vm.affiliations = affiliations;
                $scope.$apply();
                toastr.success('Affiliation has been ' + ($scope.isNew ? 'added' : 'updated'));
                vm.resetForm(form);
                $("#affiliationDialog").modal('hide');
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };

        vm.resetForm = function (form) {
            form.$setSubmitted();
            form.$setPristine();
            form.$setUntouched();
        };

        vm.openDeleteAffiliationModal = function (affiliation) {
            $scope.currentAffiliation = affiliation;
            $document.scrollTop(0, 0);
            $("#deleteAffiliationModal").modal({ backdrop: 'static', show: true });
            $timeout(function () {
                $("body > .modal-backdrop.in").remove();
                $(".modal-dialog").css("z-index", "99999");
                $("body").removeClass("modal-open");
            }, 300);
        };

        vm.deleteAffiliation = async function () {
            $("#deleteAffiliationModal").modal('hide');

            loader.show();
            try {
                await professionalService.rejectAffiliation(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, _.get($scope, 'currentAffiliation.organization._id'), $scope.rejectionReason);
                var selectOptions = { select: { 'affiliations': 1 } };

                var _ref5 = await professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, selectOptions),
                    affiliations = _ref5.affiliations;

                vm.affiliations = affiliations;
                $scope.rejectionReason = undefined;
                toastr.success('Affiliation has been removed successfully');
                $scope.$apply();
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };

        vm.addRemoveDNROrganization = async function () {
            vm.organizations = null;
            loader.show();
            try {
                var _ref6 = await organizationService.list(briefcaseConstants.ACCESS_TOKEN, { select: { name: 1, intId: 1 }, status: 'APPROVED' }),
                    list = _ref6.list;

                vm.organizations = list;
                vm.addDNR = {};
                vm.addDNR.dnrType = 'CLINICAL';
                $scope.$apply();
                $document.scrollTop(0, 0);
                $timeout(function () {
                    $('.selectpicker').selectpicker('refresh');
                });
                $("#AddDNRDialog").modal({ backdrop: 'static', show: true });
                $timeout(function () {
                    $("body > .modal-backdrop.in").remove();
                    $(".modal-dialog").css("z-index", "99999");
                    $("body").removeClass("modal-open");
                }, 300);
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };

        vm.addRemoveDNRSubmit = async function (flag, orgId) {
            $("#AddDNRDialog").modal('hide');
            loader.show();
            try {
                if (flag == 1) {
                    await jobService.addDnr(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, {
                        organization: vm.addDNR.hospital,
                        dnrType: vm.addDNR.dnrType === "CLINICAL" ? 1 : 0
                    });
                } else {
                    await jobService.deleteDnr(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, orgId);
                }

                var _ref7 = await professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, {
                    select: {
                        'jobs.dnrOrganizations': 1
                    }
                }),
                    jobs = _ref7.jobs;

                if (jobs.dnrOrganizations) {
                    vm.dnrOrganizations = jobs.dnrOrganizations;
                } else {
                    vm.dnrOrganizations = [];
                }

                if (flag == 1) {
                    toastr.success('DNR organization added successfully');
                } else {
                    toastr.success('DNR organization has been removed successfully');
                }
                $scope.$apply();
            } catch (e) {
                toastr.error(e.message);
            } finally {
                loader.hide();
            }
        };
    }]);
})();
'use strict';

(function () {
    'use strict';


    angular.module('praos.briefcase').constant('profileConstants', {
        CITY: [{
            'cityId': '',
            'label': '',
            'stateId': '',
            'latitude': '',
            'longitude': ''
        }],
        CITY_LIST: [{ "cityId": "1", "stateId": "AL", "label": "Ambler", "latitude": "67.46951", "longitude": "67.46951" }, { "cityId": "2", "stateId": "AK", "label": "Atka", "latitude": "52.199167", "longitude": "-174.213333" }, { "cityId": "3", "stateId": "Ak", "label": "Big Lake", "latitude": "61.5842", "longitude": "-149.4401" }, { "cityId": "4", "stateId": "AL", "label": "Akron", "latitude": "32.872354", "longitude": "-87.708558" }, { "cityId": "5", "stateId": "AK", "label": "Camden", "latitude": "", "longitude": "" }, { "cityId": "6", "stateId": "AK", "label": "Green Pond", "latitude": "", "longitude": "" }, { "cityId": "7", "stateId": "TX", "label": "Austin", "latitude": "35.028369", "longitude": "-91.959398" }, { "cityId": "8", "stateId": "OH", "label": "Austin", "latitude": "35.0228369", "longitude": "-91.959398" }, { "cityId": "9", "stateId": "TX", "label": "Sweet Home", "latitude": "", "longitude": "" }, { "cityId": "10", "stateId": "TX", "label": "Cibolo", "latitude": "", "longitude": "" }],
        STATES: {
            "AL": "Alabama",
            "AK": "Alaska",
            "AS": "American Samoa",
            "AZ": "Arizona",
            "AR": "Arkansas",
            "CA": "California",
            "CO": "Colorado",
            "CT": "Connecticut",
            "DE": "Delaware",
            "DC": "District Of Columbia",
            "FM": "Federated States Of Micronesia",
            "FL": "Florida",
            "GA": "Georgia",
            "GU": "Guam",
            "HI": "Hawaii",
            "ID": "Idaho",
            "IL": "Illinois",
            "IN": "Indiana",
            "IA": "Iowa",
            "KS": "Kansas",
            "KY": "Kentucky",
            "LA": "Louisiana",
            "ME": "Maine",
            "MH": "Marshall Islands",
            "MD": "Maryland",
            "MA": "Massachusetts",
            "MI": "Michigan",
            "MN": "Minnesota",
            "MS": "Mississippi",
            "MO": "Missouri",
            "MT": "Montana",
            "NE": "Nebraska",
            "NV": "Nevada",
            "NH": "New Hampshire",
            "NJ": "New Jersey",
            "NM": "New Mexico",
            "NY": "New York",
            "NC": "North Carolina",
            "ND": "North Dakota",
            "MP": "Northern Mariana Islands",
            "OH": "Ohio",
            "OK": "Oklahoma",
            "OR": "Oregon",
            "PW": "Palau",
            "PA": "Pennsylvania",
            "PR": "Puerto Rico",
            "RI": "Rhode Island",
            "SC": "South Carolina",
            "SD": "South Dakota",
            "TN": "Tennessee",
            "TX": "Texas",
            "UT": "Utah",
            "VT": "Vermont",
            "VI": "Virgin Islands",
            "VA": "Virginia",
            "WA": "Washington",
            "WV": "West Virginia",
            "WI": "Wisconsin",
            "WY": "Wyoming"
        },
        FACILITY_TYPE: ["Ambulatory Surgery Center", "Association", "Dialysis Center", "Emergency Response Organization", "Home Health", "Hospital", "Immediate Care/Stand-alone ER", "Long Term Care/ Assisted Living Facility", "Occupational Health", "Outpatient Lab", "Palliative Care/Hospice", "Physician Office/Primary Care", "Public Health/Community Health", "Rehab Care/Sub Acute Care Facility", "School Health", "Staffing Agency", "Telehealth", "Other"]

    });
})();
'use strict';

(function () {
	'use strict';

	angular.module('praos.briefcase').directive('profileBriefcase', profileBriefcase);

	profileBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];

	function profileBriefcase($window, briefcaseUtil, briefcaseConstants) {
		return {
			template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
			scope: {
				profileType: '@'
			},
			transclude: true,
			controller: 'profileCtrl as profileCtrl',
			link: function link($scope, $elm, $attrs, profileCtrl) {
				$scope.getTemplateUrl = function () {
					return 'profile/profile-' + $attrs.profileType + '.html';
				};

				profileCtrl.init();

				$scope.updateTemplate = function (viewType) {
					$attrs.profileType = viewType;
					$scope.getTemplateUrl();
					profileCtrl.init(); 
				};
			}
		};
	}
})();
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
    'use strict';


    angular.module('praos.briefcase').controller('profileCtrl', ['$window', '$timeout', '$scope', '$state', 'briefcaseService', 'profileService', 'profileConstants', 'dropDownConstant', 'briefcaseConstants', 'ngDialog', 'briefcaseUtil', '$document', 'toastr', '$filter', '$localStorage', '$q', '$log', 'professionalService', 'loader', 'cityService', function ($window, $timeout, $scope, $state, briefcaseService, profileService, profileConstants, dropDownConstant, briefcaseConstants, ngDialog, briefcaseUtil, $document, toastr, $filter, $localStorage, $q, $log, professionalService, loader, cityService) {
        var vm = this;
        vm.ssnRegex = /^[0-9]{4,4}$/;
        vm.maxDateDatepicker = moment();
        var profilePopUp;

        function initConstant() {
            vm.viewType = briefcaseConstants.VIEW_TYPE;
            vm.role = briefcaseService.userRole;
            vm.dropDownConstant = angular.copy(dropDownConstant);
            vm.cityList = angular.copy(profileConstants.CITY_LIST);
            vm.cityName = [];
            vm.selectState = angular.copy(profileConstants.STATES);
            vm.selectFacilityType = angular.copy(profileConstants.FACILITY_TYPE);
            vm.nameRegex = briefcaseConstants.NAME_REGEX;
            vm.phoneNumberRegex = briefcaseConstants.PHONE_NUMBER_REGEX;
            vm.emailRegex = briefcaseConstants.EMAIL_REGEX;
            vm.roleAccess = angular.copy(briefcaseService.roleAccess);
            vm.isEditable = briefcaseConstants.isEditable;
            vm.preferenceState = [];
            vm.preferenceCity = [];
            vm.preState = [];
            vm.preCity = [];
            vm.selectCity = '';
            vm.cityChips = [];
            vm.cityObjArray = [];
            vm.open = false;
            vm.statesCodeTipToShow = ['TX', 'FL', 'CA']; 
            vm.statesTipToShow = []; 
            vm.dropDownConstant.lANGUAGE_CHOICES = [{ id: "c9", value: "1", label: "English" }, { id: "c10", value: "2", label: "Spanish" }, { id: "c11", value: "3", label: "Other", otherLanguage: "" }];

            angular.forEach(vm.statesCodeTipToShow, function (value1) {
                angular.forEach(profileConstants.STATES, function (value2, key2) {
                    if (value1 === key2) {
                        vm.statesTipToShow.push(value2);
                    }
                });
            });

            vm.stateDropDownsettings = {
                selectionLimit: 0,
                defaultSelectionText: "States Selected",
                enableSearch: false
            };
            vm.stateDropDownText = {
                searchPlaceholder: 'Search State',
                buttonDefaultText: 'Select State'
            };
            vm.cityDropDownText = {
                searchPlaceholder: 'Search City',
                buttonDefaultText: 'Select your preferred cities' 
            };

            angular.forEach(vm.selectState, function (value, key) {
                vm.preState.push(value);
            });

            vm.consentedAt = false;
        }

        vm.viewType = briefcaseService.viewType;

        vm.init = function () {
            loader.show();
            initConstant();
            if (vm.roleAccess.nurse === true && briefcaseService.briefcaseSession.briefcase.currentStep === undefined) {
                $timeout(function () {
                    profilePopUp = ngDialog.open({
                        template: 'profilePopUp',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: false,
                        closeByEscape: false
                    });
                }, 500);
            }
            profileService.getUserProfile().then(function (result) {
                loader.hide();
                vm.userProfile = angular.copy(result);
                vm.cacheBustingParam = Date.now();

                if (localStorage.getItem('updatedProfilePic') === 'true') {
                    localStorage.removeItem('updatedProfilePic');
                    vm.userProfile.profilePic = localStorage.getItem('updateProfilePicUrl');
                    vm.userProfile.profilePicFileId = localStorage.getItem('updateProfilePicId');
                    $scope.$emit('updateProfileAvatar', localStorage.getItem('updateProfilePicUrl'));
                } else {
                    vm.userProfile.profilePic = vm.userProfile && vm.userProfile.profilePicUrl;
                    vm.userProfile.profilePicFileId = vm.userProfile && vm.userProfile.profilePicFileId ? vm.userProfile.profilePicFileId : undefined;
                }

                if (vm.userProfile.jobs && vm.userProfile.jobs.workDistance) {
                    vm.userProfile.workDistance = String(vm.userProfile.jobs.workDistance);
                } else {
                    vm.userProfile.workDistance = '20';
                }

                if (vm.userProfile.jobs && vm.userProfile.jobs.workStates && vm.userProfile.jobs.workStates.length > 0) {
                    vm.state = angular.copy(vm.userProfile.jobs.workStates);
                    angular.forEach(vm.state, function (value1) {
                        angular.forEach(profileConstants.STATES, function (value2, key2) {
                            if (value1 === key2) {
                                vm.preferenceState.push(value2);
                            }
                        });
                    });
                }

                if (vm.userProfile.jobs && vm.userProfile.jobs.workCities && vm.userProfile.jobs.workCities.length > 0) {
                    var city = angular.copy(vm.userProfile.jobs.workCities);
                    angular.forEach(city, function (item) {
                        vm.cityChips.push(vm.getStateCity(item));
                        var strName = vm.getStateCity(item);
                        vm.cityObjArray.push(_defineProperty({}, strName, item));
                    });
                }

                vm.stateView = vm.preferenceState.toString();
                vm.cityView = vm.cityChips.toString();
                vm.consentedAt = result.briefcase.consentedAt;

                if (vm.userProfile.address && !vm.userProfile.address.address2) {
                    vm.userProfile.address.address2 = '';
                }

                var languages = _.get(vm, 'userProfile.languages', []);

                if (languages.length > 0) {
                    languages.forEach(function myFunction(selectedLanguage) {
                        for (var i = 0; i < vm.dropDownConstant.lANGUAGE_CHOICES.length; i++) {
                            if (vm.dropDownConstant.lANGUAGE_CHOICES[i].label == selectedLanguage) {
                                vm.dropDownConstant.lANGUAGE_CHOICES[i].checked = true;
                            }
                        }

                        if (selectedLanguage != vm.dropDownConstant.lANGUAGE_CHOICES[0].label && selectedLanguage != vm.dropDownConstant.lANGUAGE_CHOICES[1].label) {
                            vm.dropDownConstant.lANGUAGE_CHOICES[2].checked = true;
                            vm.dropDownConstant.lANGUAGE_CHOICES[2].otherLanguage = selectedLanguage;
                        }
                    });
                }

                if (!vm.userProfile.profilePic || vm.userProfile.profilePic === 'NULL') {
                    vm.userProfile.profilePic = '';
                }

                if (vm.userProfile.jobs) {
                    vm.competentReviews = vm.userProfile.competentReviews;
                    vm.professionalReviews = vm.userProfile.professionalReviews;
                    vm.skilledReviews = vm.userProfile.skilledReviews;

                    vm.jobsCancelled = parseInt(vm.userProfile.jobs.jobsCancelled);
                    vm.jobsConfirmed = parseInt(vm.userProfile.jobs.jobsConfirmed);
                    var jobsCancelled = parseInt(vm.userProfile.jobs.jobsCancelled);
                    var jobsConfirmed = parseInt(vm.userProfile.jobs.jobsConfirmed);
                    if (jobsConfirmed + jobsCancelled != 0) {
                        vm.cancellationScore = Math.round(jobsCancelled / jobsConfirmed * 100);
                    } else {
                        vm.cancellationScore = 0;
                    }
                }

                if (briefcaseService.isWorkPrefRedirect) {
                    ngDialog.open({
                        template: 'stateSelectPopup1',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: true,
                        closeByEscape: true
                    });
                    briefcaseService.isWorkPrefRedirect = null;
                }
            }, function (error) {
                loader.hide();
                error = error.data;
                toastr.error(error.message);
            });
        };

        vm.closePopup = function (dialogId) {
            ngDialog.close(dialogId);
        };

        $scope.$on('$destroy', function () {
            window.removeEventListener('message', photoEditorEvent);
            window.removeEventListener('resize', resizeWindowEvent);
            briefcaseService.bindingsInit = false;
        });

        $scope.onSubmit = function (form, isConsented) {
            if (form.$invalid) {
                return toastr.error('Please fill the required details!');
            }

            var briefcase = angular.copy({
                consentedAt: isConsented ? true : undefined
            });
            var options = { item: { briefcase: briefcase } };
            loader.show();
            ngDialog.closeAll();
            professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options).then(function () {
                vm.consentedAt = true;
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return vm.saveMyProfile(true, vm.userProfile);
            });
        };

        var consentDialogPopup;

        vm.viewConsents = function () {
            vm.consentsElementDisable = true;
            vm.consentList = [];
            loader.show();
            professionalService.getConsent(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id).then(function (_ref) {
                var consentedAt = _ref.consentedAt,
                    form = _ref.form;

                loader.hide();
                vm.jobConsentsTimeStamp = consentedAt || 'N/A';
                vm.consentList = form;
                vm.openPopup1('common_consent_template');
            }, function (error) {
                loader.hide();
                error = error.data;
                toastr.error(error.message);
            });
        };

        vm.openPopup1 = function (id) {
            consentDialogPopup = ngDialog.open({
                template: id,
                className: 'ngdialog-theme-default documentation-dialog',
                closeByNavigation: true,
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false
            });
        };

        vm.closeConsentPopUp = function () {
            ngDialog.close(consentDialogPopup);
        };

        var everywhere = angular.element(window.document);
        everywhere.bind('click', function (event) {
            if (event.target.className.indexOf("prevent-close") > -1 || event.target.id === "selectCity") {
                return;
            }
            if (vm.open) {
                vm.open = false;
                vm.selectCity = '';
            }
            $scope.$apply();
        });

        vm.searchCity = function () {
            var selectedCity = vm.selectCity;
            var len = vm.selectCity ? vm.selectCity.length : 0;
            if (len >= 1) {
                cityService.list(briefcaseConstants.ACCESS_TOKEN, selectedCity).then(function (cities) {
                    vm.cityList = cities;
                    vm.cityName = angular.copy(vm.cityList);
                    vm.preCity = angular.copy(cities);
                    vm.open = true;
                    $scope.$apply();
                }).catch(function (error) {
                    error = error.data;
                    toastr.error(error.message);
                });
            } else if (len === 0) {
                vm.preCity = [];
            }
        };

        vm.getStateCity = function (cityObj) {
            if (cityObj.city != undefined && cityObj.state != undefined) {
                return cityObj.city + ", " + cityObj.state;
            }
        };

        vm.isItemSelected = function (chips) {
            return vm.cityChips.indexOf(chips) >= 0;
        };

        vm.citySelect = function (cityObj) {

            var strName = vm.getStateCity(cityObj);

            var strIndex = vm.cityChips.indexOf(strName);
            var strIndexCityObj = -1;
            angular.forEach(vm.cityObjArray, function (item, index) {
                Object.keys(item).forEach(function (key) {
                    if (strName === key) {
                        strIndexCityObj = index;
                    }
                });
            });

            if (strIndex === -1) {
                vm.cityChips.push(strName);
                if (strIndexCityObj === -1) {
                    var cObj = {};
                    cObj.city = cityObj.city;
                    cObj.state = cityObj.state;
                    cObj.coordinates = cityObj.coordinates;
                    vm.cityObjArray.push(_defineProperty({}, strName, cObj));
                }
            } else {
                vm.cityChips.splice(strIndex, 1);
                vm.cityObjArray.splice(strIndexCityObj, 1);
            }
        };

        vm.cityCheckedTrue = function (item) {
            return vm.cityChips.indexOf(vm.getStateCity(item) > -1);
        };

        vm.selectEvents = {
            onItemSelect: function onItemSelect(item) {
                if (vm.statesTipToShow.indexOf(item) > -1) {
                    ngDialog.open({
                        template: 'stateSelectPopup',
                        className: 'ngdialog-theme-default documentation-dialog',
                        closeByNavigation: true,
                        scope: $scope,
                        closeByDocument: true,
                        closeByEscape: true
                    });
                }
            }

        };vm.updateOtherLangauge = function (index, value) {
            if (!value) {
                vm.dropDownConstant.lANGUAGE_CHOICES[index].otherLanguage = '';
            }
        };

        vm.languages = [];
        vm.otherlanguageCheck = false;

        vm.updateLanguage = function () {
            vm.languages = _.filter(vm.dropDownConstant.lANGUAGE_CHOICES, function (c) {
                if (c.id == 'c11' && c.checked) {
                    vm.otherlanguageCheck = true;
                } else {
                    vm.otherlanguageCheck = false;
                }
                return c.checked;
            });
        };

        vm.profile_upload_crop_dialog = function () {
            ngDialog.open({
                template: 'cropImagePopup',
                className: 'ngdialog-theme-default profileModel',
                showClose: true,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope,
                preCloseCallback: function preCloseCallback() {
                    var input = document.getElementById('uploadFile');
                    if (input) {
                        input.value = '';
                    }
                }
            });
        };

        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener && !briefcaseService.bindingsInit) {
                element.addEventListener(eventName, eventHandler, false);
            }
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {
                type: contentType
            });
            return blob;
        }

        function resizeWindowEvent() {
            {
                if (navigator.userAgent.match(/iP(hone|od|ad)/i)) {
                    $scope.rotateCount = 0;
                    $scope.img.myImage = '';
                    $scope.isRotating = false;
                    $scope.dominantColor = [];
                    $scope.paletteColor = '';
                    $scope.paletteColorLength = 8;
                    $scope.resImgSize = 200;

                    $scope.firstTimeRotate = 0;

                    var canvas = document.createElement('canvas'),
                        mpImg = new MegaPixImage($scope.fileOrientation);
                    canvas.width = mpImg.srcImage.width;
                    canvas.height = mpImg.srcImage.height;
                    EXIF.getData($scope.fileOrientation, function () {
                        var orientation = EXIF.getTag(this, 'Orientation');
                        mpImg.render(canvas, {
                            maxHeight: $scope.resImgSize * 2,
                            orientation: orientation
                        }, function () {
                            var tt = canvas.toDataURL('image/jpeg', 1);
                            canvas.toBlob(function (blob) {
                                $scope.$apply(function ($scope) {
                                    var reader = new FileReader();
                                    reader.onload = function (evt) {
                                        $scope.$apply(function ($scope) {
                                            $scope.img.myImage = evt.target.result;
                                        });
                                    };
                                    reader.readAsDataURL($scope.fileOrientation);
                                });
                            });
                        });
                    });
                }
            }
        }

        function photoEditorEvent(e) {
            if (e.origin.includes('photoeditor')) {
                var ImageURL = e.data;
                var block = ImageURL.split(';');
                var contentType = block[0].split(':')[1]; 
                var realData = block[1].split(',')[1]; 

                var blob = b64toBlob(realData, contentType);
                $scope.img = {};
                $scope.img.myCroppedImage = blob;

                $scope.imageData = ImageURL;
                $scope.imageExtension = contentType.split('/')[1];
                $scope.cacheBustingParam = Date.now();
                vm.UploadProfilePicOnClickV2();
                ngDialog.closeAll();
            }
        }
        if (!briefcaseService.bindingsInit) {
            bindEvent($window, 'message', photoEditorEvent);
            bindEvent($window, 'resize', resizeWindowEvent);
        }
        briefcaseService.bindingsInit = true;

        $scope.rotate = function (isClockwise) {
            if (!$scope.img.myImage) {
                return;
            }
            $scope.isRotating = true;
            $scope.loadingModel = true;
            rotateBase64Image($scope.img.myImage, isClockwise, function (result) {
                $scope.$apply(function () {
                    $scope.img.myImage = result;
                    $scope.isRotating = false;
                    $scope.loadingModel = false;
                });
            });
        };

        function rotateBase64Image(base64data, isClockwise, callback) {
            var image = new Image();
            image.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = image.width < image.height ? image.height : image.width;
                canvas.height = image.height < image.width ? image.width : image.height;

                var ctx = canvas.getContext('2d');
                if (!$scope.firstTimeRotate) {
                    $scope.firstTimeRotate = 1;
                    var deg = isClockwise ? ($scope.OrientationCount + 1) * Math.PI / 2 : ($scope.OrientationCount - 1) * Math.PI / 2; 
                } else {
                    var deg = isClockwise ? Math.PI / 2 : Math.PI / -2; 
                }
                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate(deg);
                ctx.drawImage(image, -image.width / 2, -image.height / 2);
                ctx.rotate(-deg);
                ctx.translate(-canvas.width / 2, -canvas.height / 2);
                callback(canvas.toDataURL());
            };
            image.src = base64data;
        }

        function imageOrientation(file) {
            $scope.OrientationCount = 0;
            $scope.firstTimeRotate = 0;
            getOrientation(file, function (e) {
                if (e == 6) {
                    $scope.OrientationCount = 1;
                } else if (e == 3) {
                    $scope.OrientationCount = -2;
                } else if (e == 8) {
                    $scope.OrientationCount = -1;
                } else if (e == 5) {
                    $scope.OrientationCount = 1;
                } else if (e == 4) {
                    $scope.OrientationCount = -2;
                } else if (e == 7) {
                    $scope.OrientationCount = -1;
                } else {
                    $scope.OrientationCount = 0;
                }
            });
        }

        function getOrientation(file, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var view = new DataView(e.target.result);
                if (view.getUint16(0, false) != 0xFFD8) {
                    return callback(-2);
                }
                var length = view.byteLength,
                    offset = 2;
                while (offset < length) {
                    var marker = view.getUint16(offset, false);
                    offset += 2;
                    if (marker == 0xFFE1) {
                        if (view.getUint32(offset += 2, false) != 0x45786966) {
                            return callback(-1);
                        }
                        var little = view.getUint16(offset += 6, false) == 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        for (var i = 0; i < tags; i++) {
                            if (view.getUint16(offset + i * 12, little) == 0x0112) {
                                return callback(view.getUint16(offset + i * 12 + 8, little));
                            }
                        }
                    } else if ((marker & 0xFF00) != 0xFF00) {
                        break;
                    } else {
                        offset += view.getUint16(offset, false);
                    }
                }
                return callback(-1);
            };
            reader.readAsArrayBuffer(file);
        }


        vm.UploadProfilePicOnClickV2 = function () {
            ngDialog.close();
            loader.show();
            profileService.uploadUserPicture($scope.imageData, $scope.imageExtension, vm.userProfile.profilePicFileId).then(function (_ref2) {
                var downloadUrl = _ref2.downloadUrl,
                    recordId = _ref2.recordId;

                $scope.$emit('updateProfileAvatar', downloadUrl);
                vm.userProfile.profilePic = downloadUrl;
                vm.userProfile.profilePicFileId = recordId;

                localStorage.setItem('updatedProfilePic', 'true');
                localStorage.setItem('updateProfilePicUrl', downloadUrl);
                localStorage.setItem('updateProfilePicId', recordId);

                loader.hide();
                toastr.success('Profile picture uploaded successfully!');
                var input = document.getElementById('uploadFile');
                input.value = '';
                $state.reload();
            }, function (error) {
                loader.hide();
                error = error.data;
                toastr.error(error.message);
                $document.scrollTop(200, 0);
                angular.element(document).find('body').css('overflow', 'auto');
                var input = document.getElementById('uploadFile');
                input.value = '';
            });
        };

        vm.openBriefcase = function () {
            var SB_URL = briefcaseConstants.SB_URL + '/' + briefcaseService.briefcase.id + '?authToken=' + briefcaseConstants.ACCESS_TOKEN;
            console.log("Briefcase url", SB_URL);
            window.open(SB_URL);
            return false;
        };

        vm.saveMyProfile = async function (valid, userProfile) {
            angular.element('input.ng-invalid,select.ng-invalid').first().focus(); 

            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('safari') != -1) {
                if (ua.indexOf('chrome') > -1) {
                } else {
                    if (angular.element('#uploadFile').val() == '') {
                        $window.scrollTo(0, angular.element('#uploadFile').offsetTop);
                    }
                }
            }

            if (valid) {
                if (!vm.consentedAt && vm.role === 'nurse') {
                    vm.viewConsents();
                } else {
                    var phoneNumber = vm.userProfile.phoneNumber;
                    vm.userProfile.phoneNumber = phoneNumber.toString().replace(/-/g, '');

                    if (vm.userProfile.emergencyContact) {
                        if (vm.userProfile.emergencyContact.phoneNumber) {
                            vm.userProfile.emergencyContact.phoneNumber = vm.userProfile.emergencyContact.phoneNumber.replace(/-/g, '');
                        }
                        if (vm.userProfile.emergencyContact.phoneNumber == '') {
                            delete vm.userProfile.emergencyContact.phoneNumber;
                        }
                        if (vm.userProfile.emergencyContact.name == '') {
                            delete vm.userProfile.emergencyContact.name;
                        }
                        if (vm.userProfile.emergencyContact.email == '') {
                            delete vm.userProfile.emergencyContact.email;
                        }
                        if (vm.userProfile.emergencyContact.relationship == '') {
                            delete vm.userProfile.emergencyContact.relationship;
                        }
                    }

                    var workCities = [];

                    if (vm.cityChips && vm.cityChips.length > 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = vm.cityChips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var element1 = _step.value;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = vm.cityObjArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;

                                        if (item[element1]) {
                                            delete item[element1].$$hashKey;
                                            workCities.push({ city: item[element1].city, state: item[element1].state, coordinates: item[element1].coordinates });
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    var jobs = {};
                    var workStates = [];
                    if (vm.preferenceState && vm.preferenceState.length <= 0) {
                        vm.preferenceState.push(vm.selectState[vm.userProfile.address.state]);
                    }

                    if (vm.preferenceState && vm.preferenceState.length > 0) {
                        vm.preferenceState.forEach(function myFunction(pState) {
                            var stateAbb = Object.keys(vm.selectState).find(function (key) {
                                return vm.selectState[key] === pState;
                            });
                            workStates.push(stateAbb);
                        });
                    }

                    var languages = [];

                    if (vm.dropDownConstant.lANGUAGE_CHOICES.length > 0) {
                        vm.dropDownConstant.lANGUAGE_CHOICES.forEach(function myFunction(selectedLanguage) {
                            if (selectedLanguage.checked == true) {
                                if (selectedLanguage.label == "Other") {
                                    if (selectedLanguage.otherLanguage != '' && selectedLanguage.otherLanguage != undefined) {
                                        languages.push(selectedLanguage.otherLanguage);
                                    }
                                } else {
                                    languages.push(selectedLanguage.label);
                                }
                            }
                        });
                    }

                    jobs.workStates = workStates;
                    jobs.workDistance = Number(vm.userProfile.workDistance);
                    jobs.workCities = workCities;

                    var profileData1 = {};
                    profileData1.firstName = vm.userProfile.firstName;
                    profileData1.lastName = vm.userProfile.lastName;
                    profileData1.email = vm.userProfile.email;
                    profileData1.phoneNumber = vm.userProfile.phoneNumber;
                    profileData1.address = vm.userProfile.address;
                    profileData1.languages = languages;
                    profileData1.emergencyContact = vm.userProfile.emergencyContact;
                    profileData1.jobs = jobs;

                    var briefcase = {};
                    if (!briefcaseConstants.isAdminOrHospitalUser) {
                        briefcase.currentStep = _.get(vm, 'userProfile.briefcase.currentStep', 0) > 1 ? vm.userProfile.currentStep : 1;
                    }
                    profileData1.briefcase = briefcase;

                    var profileData = {};
                    profileData.item = profileData1;

                    loader.show();

                    profileService.updateUserProfile(profileData).then(function () {
                        $scope.$emit('updateProfile');
                        loader.hide();
                        toastr.success('Data saved successfully!');
                        $scope.$emit('$TabWorking', { flag: 1 });
                    }, function (error) {
                        loader.hide();
                        error = error.data;
                        toastr.error(error.message);
                    });
                }
            } else {
                toastr.error('Please fill the required details!');
            }
        };

        vm.syncDocument = function () {
            loader.show();
            professionalService.sync(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, { profile: 1 }).then(function () {
                return toastr.success('Profile sync completed.');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        $scope.closePopup = function (dialogId) {
            ngDialog.close(dialogId);
        };
    }]);
})();
'use strict';

(function () {
    'use strict';

    var module = angular.module('praos.briefcase');
    module.service('profileService', ['$q', 'briefcaseConstants', 'briefcaseService', 'professionalService', 'recordService', function ($q, briefcaseConstants, briefcaseService, professionalService, recordService) {

        this.getUserProfile = getUserProfile;
        this.fetchUserProfile = fetchUserProfile;
        this.updateUserProfile = updateUserProfile;
        this.uploadUserPicture = uploadUserPicture;

        function getUserProfile() {
            var def = $q.defer();
            professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, briefcaseConstants.profileFields).then(function (result) {
                def.resolve(result);
            }).catch(function (error) {
                def.reject(error.message);
            });
            return def.promise;
        }

        async function fetchUserProfile() {
            return professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, briefcaseConstants.profileFields);
        }

        function updateUserProfile(data) {
            var def = $q.defer();
            professionalService.update(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, data).then(function (result) {
                def.resolve(result);
            }).catch(function (error) {
                def.reject(error.message);
            });
            return def.promise;
        }

        function uploadUserPicture(imageData, imageExt, recordId) {
            var data = {};
            data.fileName = 'profile' + '.' + imageExt;
            data.file = imageData;
            data.userId = briefcaseService.briefcase.id;
            data.isPermanent = true;
            data.recordType = 'Profile Picture';
            data.attachmentType = 'image';
            data.permissions = 115; 
            if (recordId) {
                data.recordId = recordId;
            }

            var def = $q.defer();
            recordService.upload(briefcaseConstants.ACCESS_TOKEN, data).then(function (result) {
                def.resolve(result);
            }).catch(function (error) {
                def.reject(error.message);
            });
            return def.promise;
        }
    }]);
})();
'use strict';

(function () {
    var controller = function controller(briefcaseConstants, briefcaseService, professionalService, $scope) {
        var _this = this;

        this.$onInit = async function () {
            var options = {
                select: {
                    'jobs.cancelledJobs': 1,
                    'jobs.confirmedJobs': 1,
                    'jobs.competentReviews': 1,
                    'jobs.professionalReviews': 1,
                    'jobs.skilledReviews': 1,
                    'jobs.badgedReviews': 1
                }
            };
            _this.role = briefcaseService.userRole;
            var result = await professionalService.get(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, options);
            _this.jobsCancelled = _.get(result, 'jobs.cancelledJobs', 0);
            _this.jobsConfirmed = _.get(result, 'jobs.confirmedJobs', 0);
            _this.competentReviews = _.get(result, 'jobs.competentReviews', 0);
            _this.professionalReviews = _.get(result, 'jobs.professionalReviews', 0);
            _this.skilledReviews = _.get(result, 'jobs.skilledReviews', 0);
            _this.badgedReviews = _.get(result, 'obs.badgedReviews', 0);
            _this.jobsPercentage = _this.jobsConfirmed ? Math.round(_this.jobsCancelled / _this.jobsConfirmed * 100) : 0;
            _this.loaded = true;
            $scope.$apply();
        };
    };
    angular.module('praos.briefcase').component('performanceManagement', {
        templateUrl: 'shared/performance-management.html',
        controller: ['briefcaseConstants', 'briefcaseService', 'professionalService', '$scope', controller]
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').directive('taskBriefcase', taskBriefcase);

    taskBriefcase.$inject = ['$window', 'briefcaseUtil', 'briefcaseConstants'];
    function taskBriefcase($window, briefcaseUtil, briefcaseConstants) {
        return {
            template: '<div ng-include="getTemplateUrl()" /> <div ng-transclude></div>',
            scope: {
                viewType: '@',
                callBack: '&taskBriefcase'
            },
            transclude: true,
            controller: 'taskCtrl as taskCtrl',
            link: function link($scope, $elm, $attrs, taskCtrl) {
                $scope.getTemplateUrl = function () {
                    var viewType = $attrs.viewType || 'view';
                    return 'task/task-' + viewType + '.html';
                };
                $elm.on('load', function () {
                    return $scope.callBack();
                });

                taskCtrl.init();

                $scope.updateTemplate = function (viewType) {
                    $attrs.viewType = viewType;
                    $scope.getTemplateUrl();
                    taskCtrl.init(); 
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('praos.briefcase').controller('taskCtrl', ['$scope', '$sce', 'briefcaseConstants', 'briefcaseService', 'loader', function ($scope, $sce, briefcaseConstants, briefcaseService, loader) {
        var vm = this;

        if (briefcaseConstants.isAdminOrHospitalUser) {
            $scope.externalClientIframeUrl = briefcaseConstants.ADMIN_TASK_TAB_IFRAME_URL.replace('{userId}', briefcaseService.briefcase.id) + '?auth=' + briefcaseConstants.ACCESS_TOKEN;
        } else {
            $scope.externalClientIframeUrl = briefcaseConstants.TASK_TAB_IFRAME_URL + '?auth=' + briefcaseConstants.ACCESS_TOKEN;
        }

        vm.init = function () {

            $scope.iframeLoadedCallBack = function () {
                loader.show();
            };

            $scope.trustSrc = function (src) {
                var trustedUrl = $sce.trustAsResourceUrl(src);
                return trustedUrl;
            };
        };
    }]);
})();
'use strict';

(function () {
    var controller = function controller(recordService, briefcaseConstants, briefcaseService, $timeout, loader, toastr, $scope) {
        var _this = this;

        this.options = {
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            autoUpdateInput: false,
            minDate: new Date()
        };

        this.onFileChange = function (idField, urlField, recordType, attachmentType, evt) {
            var file = evt.target.files[0];
            if (!file) {
                return;
            }
            if (file.size / 1e+6 > 10) {
                return toastr.error('File is too large');
            }
            var isPermanent = !!_this.certificate.id && !_this.isCertificateSaved;
            loader.show();
            recordService.upload(briefcaseConstants.ACCESS_TOKEN, {
                recordId: _this.certificate.id || _this.certificate[idField], 
                recordType: isPermanent ? recordType : undefined,
                fileName: attachmentType,
                file: file,
                attachmentType: isPermanent ? attachmentType : undefined,
                userId: isPermanent ? briefcaseService.briefcase.id : undefined,
                isPermanent: isPermanent,
                permissions: isPermanent ? 51 : undefined 
            }).then(function (_ref) {
                var downloadUrl = _ref.downloadUrl,
                    recordId = _ref.recordId,
                    tempFileName = _ref.tempFileName;

                if (!_this.certificate.id) {
                    _this.certificate.id = recordId;
                }
                _this.certificate[urlField] = downloadUrl;
                _this.certificate[idField] = recordId;

                if (!isPermanent) {
                    if (!_this.certificate.attachments) {
                        _this.certificate.attachments = {};
                    }

                    _this.certificate.attachments[attachmentType] = {
                        fileName: attachmentType,
                        tempFileName: tempFileName
                    };
                }

                toastr.success('File successfully loaded');
                loader.hide();
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        this.download = function (e, recordId, url, attachmentType) {
            e.preventDefault();
            recordService.download({
                auth: briefcaseConstants.ACCESS_TOKEN,
                recordId: recordId,
                url: url,
                attachmentType: attachmentType,
                openWindow: true
            });
        };

        this.callback = function (field, date) {
            if (field === 'expirationDate') {
                var diff = date.diff(moment(), 'days');
                _this.expirationTooltip = diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null;
            }
            _this.certificate[field] = date.toDate();
            _this.form.additionalCertificates.$setDirty();
            _this.form.additionalCertificates[_this.index].$setDirty();
            $scope.$apply();
        };

        this.updateVisibility = function () {
            if (!_this.isActive) {
                _this.showEcard = false;
                _this.expiredTooltip = null;
                _this.expirationTooltip = null;
                _this.certificate.expirationDate = undefined;
            }
        };

        this.toggleCardNumber = function () {
            if (_this.certificate.isActive) {
                _this.showEcard = !_this.showEcard;
            }
        };

        this.$onInit = function () {
            _this.certificate = _this.certificateObject;
            _this.certificate.isActive = !!_this.certificate.id;
            _this.isCertificateSaved = !_this.certificate.id;
            var today = Date.now();
            var expDate = _.get(_this, 'certificate.expirationDate');
            if (expDate) {
                _this.expiredTooltip = expDate < today ? 'Expired' : null;
                var diff = moment(expDate).diff(moment(), 'days');
                _this.expirationTooltip = diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null;
            }
            _this.expDPid = 'exp' + _this.index;
            if (_this.certificate.isAha) {
                _this.frontId = 'front' + _this.index;
                _this.backId = 'back' + _this.index;
                _this.fileId = 'file' + _this.index;
                _this.showEcard = !!_this.certificate.eCardNumber;

                $timeout(function () {
                    angular.element('#' + _this.frontId).bind('change', _this.onFileChange.bind(_this, 'frontFileId', 'frontFileUrl', 'Additional Certification', 'front'));
                    angular.element('#' + _this.backId).bind('change', _this.onFileChange.bind(_this, 'backFileId', 'backFileUrl', 'Additional Certification', 'back'));
                    angular.element('#' + _this.expDPid).daterangepicker(_this.options, _this.callback.bind(_this, 'expirationDate'));
                });
            } else {
                _this.fileId = 'file' + _this.index;
                $timeout(function () {
                    angular.element('#' + _this.fileId).bind('change', _this.onFileChange.bind(_this, 'frontFileId', 'frontFileUrl', 'Additional Certification', 'front'));
                    angular.element('#' + _this.expDPid).daterangepicker(_this.options, _this.callback.bind(_this, 'expirationDate'));
                });
            }
        };
    };
    angular.module('praos.briefcase').component('additionalCertificate', {
        templateUrl: 'license/additional-certificate.html',
        bindings: {
            certificateObject: '=',
            form: '<',
            index: '<'
        },
        controller: ['recordService', 'briefcaseConstants', 'briefcaseService', '$timeout', 'loader', 'toastr', '$scope', controller]
    });
})();
'use strict';

(function () {
    var controller = function controller(recordService, briefcaseConstants, briefcaseService, $timeout, loader, toastr, $scope) {
        var _this = this;

        this.remove = function () {
            _this.onRemove(_this.index);
        };

        this.resetForm = function () {
            _this.certificate.name = 'None';
            _this.certificate.fileUrl = undefined;
            _this.certificate.courseWorkFileUrl = undefined;
            _this.certificate.digitalBadgeUrl = undefined;
            _this.certificate.expirationDate = undefined;
            _this.disabled = true;
        };

        this.options = {
            singleDatePicker: true,
            showDropdowns: true,
            minDate: new Date(),
            autoApply: true
        };

        this.onBodyChange = function () {
            if (_this.certificate.certifyingBody === 'None') {
                _this.resetForm();
            } else {
                _this.names = _this.certificationNames.filter(function (_ref) {
                    var certifyingBody = _ref.certifyingBody;
                    return !certifyingBody || certifyingBody === _this.certificate.certifyingBody;
                });
                _this.certificate.name = null;
                _this.disabled = false;
            }
        };

        this.openDatePicker = function (el) {
            angular.element('#' + el).triggerHandler('click');
        };

        this.callback = function (field, date) {
            if (field === 'expirationDate') {
                var diff = date.diff(moment(), 'days');
                _this.expirationTooltip = diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null;
            }
            _this.certificate[field] = date.toDate();
            _this.form.professionalCertificates.$setDirty();
            _this.form.professionalCertificates[_this.index].$setDirty();
            $scope.$apply();
        };

        this.onFileChange = function (idField, urlField, recordType, attachmentType, evt) {
            var file = evt.target.files[0];
            if (!file) {
                return;
            }
            if (file.size / 1e+6 > 10) {
                return toastr.error('File is too large');
            }

            var isPermanent = !!_this.certificate.id && !_this.isCertificateSaved;
            loader.show();
            recordService.upload(briefcaseConstants.ACCESS_TOKEN, {
                recordId: _this.certificate.id || _this.certificate[idField],
                recordType: isPermanent ? recordType : undefined,
                fileName: attachmentType,
                file: file,
                attachmentType: isPermanent ? attachmentType : undefined,
                userId: isPermanent ? briefcaseService.briefcase.id : undefined,
                isPermanent: isPermanent,
                permissions: isPermanent ? 51 : undefined 
            }).then(function (_ref2) {
                var downloadUrl = _ref2.downloadUrl,
                    recordId = _ref2.recordId,
                    tempFileName = _ref2.tempFileName;

                if (!_this.certificate.id) {
                    _this.certificate.id = recordId;
                }
                _this.certificate[urlField] = downloadUrl;
                _this.certificate[idField] = recordId;

                if (!isPermanent) {
                    if (!_this.certificate.attachments) {
                        _this.certificate.attachments = {};
                    }

                    _this.certificate.attachments[attachmentType] = {
                        fileName: attachmentType,
                        tempFileName: tempFileName
                    };
                }
                toastr.success('File successfully uploaded');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        this.download = function (e, recordId, url, attachmentType) {
            e.preventDefault();
            recordService.download({
                auth: briefcaseConstants.ACCESS_TOKEN,
                recordId: recordId,
                url: url,
                attachmentType: attachmentType,
                openWindow: true
            });
        };

        this.$onInit = function () {
            _this.certificate = _this.certificateObject;
            _this.isCertificateSaved = !_this.certificate.id;
            if (_this.certificate.certifyingBody) {
                _this.names = _this.certificationNames.filter(function (_ref3) {
                    var certifyingBody = _ref3.certifyingBody;
                    return certifyingBody === _this.certificate.certifyingBody;
                });
            }

            if (_this.certificate.certifyingBody === 'None') {
                _this.resetForm();
            }

            if (_this.certificate.expirationDate) {
                var mDate = moment(_this.certificate.expirationDate);
                var diff = mDate.diff(moment(), 'days');
                _this.expirationTooltip = diff < 90 ? diff > 1 ? 'Expiring in ' + diff + ' days' : 'Expiring today' : null;
            }
            _this.expDPid = 'exp-dp-cert-' + _this.index;
            _this.courseWorkUploadId = 'course-work-' + _this.index;
            _this.fileUploadId = 'file-upload-' + _this.index;
            $timeout(function () {
                angular.element('#' + _this.fileUploadId).bind('change', _this.onFileChange.bind(_this, 'fileId', 'fileUrl', 'Certification', 'certification'));
                angular.element('#' + _this.courseWorkUploadId).bind('change', _this.onFileChange.bind(_this, 'courseworkFileId', 'courseWorkFileUrl', 'Certification', 'coursework'));
                angular.element('#' + _this.expDPid).daterangepicker(_this.options, _this.callback.bind(_this, 'expirationDate'));
            });
        };
    };
    angular.module('praos.briefcase').component('singleCertificate', {
        templateUrl: 'license/certificate-single.html',
        bindings: {
            certificateObject: '=',
            certificationNames: '<',
            certificationBodies: '<',
            onRemove: '=',
            index: '<',
            form: '<'
        },
        controller: ['recordService', 'briefcaseConstants', 'briefcaseService', '$timeout', 'loader', 'toastr', '$scope', controller]
    });
})();
'use strict';

(function () {
    var controller = function controller(briefcaseService, dropDownConstant, briefcaseConstants, professionalService, loader, toastr, recordService, licenseUrlService, $scope, ngDialog, $timeout) {
        var _this = this;

        this.fileChanged = false;
        this.isManual = false;
        this.isAdminOrHospitalUser = briefcaseConstants.isAdminOrHospitalUser;
        this.options = {
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true
        };
        this.licenseUrl = '';
        this.licenseChosen = {
            licenseType: undefined,
            licenseBody: undefined
        };
        this.licenseFileUpdated = false;
        this.psvLicenseFileUpdated = false;
        this.canBypassDOB = false;

        this.callback = function (field, date) {
            _this.license[field] = date.toDate();
            $scope.$apply();
        };

        this.onFileChange = function (evt) {
            var file = evt.target.files[0];
            if (!file) {
                return;
            }
            if (file.size / 1e+6 > 10) {
                return toastr.error('File is too large');
            }
            loader.show();
            var uploadData = {
                file: file,
                fileName: 'license'
            };
            if (_this.license.licenseFileId || _this.license.id) {
                uploadData.recordId = _this.license.licenseFileId || _this.license.id;
            }
            recordService.upload(briefcaseConstants.ACCESS_TOKEN, uploadData).then(function (_ref) {
                var downloadUrl = _ref.downloadUrl,
                    recordId = _ref.recordId,
                    tempFileName = _ref.tempFileName;

                _this.license.fileUrl = downloadUrl;
                _this.license.licenseFileId = recordId;
                _this.license.licenseFileKey = recordId + '/' + tempFileName;

                if (_this.licenseObject) {
                    _this.licenseObject.fileUrl = downloadUrl;
                    _this.licenseObject.licenseFileId = recordId;
                    _this.licenseObject.licenseFileKey = recordId + '/' + tempFileName;
                    _this.licenseFileUpdated = true;
                }
                if (!_this.license.id) {
                    _this.license.id = recordId;
                    if (_this.licenseObject) {
                        _this.licenseObject.id = recordId;
                    }
                }
                _this.fileChanged = true;
                toastr.success('File selected. File will only be uploaded when you "Save and Verify" license information.');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        this.onPsvFileChange = function (evt) {
            var file = evt.target.files[0];
            if (!file) {
                return;
            }
            if (file.size / 1e+6 > 5) {
                return toastr.error('File is too large');
            }
            loader.show();

            var uploadData = {
                file: file,
                fileName: 'psvLicense'
            };
            if (_this.license.licenseFileId || _this.license.id) {
                uploadData.recordId = _this.license.licenseFileId || _this.license.id;
            }
            recordService.upload(briefcaseConstants.ACCESS_TOKEN, uploadData).then(function (_ref2) {
                var downloadUrl = _ref2.downloadUrl,
                    recordId = _ref2.recordId,
                    tempFileName = _ref2.tempFileName;

                _this.license.psvLicenseUrl = downloadUrl;
                _this.license.psvLicenseFileId = recordId;
                _this.license.psvLicenseFileKey = recordId + '/' + tempFileName;
                if (_this.licenseObject) {
                    _this.licenseObject.psvLicenseUrl = downloadUrl;
                    _this.licenseObject.psvLicenseFileId = recordId;
                    _this.licenseObject.psvLicenseFileKey = recordId + '/' + tempFileName;
                    _this.psvLicenseFileUpdated = true;
                }
                if (!_this.license.id) {
                    _this.license.id = recordId;
                }
                _this.fileChanged = true;
                toastr.success('File selected. File will only be uploaded when you "Save and Verify" license information.');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        this.downloadFile = function (e, recordId, url, fileUpdated, attachmentType) {
            e.preventDefault();
            recordService.download({
                auth: briefcaseConstants.ACCESS_TOKEN,
                recordId: recordId,
                attachmentType: attachmentType,
                url: recordId && !fileUpdated ? undefined : url,
                openWindow: true
            });

            return false;
        };

        this.$onChanges = function () {
            _this.license = angular.copy(_this.licenseObject);
        };

        this.$onInit = function () {
            _this.licensePattern = angular.copy(briefcaseConstants.LICENSE_NUMBER_REGEX);
            _this.license = angular.copy(_this.licenseObject) || { isCompact: false };
            _this.evaluateDOBbypass();
            $timeout(function () {
                angular.element('#fileUploadPL').bind('change', _this.onFileChange.bind(_this));
                angular.element('#fileUploadPLpsv').bind('change', _this.onPsvFileChange.bind(_this));
                angular.element('#expDatepicker').daterangepicker(_this.options, _this.callback.bind(_this, 'expirationDate'));
                angular.element('#issueDatepicker').daterangepicker(Object.assign({ maxDate: new Date() }, _this.options), _this.callback.bind(_this, 'issueDate'));
                var maxBirthDate = moment().subtract(15, 'years').toDate();
                var startDate = _this.license.dateOfBirth ? moment(_this.license.dateOfBirth) : maxBirthDate;
                angular.element('#dobDatepicker').daterangepicker(Object.assign({ maxDate: maxBirthDate, startDate: startDate }, _this.options), _this.callback.bind(_this, 'dateOfBirth'));
            });
        };

        this.hasChanges = function () {
            var ch = !_this.licenseObject || !angular.equals(_this.license, _this.licenseObject) || _this.fileChanged;
            $scope.$emit('prLicenseHasChanges', ch);

            _this.evaluateDOBbypass();
            if ((_this.profession === 'Allied Health' || _this.license && _this.license.licenseType === 'STNA' || _this.license && _this.license.licenseType === 'CNA') && _this.license && _this.license.licenseType && (_this.license.licenseType !== _this.licenseChosen.licenseType || _this.license.licenseBody !== _this.licenseChosen.licenseBody)) {
                _this.licenseChosen = {
                    licenseType: _this.license.licenseType,
                    licenseBody: _this.license.licenseBody
                };
                _this.getLicenseUrl(_this.license.licenseType, _this.license.licenseBody);
            }

            return ch;
        };

        this.evaluateDOBbypass = function () {
            var isNonNursysLicense = _this.profession === 'Allied Health' || _this.license && _this.license.licenseType === 'STNA' || _this.license && _this.license.licenseType === 'CNA';
            _this.canBypassDOB = _this.isAdminOrHospitalUser && (isNonNursysLicense || _this.license.licenseBody && ['Michigan Board of Nursing', 'Michigan State Board'].indexOf(_this.license.licenseBody) > -1);
        };

        this.getLicenseUrl = function (licenseType, licenseBody) {
            licenseUrlService.lookupUrl(licenseType, {
                licenseBody: licenseBody || undefined,
                organization: _this.organization || undefined
            }).then(function (url) {
                _this.licenseUrl = url;
                $scope.$apply();
            }).catch(function (err) {
                return console.error('failed to get license url', err);
            });
        };

        this.resetDetails = function () {
            _this.license.isCompact = false;
            if (_this.types) {
                var licenseType = _this.types.find(function (type) {
                    return type.abbr === _this.license.licenseType;
                });
                _this.detailsRequired = licenseType && licenseType.detailsRequired;
            }
        };

        this.openDatePicker = function (el) {
            angular.element(el).triggerHandler('click');
        };

        this.enableUserToMakeChanges = async function () {
            $scope.$emit('updateProfile');
            await _this.onSave('enableUserOnTimeOut');
            toastr.error("Your license couldn't be verified electronically, we will attempt to verify manually. Please continue to complete your profile.");
        };

        this.submit = function (form) {
            if (form.$valid) {
                var _loader = ngDialog.open({
                    template: 'licensecheckloader',
                    className: 'ngdialog-theme-default',
                    showClose: false,
                    closeByDocument: false,
                    closeByEscape: false,
                    scope: $scope
                });
                var fn = _this.licenseObject ? professionalService.updateBriefcaseItem.bind(professionalService) : professionalService.addBriefcaseItem.bind(professionalService);
                var copy = angular.copy(_this.license);
                delete copy.verificationText;
                delete copy.verifiedAt;
                delete copy.verifiedBy;
                delete copy.psvLicenseDownloadUrl;
                delete copy.psvLicenseUrl;

                if (_this.isManual) {
                    copy.manualOverride = true;
                }
                if (copy.licenseFileKey) {
                    copy.licenseFileId = copy.licenseFileKey;
                    delete copy.licenseFileKey;
                }
                if (copy.psvLicenseFileKey) {
                    copy.psvLicenseFileId = copy.psvLicenseFileKey;
                    delete copy.psvLicenseFileKey;
                }

                fn(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, 'licenses', copy).then(function (res) {
                    _this.license.id = res.id;
                    _this.license.verifiedAt = res.verifiedAt;
                    $scope.$emit('updateProfile');
                    _this.onSave(res);
                    _this.licenseObject = angular.copy(_this.license);
                    _this.fileChanged = false;
                }).catch(function (e) {
                    return e.message === "Endpoint request timed out" ? _this.enableUserToMakeChanges() : toastr.error(e.message);
                }).finally(function () {
                    return _loader.close();
                });
            }
        };
    };
    angular.module('praos.briefcase').component('primaryLicense', {
        templateUrl: 'license/license-primary.html',
        bindings: {
            licenseObject: '<',
            types: '<',
            states: '<',
            detailsRequired: '<',
            profession: '<',
            organization: '<',
            onSave: '='
        },
        controller: ['briefcaseService', 'dropDownConstant', 'briefcaseConstants', 'professionalService', 'loader', 'toastr', 'recordService', 'licenseUrlService', '$scope', 'ngDialog', '$timeout', controller]
    });
})();
'use strict';

(function () {
    var controller = function controller(briefcaseService, dropDownConstant, briefcaseConstants, professionalService, loader, toastr, $timeout, $scope) {
        var _this = this;

        this.options = {
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true
        };

        this.callback = function (field, date) {
            _this.license[field] = date.toDate();
            $scope.$apply();
        };

        this.$onInit = function () {
            _this.licensePattern = angular.copy(briefcaseConstants.LICENSE_NUMBER_REGEX);
            _this.license = angular.copy(_this.licenseObject) || { isCompact: false };
            _this.expDPid = 'exp-dp-' + (_this.licenseObject ? _this.licenseObject.id : Date.now());
            _this.issueDPid = 'issue-dp-' + (_this.licenseObject ? _this.licenseObject.id : Date.now());
            $timeout(function () {
                angular.element('#' + _this.expDPid).daterangepicker(_this.options, _this.callback.bind(_this, 'expirationDate'));
                angular.element('#' + _this.issueDPid).daterangepicker(Object.assign({ maxDate: new Date() }, _this.options), _this.callback.bind(_this, 'issueDate'));
            });
        };

        this.remove = function () {
            if (!_this.licenseObject) {
                return _this.onRemove(null);
            }
            loader.show();
            professionalService.deleteBriefcaseItem(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, 'licenses', _this.licenseObject.id).then(function () {
                $scope.$emit('updateProfile');
                _this.onRemove(_this.licenseObject);
                toastr.success('The license was removed');
            }).catch(function (e) {
                return toastr.error(e.message);
            }).finally(function () {
                return loader.hide();
            });
        };

        function parseLicense(lic) {
            var newLic = angular.copy(lic);
            if (newLic.expirationDate) {
                newLic.expirationDate = convertFromUTC(newLic.expirationDate);
            }
            if (newLic.issueDate) {
                newLic.issueDate = convertFromUTC(newLic.issueDate);
            }
            return newLic;
        }

        function convertFromUTC(input) {
            if (!input) return null;

            var localMoment = void 0;
            if (typeof input === 'number') {
                localMoment = moment.utc(input).local();
            } else {
                localMoment = moment.utc(new Date(input)).local();
            }

            return typeof input === 'number' ? localMoment.valueOf() : localMoment.format();
        }

        this.hasChanges = function () {
            var ch = !_this.licenseObject || !angular.equals(parseLicense(_this.license), parseLicense(_this.licenseObject));
            $scope.$emit('licenseHasChanges', _this.licenseObject, ch, _this.license);
            return ch;
        };

        this.resetDetails = function (form) {
            _this.license.isCompact = false;
            if (_this.types) {
                var licenseType = _this.types.find(function (type) {
                    return type.abbr === _this.license.licenseType;
                });
                _this.detailsRequired = licenseType && licenseType.detailsRequired;
            }
            form.$setSubmitted();
        };

        this.openDatePicker = function (el) {
            angular.element('#' + el).triggerHandler('click');
        };

        this.submit = function (form) {
            if (form.$valid) {
                loader.show();
                var fn = _this.licenseObject ? professionalService.updateBriefcaseItem.bind(professionalService) : professionalService.addBriefcaseItem.bind(professionalService);
                _this.license.fileUrl = undefined;
                _this.license.uploadedAt = undefined;
                _this.license.downloadUrl = undefined;
                _this.license.psvLicenseUrl = undefined;
                _this.license.psvLicenseDownloadUrl = undefined;
                fn(briefcaseConstants.ACCESS_TOKEN, briefcaseService.briefcase.id, 'licenses', _this.license).then(function (updatedLicense) {
                    $scope.$emit('updateProfile');
                    toastr.success('The license saved successfully');
                    _this.license = angular.merge(updatedLicense, _this.license);
                    _this.licenseObject = angular.copy(_this.license);
                    _this.onSave(_this.licenseObject);
                }).catch(function (e) {
                    return toastr.error(e.message);
                }).finally(function () {
                    return loader.hide();
                });
            }
        };
    };
    angular.module('praos.briefcase').component('license', {
        templateUrl: 'license/license-single.html',
        bindings: {
            licenseObject: '<',
            onRemove: '=',
            onSave: '=',
            types: '<',
            states: '<',
            detailsRequired: '<'
        },
        controller: ['briefcaseService', 'dropDownConstant', 'briefcaseConstants', 'professionalService', 'loader', 'toastr', '$timeout', '$scope', controller]
    });
})();
